import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export enum AccountClosureReasonEnum {
  CardLinkingIssues = 'CARD_LINKING_ISSUES',
  DeniedAtmInstantCash = 'DENIED_ATM_INSTANT_CASH',
  InstantCashApprovalNotEnough = 'INSTANT_CASH_APPROVAL_NOT_ENOUGH',
  NotEnoughRewardOpportunities = 'NOT_ENOUGH_REWARD_OPPORTUNITIES',
  NoRealPersonHelp = 'NO_REAL_PERSON_HELP',
  Other = 'OTHER',
  PlatformFeeTooHigh = 'PLATFORM_FEE_TOO_HIGH',
  PreferAnotherApp = 'PREFER_ANOTHER_APP',
  TechnicalIssues = 'TECHNICAL_ISSUES',
  TooManyMessages = 'TOO_MANY_MESSAGES'
}

export type AccountDoesNotMatchError = ErrorInterface & {
  __typename?: 'AccountDoesNotMatchError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type AccountNotFoundError = ErrorInterface & {
  __typename?: 'AccountNotFoundError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type AccountPerformance = {
  __typename?: 'AccountPerformance';
  /** Calculated total portfolio Rate of Return, including rewards (scale 0-100) */
  moneyWeightedRor: Scalars['Float']['output'];
  performance: Array<Performance>;
};

export type AccountTask = {
  __typename?: 'AccountTask';
  currentCompletions: Scalars['Int']['output'];
  deepLink: Scalars['String']['output'];
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  instruction?: Maybe<Scalars['String']['output']>;
  targetCompletions: Scalars['Int']['output'];
};

export type AccountTaskList = {
  __typename?: 'AccountTaskList';
  accountTaskList: Scalars['String']['output'];
  accountTasks?: Maybe<Array<AccountTask>>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for AccountTaskList. */
export type AccountTaskListConnection = {
  __typename?: 'AccountTaskListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountTaskListEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AccountTaskList>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AccountTaskListEdge = {
  __typename?: 'AccountTaskListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccountTaskList>;
};

export type AccountTypeError = ErrorInterface & {
  __typename?: 'AccountTypeError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export enum ActionChoiceEnum {
  /** Later */
  Later = 'LATER',
  /** No */
  No = 'NO',
  /** Yes */
  Yes = 'YES'
}

/** Active A/B test experiments for a user. */
export type ActiveExperiment = {
  __typename?: 'ActiveExperiment';
  /** Additional details about the variant */
  details?: Maybe<Scalars['JSON']['output']>;
  /** The name of the A/B test */
  testName: Scalars['String']['output'];
  /** The variant a user belongs to */
  variant?: Maybe<Scalars['String']['output']>;
};

export type AdAttributesInput = {
  htmlAd?: InputMaybe<HtmlAdInput>;
};

export enum AdMraidVersionEnum {
  /** mraid 2.0 */
  Mraid2 = 'MRAID2',
  /** mraid 3.0 */
  Mraid3 = 'MRAID3'
}

export enum AdSupportedSizeEnum {
  /** 3:4 */
  LandscapeInterstitial = 'LANDSCAPE_INTERSTITIAL',
  /** 4:3 */
  PortraitInterstitial = 'PORTRAIT_INTERSTITIAL'
}

export enum AdTypeEnum {
  HtmlAd = 'HTML_AD',
  NativeAd = 'NATIVE_AD',
  VastAd = 'VAST_AD'
}

export type AdUnion = HtmlAd | NativeAd;

/** The connection type for AdUnion. */
export type AdUnionConnection = {
  __typename?: 'AdUnionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AdUnionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AdUnion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AdUnionEdge = {
  __typename?: 'AdUnionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AdUnion>;
};

export type AddonInstrument = {
  __typename?: 'AddonInstrument';
  fundamentals: InstrumentFundamentals;
  inactive: Scalars['Boolean']['output'];
  labels: Array<InstrumentLabel>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  administrativeArea?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type AddressError = Error;

/** Autogenerated input type of Address */
export type AddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userAddress: UserAddress;
};

/** Autogenerated return type of Address */
export type AddressPayload = {
  __typename?: 'AddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<AddressError>>;
};

export type AddressVerificationError = ErrorInterface & {
  __typename?: 'AddressVerificationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export enum AdjoeCategoryEnum {
  /** Both gaming and non-gaming apps */
  Both = 'BOTH',
  /** Gaming apps only */
  Gaming = 'GAMING',
  /** Non-gaming apps only */
  NonGaming = 'NON_GAMING'
}

export type AdjoeOffer = {
  __typename?: 'AdjoeOffer';
  alreadyClicked: Scalars['Boolean']['output'];
  appId: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  coins: Scalars['Int']['output'];
  cpi: Scalars['Float']['output'];
  ecpm: Scalars['Float']['output'];
  isRecommended: Scalars['Boolean']['output'];
  placementPosition?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Float']['output'];
  token: Scalars['String']['output'];
};

export enum AdjoeOfferSortFieldEnum {
  /** Sort by coin reward */
  Coins = 'COINS',
  /** Sort by cost per install */
  Cpi = 'CPI',
  /** Sort by effective CPM */
  Ecpm = 'ECPM',
  /** Sort by Adjoe score (default) */
  Score = 'SCORE'
}

export type AdjoePromotion = {
  __typename?: 'AdjoePromotion';
  endsAt?: Maybe<Scalars['String']['output']>;
  installLimit?: Maybe<Scalars['Int']['output']>;
  multiplier: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  promotionTag: Scalars['String']['output'];
  startsAt?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type AggregatedAddonInstrument = {
  __typename?: 'AggregatedAddonInstrument';
  addonInstrument: AddonInstrument;
  equityPosition?: Maybe<EquityPosition>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  status: AggregatedAddonInstrumentStatusEnum;
  unrealizedDayPL?: Maybe<Scalars['Float']['output']>;
  unrealizedDayPLPercent?: Maybe<Scalars['Float']['output']>;
  unrealizedPL?: Maybe<Scalars['Float']['output']>;
  unrealizedPLPercent?: Maybe<Scalars['Float']['output']>;
};

export enum AggregatedAddonInstrumentStatusEnum {
  /** Owned */
  Owned = 'OWNED',
  /** Pending Buy */
  PendingBuy = 'PENDING_BUY',
  /** Pending Sell */
  PendingSell = 'PENDING_SELL'
}

export type AggregatedCorePortfolio = {
  __typename?: 'AggregatedCorePortfolio';
  equityPositions: Array<EquityPosition>;
  marketValue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  status: AggregatedCorePortfolioStatusEnum;
  unrealizedDayPL: Scalars['Float']['output'];
  unrealizedDayPLPercent: Scalars['Float']['output'];
  unrealizedPL: Scalars['Float']['output'];
  unrealizedPLPercent: Scalars['Float']['output'];
};

export enum AggregatedCorePortfolioStatusEnum {
  /** Owned */
  Owned = 'OWNED',
  /** Partial Owned */
  PartialOwned = 'PARTIAL_OWNED',
  /** Pending Buy */
  PendingBuy = 'PENDING_BUY'
}

export type AnswerQuestionError = Error;

/** Autogenerated input type of AnswerQuestion */
export type AnswerQuestionInput = {
  answers?: InputMaybe<Array<QuestionResponse>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  placementName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AnswerQuestion */
export type AnswerQuestionPayload = {
  __typename?: 'AnswerQuestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<AnswerQuestionError>>;
  nextAvailableDataContainer?: Maybe<QuestionContainer>;
  partnerBid?: Maybe<PartnerBid>;
};

export type AppSettings = {
  __typename?: 'AppSettings';
  accountClosureLifetimeEarningsMinimumAmount: Scalars['Float']['output'];
  accountClosurePotentialEarningsLostAmount: Scalars['Float']['output'];
  accountClosureRetentionOfferCategoryIds: Array<Scalars['String']['output']>;
  accountStrengthCardHeaderCopy: Scalars['String']['output'];
  accountStrengthIncentiveCopy: Scalars['String']['output'];
  accountStrengthIncentiveRewardAmount: Scalars['Float']['output'];
  actualPayoutPercentage: Scalars['Float']['output'];
  availableBalanceInfoCopy: Scalars['String']['output'];
  branchEventWhitelist: Array<Scalars['String']['output']>;
  cashAdvanceAchTransferCopy: Scalars['String']['output'];
  cashAdvanceDeclineScreenCategory: Scalars['String']['output'];
  cashAdvanceFirstMonthFee: Scalars['Float']['output'];
  cashAdvanceMaximumAmount: Scalars['Float']['output'];
  cashAdvanceMembershipCopy: Scalars['String']['output'];
  cashAdvanceMinimumAmount: Scalars['Float']['output'];
  cashAdvanceMinimumMonthlyIncome: Scalars['Int']['output'];
  cashAdvanceMonthlyFee: Scalars['Float']['output'];
  /** Two-letter codes of states where cash advance is not offered (matched against the primary address) */
  cashAdvanceRestrictedStates: Array<Scalars['String']['output']>;
  currentTermsOfServiceVersion: Scalars['String']['output'];
  dailyActionListOfferCategory: Scalars['String']['output'];
  dataQuestionZeroStateCategoryId: Scalars['String']['output'];
  depositMaxLimit: Scalars['Int']['output'];
  depositMinLimit: Scalars['Int']['output'];
  gamingHubOfferCategoryId: Scalars['String']['output'];
  gamingHubOfferCategoryIds: Array<Scalars['String']['output']>;
  identityVerificationLink?: Maybe<Scalars['String']['output']>;
  keepAccessEligibleButtonText: Scalars['String']['output'];
  keepAccessEligibleDescription: Scalars['String']['output'];
  keepAccessEligibleDiscountCode: Scalars['String']['output'];
  keepAccessEligibleSplash: Scalars['String']['output'];
  keepAccessEligibleTitle: Scalars['String']['output'];
  keepAccessFinalWarning: Scalars['String']['output'];
  keepAccessFinalWarningTitle: Scalars['String']['output'];
  keepAccessIneligibleButtonText: Scalars['String']['output'];
  keepAccessIneligibleDescription: Scalars['String']['output'];
  keepAccessIneligibleDiscountCode: Scalars['String']['output'];
  keepAccessIneligibleSplash: Scalars['String']['output'];
  keepAccessIneligibleTitle: Scalars['String']['output'];
  lifetimeEarningsInfoCopy: Scalars['String']['output'];
  locationCardHeaderSubtitle: Scalars['String']['output'];
  locationCardHeaderTitle: Scalars['String']['output'];
  locationPayoutAmount: Scalars['Float']['output'];
  pendingBalanceInfoCopy: Scalars['String']['output'];
  premiumSubscriptionPrice: Scalars['Float']['output'];
  receiptScanningPayoutAmount: Scalars['Float']['output'];
  rpCategoryPaginationAmount: Scalars['Int']['output'];
  rpHomeTagCopy: Scalars['String']['output'];
  rpOfferDetailVerticalRewards: Scalars['Boolean']['output'];
  rpSearchPlaceholderCopy: Scalars['String']['output'];
  searchZeroStateCategoryId: Scalars['String']['output'];
  sessionInactivityPeriod: Scalars['Int']['output'];
  supportUrl: Scalars['String']['output'];
  surveyProviders: Array<SurveyProvider>;
  tabapayRsaKey: Scalars['String']['output'];
  tabapayRsaKeyId: Scalars['String']['output'];
  tutorialHighlightedRpCategoryId: Scalars['String']['output'];
  tutorialHighlightedRpTagId: Scalars['String']['output'];
  unifiedLogin: Scalars['Boolean']['output'];
  unifiedLoginAndroid: Scalars['Boolean']['output'];
  withdrawalIncrement: Scalars['Float']['output'];
  withdrawalMaxLimit: Scalars['Int']['output'];
  /** @deprecated Use available_balance_info_copy instead */
  withdrawalMinBalanceCopy: Scalars['String']['output'];
  withdrawalMinLimit: Scalars['Int']['output'];
};

export type ApplicationNotCancellableError = ErrorInterface & {
  __typename?: 'ApplicationNotCancellableError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type AssignAddonError = Error;

/** Autogenerated input type of AssignAddon */
export type AssignAddonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  investmentAccountId: Scalars['ID']['input'];
  symbol: Scalars['String']['input'];
};

/** Autogenerated return type of AssignAddon */
export type AssignAddonPayload = {
  __typename?: 'AssignAddonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<AssignAddonError>>;
  investmentAccount?: Maybe<InvestmentAccount>;
};

export type AssignBankAccountToCashAdvanceApplicationError = Error;

/** Autogenerated input type of AssignBankAccountToCashAdvanceApplication */
export type AssignBankAccountToCashAdvanceApplicationInput = {
  bankAccountId: Scalars['ID']['input'];
  cashAdvanceApplicationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AssignBankAccountToCashAdvanceApplication */
export type AssignBankAccountToCashAdvanceApplicationPayload = {
  __typename?: 'AssignBankAccountToCashAdvanceApplicationPayload';
  cashAdvanceApplication?: Maybe<CashAdvanceApplication>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<AssignBankAccountToCashAdvanceApplicationError>>;
};

export type AtmSubscriptionFee = Transaction & {
  __typename?: 'AtmSubscriptionFee';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type AtmSubscriptionFeePayment = Transaction & {
  __typename?: 'AtmSubscriptionFeePayment';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Attempt = {
  __typename?: 'Attempt';
  createdAt: Scalars['ISO8601DateTime']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  platform?: Maybe<Scalars['String']['output']>;
  reason: AccountClosureReasonEnum;
};

export type Authentication = {
  __typename?: 'Authentication';
  accessToken: Scalars['String']['output'];
  accessTokenExpiresAt: Scalars['ISO8601DateTime']['output'];
  refreshToken: Scalars['String']['output'];
  refreshTokenExpiresAt: Scalars['ISO8601DateTime']['output'];
  sessionExpiresAt: Scalars['ISO8601DateTime']['output'];
};

export type AvailableFeatures = {
  __typename?: 'AvailableFeatures';
  cashAdvanceRequest: Scalars['Boolean']['output'];
  pfmAdditionalAccounts: Scalars['Boolean']['output'];
  pfmBase: Scalars['Boolean']['output'];
  pfmCustomCategories: Scalars['Boolean']['output'];
  pfmExports: Scalars['Boolean']['output'];
  pfmRefreshTransactions: Scalars['Boolean']['output'];
};

export type BadRequest = ErrorInterface & {
  __typename?: 'BadRequest';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type Balance = {
  __typename?: 'Balance';
  available?: Maybe<Scalars['String']['output']>;
  availableToWithdraw?: Maybe<Scalars['String']['output']>;
  cashTotal?: Maybe<Scalars['String']['output']>;
  cumulativeEarned?: Maybe<Scalars['String']['output']>;
  cumulativeEarnedPast30Days?: Maybe<Scalars['String']['output']>;
  pending?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};

export type BalanceCalendar = {
  __typename?: 'BalanceCalendar';
  asOfDate: Scalars['ISO8601Date']['output'];
  days: Array<BalanceCalendarDay>;
};

export type BalanceCalendarDay = {
  __typename?: 'BalanceCalendarDay';
  date: Scalars['ISO8601Date']['output'];
  level: BalanceCalendarLevel;
};

export enum BalanceCalendarLevel {
  /** Meaningful chance of being below $0 */
  Amber = 'AMBER',
  /** Unlikely to be below $0 */
  Clear = 'CLEAR',
  /** More likely than not to be below $0 */
  Red = 'RED'
}

export type BankAccount = {
  __typename?: 'BankAccount';
  allowDeposit?: Maybe<Scalars['Boolean']['output']>;
  allowWithdrawal?: Maybe<Scalars['Boolean']['output']>;
  /** The linked bank's last synced balance, or null when we have no balance for it */
  balance?: Maybe<Scalars['Float']['output']>;
  /** When the balance was last refreshed from the bank */
  balanceLastUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cardlyticsHasOffers: Scalars['Boolean']['output'];
  cardlyticsLinked: Scalars['Boolean']['output'];
  cardlyticsLinkedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cashAdvanceUsable?: Maybe<CashAdvanceUsableStatus>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  displayAccountNumber?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  gatewayWithdrawalFee?: Maybe<Scalars['String']['output']>;
  /** A problem the user should resolve, or null when healthy */
  health?: Maybe<BankAccountHealthEnum>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  relinkable: Scalars['Boolean']['output'];
  requireReauth?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<BankAccountStatusEnum>;
  transferMethod?: Maybe<Scalars['String']['output']>;
};

export enum BankAccountHealthEnum {
  /** Card expiration date has passed */
  Expired = 'EXPIRED',
  /** Card expiration date is approaching */
  ExpiringSoon = 'EXPIRING_SOON',
  /** Card is inoperable and cannot be used */
  Inop = 'INOP',
  /** Account needs to be re-authenticated */
  RequireReauth = 'REQUIRE_REAUTH',
  /** Account link is permanently broken and must be re-linked from scratch */
  Unrepairable = 'UNREPAIRABLE'
}

export enum BankAccountStatusEnum {
  /** Linked */
  Linked = 'LINKED',
  /** Pending Verification */
  PendingVerification = 'PENDING_VERIFICATION',
  /** Unlinked */
  Unlinked = 'UNLINKED',
  /** Unlinking */
  Unlinking = 'UNLINKING'
}

export type BankAccountTransaction = {
  __typename?: 'BankAccountTransaction';
  amount: Scalars['Float']['output'];
  bankAccountId: Scalars['ID']['output'];
  date: Scalars['ISO8601Date']['output'];
  deleted: Scalars['Boolean']['output'];
  detailedCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalDescription?: Maybe<Scalars['String']['output']>;
  pending: Scalars['Boolean']['output'];
  primaryCategory?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export enum BankAccountTransactionSort {
  /** Amount Ascending */
  AmountAsc = 'AMOUNT_ASC',
  /** Amount Descending */
  AmountDesc = 'AMOUNT_DESC',
  /** Date Ascending */
  DateAsc = 'DATE_ASC',
  /** Date Descending */
  DateDesc = 'DATE_DESC'
}

export type BarData = {
  __typename?: 'BarData';
  close: Scalars['String']['output'];
  high: Scalars['String']['output'];
  low: Scalars['String']['output'];
  open: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  volume: Scalars['String']['output'];
};

export type BaseAd = {
  /** The specific type of ad. */
  adType: AdTypeEnum;
  id: Scalars['ID']['output'];
  /** The Served Impression ID that was served to the user. */
  servedImpressionId: Scalars['ID']['output'];
};

export type BasePartnerOffer = {
  /** The card description for an offer */
  cardDescription?: Maybe<Scalars['String']['output']>;
  /** The card headline for an offer */
  cardHeadline?: Maybe<Scalars['String']['output']>;
  /** The call to action of an offer */
  cta?: Maybe<Scalars['String']['output']>;
  /** The click url for a user offer */
  ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum;
  /** The click url for a user offer */
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Details about an offer */
  description?: Maybe<Scalars['String']['output']>;
  /** Legal notice related an offer in Markdown syntax. Normally includes Terms and Conditions */
  disclosure?: Maybe<Scalars['String']['output']>;
  /**
   * The click url for a user offer
   * @deprecated Prefer cta_click_behavior instead
   */
  externalCtaUrl: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The response the user made for this offer */
  myResponse?: Maybe<UserPartnerBidResponse>;
  /** The type of offer */
  offerType: PartnerOfferTypeEnum;
  /** The partner for an offer */
  partner: Partner;
  /** The potential reward for this offer that can be earned. */
  potentialRewardTotal?: Maybe<PartnerOfferPotentialRewardTotal>;
  /** The savings amount for this offer */
  savingsAmount?: Maybe<Scalars['String']['output']>;
  /** The Served Impression ID that was served to the user. */
  servedImpressionId: Scalars['ID']['output'];
  /** Whether or not to skip the offer details page */
  skipOfferDetails: Scalars['Boolean']['output'];
  /** The url linking to the terms and conditions for an offer */
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BatchPublishClientEvents */
export type BatchPublishClientEventsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  events: Array<ClientEventInput>;
};

/** Autogenerated return type of BatchPublishClientEvents */
export type BatchPublishClientEventsPayload = {
  __typename?: 'BatchPublishClientEventsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ClientEventUnionErrors>>;
  /** The Request IDS that were successfully published */
  eventIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type BidResponseError = Error;

export type BlockedInstitutionError = ErrorInterface & {
  __typename?: 'BlockedInstitutionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type BonusTask = {
  __typename?: 'BonusTask';
  completionCriteria?: Maybe<CompletionCriteria>;
  currentCompletions: Scalars['Int']['output'];
  deepLink: Scalars['String']['output'];
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  instruction?: Maybe<Scalars['String']['output']>;
  targetCompletions: Scalars['Int']['output'];
};

export type BonusTaskList = {
  __typename?: 'BonusTaskList';
  bonusTaskList?: Maybe<Scalars['String']['output']>;
  bonusTasks?: Maybe<Array<BonusTask>>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rewardAmount?: Maybe<Scalars['Float']['output']>;
};

export type Budget = {
  __typename?: 'Budget';
  amount: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  inactiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  month: Scalars['ISO8601Date']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type BudgetNotFoundError = ErrorInterface & {
  __typename?: 'BudgetNotFoundError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type Button = {
  __typename?: 'Button';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CvvVerificationError = ErrorInterface & {
  __typename?: 'CVVVerificationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type CalculatedFee = {
  __typename?: 'CalculatedFee';
  amount: Scalars['Float']['output'];
  baseAmount: Scalars['Float']['output'];
  calculatedFeeDiscounts: Array<CalculatedFeeDiscount>;
};

export type CalculatedFeeDiscount = {
  __typename?: 'CalculatedFeeDiscount';
  amount: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subscriptionDiscountId: Scalars['ID']['output'];
};

export type CalibrateBudgetsErrors = Error | GenericCalibrationError;

/** Autogenerated input type of CalibrateBudgets */
export type CalibrateBudgetsInput = {
  clearCurrentMonth?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CalibrateBudgets */
export type CalibrateBudgetsPayload = {
  __typename?: 'CalibrateBudgetsPayload';
  budgets?: Maybe<Array<Budget>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CalibrateBudgetsErrors>>;
};

export type CancelCashAdvanceApplicationError = ApplicationNotCancellableError | Error | NoCashAdvanceApplicationError;

/** Autogenerated input type of CancelCashAdvanceApplication */
export type CancelCashAdvanceApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CancelCashAdvanceApplication */
export type CancelCashAdvanceApplicationPayload = {
  __typename?: 'CancelCashAdvanceApplicationPayload';
  cashAdvanceApplication?: Maybe<CashAdvanceApplication>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CancelCashAdvanceApplicationError>>;
};

export type CardDeclinedError = ErrorInterface & {
  __typename?: 'CardDeclinedError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type CardHolderNameVerificationError = ErrorInterface & {
  __typename?: 'CardHolderNameVerificationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type CardInBackoffError = ErrorInterface & {
  __typename?: 'CardInBackoffError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type CashAdvance = Transaction & {
  __typename?: 'CashAdvance';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CashAdvanceApplication = {
  __typename?: 'CashAdvanceApplication';
  bankAccount?: Maybe<BankAccount>;
  cashAdvanceEvaluation?: Maybe<CashAdvanceEvaluation>;
  /** When this application qualified for first_caa_approved; clients fire the event once from it */
  firstCaaApprovedEventAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When this application qualified for first_caa_hq; clients fire the event once from it */
  firstCaaHqEventAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  pendingMessage?: Maybe<Scalars['String']['output']>;
  plaidSyncInDarkHours: Scalars['Boolean']['output'];
  rejectionDetails?: Maybe<Array<Scalars['String']['output']>>;
  status: CashAdvanceApplicationStatus;
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum CashAdvanceApplicationStatus {
  /** The user has been approved for a cash advance, and a subscription has been created */
  Approved = 'APPROVED',
  /** The cash advance application has been cancelled. The user can re-apply */
  Cancelled = 'CANCELLED',
  /** The cash advance application has been cancelled, and the user is not allowed to reapply */
  CancelledNoReapply = 'CANCELLED_NO_REAPPLY',
  /** The cash advance application is in progress */
  InProgress = 'IN_PROGRESS',
  /** The user has been rejected for a cash advance. Details are available in the rejectionDetails field */
  Rejected = 'REJECTED',
  /** The user must repay an existing cash advance before applying for a new one */
  RepayOnly = 'REPAY_ONLY',
  /** The cash advance application has been submitted and is pending evaluation */
  Submitted = 'SUBMITTED'
}

export type CashAdvanceApprovedAmount = {
  __typename?: 'CashAdvanceApprovedAmount';
  amount?: Maybe<Scalars['String']['output']>;
  approvedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Reasons why a user might not be eligible for a cash advance */
  eligibilityFailures: Array<EligibilityFailureReasonEnum>;
  /** Detailed messages explaining why a user might not be eligible */
  rejectionMessages: Array<Scalars['String']['output']>;
};

export type CashAdvanceEvaluation = {
  __typename?: 'CashAdvanceEvaluation';
  allowedAmount?: Maybe<Scalars['Float']['output']>;
  candidateShadowModelVersions: Array<Scalars['String']['output']>;
  /** Reasons why a user might not be eligible for a cash advance */
  eligibilityFailures: Array<EligibilityFailureReasonEnum>;
  id: Scalars['ID']['output'];
  modelVersion?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  /** Detailed messages explaining why a user might not be eligible */
  rejectionMessages: Array<Scalars['String']['output']>;
};

export type CashAdvanceFee = {
  __typename?: 'CashAdvanceFee';
  amount: Scalars['String']['output'];
  feeType: CashAdvanceFeeType;
  id: Scalars['ID']['output'];
};

export type CashAdvanceFeeSchedule = {
  __typename?: 'CashAdvanceFeeSchedule';
  amount: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum CashAdvanceFeeType {
  /** Tip */
  Tip = 'TIP',
  /** Transfer fee */
  TransferFee = 'TRANSFER_FEE'
}

export type CashAdvanceRepayment = Transaction & {
  __typename?: 'CashAdvanceRepayment';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum CashAdvanceRepaymentTransferType {
  /** Instant transfer. Within minutes */
  Asap = 'ASAP',
  /** Transfer from rewards balance */
  Rewards = 'REWARDS'
}

export type CashAdvanceRequest = {
  __typename?: 'CashAdvanceRequest';
  amount: Scalars['String']['output'];
  amountNeededToRepay?: Maybe<Scalars['String']['output']>;
  /** The total amount of the outstanding advance that has been repaid using rewards */
  amountRepaidViaRewards: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the cash advance is expected to be repaid. Only nullable for quotes */
  expectedRepaymentDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fees: Array<CashAdvanceFee>;
  id: Scalars['ID']['output'];
  /** True if there are currently any active payments for this request */
  inFlightPayment: Scalars['Boolean']['output'];
  repaymentAmount: Scalars['String']['output'];
  status: CashAdvanceRequestStatus;
  transferType: CashAdvanceRequestTransferType;
};

export enum CashAdvanceRequestStatus {
  /** Approved */
  Approved = 'APPROVED',
  /** Charge Back */
  ChargeBack = 'CHARGE_BACK',
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Quote */
  Quote = 'QUOTE',
  /** Completed */
  Rejected = 'REJECTED',
  /** Repaid */
  Repaid = 'REPAID',
  /** Repayment Submitted */
  RepaymentSubmittedToFinsys = 'REPAYMENT_SUBMITTED_TO_FINSYS',
  /** Settled */
  Settled = 'SETTLED',
  /** Submitted */
  SubmittedToFinsys = 'SUBMITTED_TO_FINSYS',
  /** Submission Status Pending */
  SubmittedToFinsysUnknown = 'SUBMITTED_TO_FINSYS_UNKNOWN'
}

export enum CashAdvanceRequestTransferType {
  /** ACH transfer. 3-5 Business days */
  Ach = 'ACH',
  /** Instant transfer. Within minutes */
  Asap = 'ASAP'
}

export type CashAdvanceSubscription = {
  __typename?: 'CashAdvanceSubscription';
  activeAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  initialFeeChargedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextFeeChargedAt: Scalars['ISO8601DateTime']['output'];
  status: CashAdvanceSubscriptionStatus;
};

export enum CashAdvanceSubscriptionStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Inactive */
  Inactive = 'INACTIVE',
  /** Past Due */
  PastDue = 'PAST_DUE',
  /** Trial */
  Trial = 'TRIAL'
}

export type CashAdvanceTip = Transaction & {
  __typename?: 'CashAdvanceTip';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CashAdvanceTransferFee = Transaction & {
  __typename?: 'CashAdvanceTransferFee';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum CashAdvanceUsableStatus {
  /** Institution is blocked */
  InstitutionBlocked = 'INSTITUTION_BLOCKED',
  /** Account is usable for cash advance */
  Ok = 'OK',
  /** Plaid item has a pending disconnect */
  PendingDisconnect = 'PENDING_DISCONNECT',
  /** Plaid item is in an error state */
  PlaidItemError = 'PLAID_ITEM_ERROR',
  /** Plaid item requires re-authentication */
  RequireReauth = 'REQUIRE_REAUTH',
  /** Plaid item is in an unrepairable state */
  Unrepairable = 'UNREPAIRABLE'
}

export type Category = {
  __typename?: 'Category';
  name: Scalars['String']['output'];
};

export enum CategoryDetailDisplayStyleEnum {
  /** This is the featured style */
  Banner = 'BANNER',
  /** Card with gradient background overlay */
  BannerCardGradient = 'BANNER_CARD_GRADIENT',
  /** Card with gradient background overlay oriented vertically */
  BannerCardGradientVertical = 'BANNER_CARD_GRADIENT_VERTICAL',
  /** Card with split background */
  BannerCardSplit = 'BANNER_CARD_SPLIT',
  /** Card with split background oriented vertically */
  BannerCardSplitVertical = 'BANNER_CARD_SPLIT_VERTICAL',
  /** This is the larger featured style */
  BannerLarge = 'BANNER_LARGE',
  /** This is the larger featured style oriented vertically */
  BannerLargeVertical = 'BANNER_LARGE_VERTICAL',
  /** The basic tile style with a clear background */
  BasicClear = 'BASIC_CLEAR',
  /** The wide basic tile style with a clear background */
  BasicClearLarge = 'BASIC_CLEAR_LARGE',
  /** The wide basic tile style with a clear background oriented vertically */
  BasicClearLargeVertical = 'BASIC_CLEAR_LARGE_VERTICAL',
  /** The semi-wide basic tile style with a clear background double stacked */
  BasicClearMediumDouble = 'BASIC_CLEAR_MEDIUM_DOUBLE',
  /** The semi-wide basic tile style with a clear background triple stacked */
  BasicClearMediumTriple = 'BASIC_CLEAR_MEDIUM_TRIPLE',
  /** The semi-wide basic tile style with a clear background */
  BasicClearMeium = 'BASIC_CLEAR_MEIUM',
  /** The basic tile style with a white background */
  BasicWhite = 'BASIC_WHITE',
  /** Grid style which is the existing way to dispaly Your Offers */
  Grid = 'GRID',
  /** Long card showing icon, name, and amount oriented vertically */
  IconNameAmountLongVertical = 'ICON_NAME_AMOUNT_LONG_VERTICAL'
}

export enum CategoryFeaturedDisplayStyleEnum {
  /** This is the featured style */
  Banner = 'BANNER',
  /** Card with gradient background overlay */
  BannerCardGradient = 'BANNER_CARD_GRADIENT',
  /** Card with gradient background overlay oriented vertically */
  BannerCardGradientVertical = 'BANNER_CARD_GRADIENT_VERTICAL',
  /** Card with split background */
  BannerCardSplit = 'BANNER_CARD_SPLIT',
  /** Card with split background oriented vertically */
  BannerCardSplitVertical = 'BANNER_CARD_SPLIT_VERTICAL',
  /** This is the larger featured style */
  BannerLarge = 'BANNER_LARGE',
  /** This is the larger featured style oriented vertically */
  BannerLargeVertical = 'BANNER_LARGE_VERTICAL',
  /** The basic tile style with a clear background */
  BasicClear = 'BASIC_CLEAR',
  /** The wide basic tile style with a clear background */
  BasicClearLarge = 'BASIC_CLEAR_LARGE',
  /** The wide basic tile style with a clear background oriented vertically */
  BasicClearLargeVertical = 'BASIC_CLEAR_LARGE_VERTICAL',
  /** The semi-wide basic tile style with a clear background double stacked */
  BasicClearMediumDouble = 'BASIC_CLEAR_MEDIUM_DOUBLE',
  /** The semi-wide basic tile style with a clear background triple stacked */
  BasicClearMediumTriple = 'BASIC_CLEAR_MEDIUM_TRIPLE',
  /** The semi-wide basic tile style with a clear background */
  BasicClearMeium = 'BASIC_CLEAR_MEIUM',
  /** The basic tile style with a white background */
  BasicWhite = 'BASIC_WHITE',
  /** Grid style which is the existing way to dispaly Your Offers */
  Grid = 'GRID',
  /** Long card showing icon, name, and amount oriented vertically */
  IconNameAmountLongVertical = 'ICON_NAME_AMOUNT_LONG_VERTICAL'
}

export enum CategoryMainDisplayStyleEnum {
  /** This is the featured style */
  Banner = 'BANNER',
  /** Card with gradient background overlay */
  BannerCardGradient = 'BANNER_CARD_GRADIENT',
  /** Card with gradient background overlay oriented vertically */
  BannerCardGradientVertical = 'BANNER_CARD_GRADIENT_VERTICAL',
  /** Card with split background */
  BannerCardSplit = 'BANNER_CARD_SPLIT',
  /** Card with split background oriented vertically */
  BannerCardSplitVertical = 'BANNER_CARD_SPLIT_VERTICAL',
  /** This is the larger featured style */
  BannerLarge = 'BANNER_LARGE',
  /** This is the larger featured style oriented vertically */
  BannerLargeVertical = 'BANNER_LARGE_VERTICAL',
  /** The basic tile style with a clear background */
  BasicClear = 'BASIC_CLEAR',
  /** The wide basic tile style with a clear background */
  BasicClearLarge = 'BASIC_CLEAR_LARGE',
  /** The wide basic tile style with a clear background oriented vertically */
  BasicClearLargeVertical = 'BASIC_CLEAR_LARGE_VERTICAL',
  /** The semi-wide basic tile style with a clear background double stacked */
  BasicClearMediumDouble = 'BASIC_CLEAR_MEDIUM_DOUBLE',
  /** The semi-wide basic tile style with a clear background triple stacked */
  BasicClearMediumTriple = 'BASIC_CLEAR_MEDIUM_TRIPLE',
  /** The semi-wide basic tile style with a clear background */
  BasicClearMeium = 'BASIC_CLEAR_MEIUM',
  /** The basic tile style with a white background */
  BasicWhite = 'BASIC_WHITE',
  /** Grid style which is the existing way to dispaly Your Offers */
  Grid = 'GRID',
  /** Long card showing icon, name, and amount oriented vertically */
  IconNameAmountLongVertical = 'ICON_NAME_AMOUNT_LONG_VERTICAL'
}

export type ChangeBankAccountErrors = BlockedInstitutionError | Error | LinkBlockedError | LinkedAccountConflictError | LinkedOverLimitError | MaxAccountChangesReachedError | NoBankAccountError | NoValidPaymentAccountError | SameBankAccountError | UnknownError | UsedForCashAdvanceApplicationError | WithdrawalInProgressError;

/** Autogenerated input type of ChangeBankAccount */
export type ChangeBankAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: Provider;
};

/** Autogenerated return type of ChangeBankAccount */
export type ChangeBankAccountPayload = {
  __typename?: 'ChangeBankAccountPayload';
  bankAccount?: Maybe<BankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ChangeBankAccountErrors>>;
};

export type ChatUser = {
  __typename?: 'ChatUser';
  identity?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type ChatkitSession = {
  __typename?: 'ChatkitSession';
  clientSecret: Scalars['String']['output'];
};

export type CheckIdentifierResult = {
  __typename?: 'CheckIdentifierResult';
  /** sign_in, sign_up, link_required, or error */
  action: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type Chip = {
  __typename?: 'Chip';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ClientEvent = {
  __typename?: 'ClientEvent';
  data?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  partnerId?: Maybe<Scalars['ID']['output']>;
  partnerOfferId?: Maybe<Scalars['ID']['output']>;
  requestId: Scalars['ID']['output'];
  servedImpressionId?: Maybe<Scalars['ID']['output']>;
};

export type ClientEventError = {
  __typename?: 'ClientEventError';
  errors?: Maybe<Array<Error>>;
  event: ClientEvent;
};

export type ClientEventInput = {
  adId?: InputMaybe<Scalars['ID']['input']>;
  adType?: InputMaybe<AdTypeEnum>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Unix epoch (seconds) for when this event actually occurred on the client. When provided it becomes the event's `ets`. When omitted, `ets` preserves the existing behavior: the per-request X-Event-Timestamp header, then server receipt time. Supplying it per-event allows batched events to each keep their own originating time instead of all sharing the single per-request send-time. */
  eventTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  name: Scalars['String']['input'];
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  partnerOfferId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the request */
  requestId: Scalars['ID']['input'];
  servedImpressionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ClientEventUnionErrors = ClientEventError | Error;

export enum ClientPlatformEnum {
  /** android */
  Android = 'ANDROID',
  /** iOS */
  Ios = 'IOS'
}

export type CommonError = ErrorInterface & {
  __typename?: 'CommonError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type CompletionCriteria = {
  __typename?: 'CompletionCriteria';
  partnerId?: Maybe<Scalars['ID']['output']>;
  partnerOfferId?: Maybe<Scalars['ID']['output']>;
};

export enum CompressionEnum {
  /** Daily */
  Daily = 'daily',
  /** 5 minutes */
  FiveMinutes = 'five_minutes',
  /** 1 hour */
  OneHour = 'one_hour',
  /** 1 minute */
  OneMinute = 'one_minute',
  /** 30 minutes */
  ThirtyMinutes = 'thirty_minutes',
  /** Weekly */
  Weekly = 'weekly'
}

export type ConfirmEmailError = Error;

/** Autogenerated input type of ConfirmEmail */
export type ConfirmEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirmationToken: Scalars['String']['input'];
};

/** Autogenerated return type of ConfirmEmail */
export type ConfirmEmailPayload = {
  __typename?: 'ConfirmEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ConfirmEmailError>>;
};

export type ConfirmPhoneError = Error;

/** Autogenerated input type of ConfirmPhone */
export type ConfirmPhoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirmationToken: Scalars['String']['input'];
};

/** Autogenerated return type of ConfirmPhone */
export type ConfirmPhonePayload = {
  __typename?: 'ConfirmPhonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ConfirmPhoneError>>;
};

export type Conflict = ErrorInterface & {
  __typename?: 'Conflict';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateAccountClosureAttemptError = CreateAccountClosureAttemptValidationError | Error;

/** Autogenerated input type of CreateAccountClosureAttempt */
export type CreateAccountClosureAttemptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional explanation of the selected reason, including other apps used. */
  details?: InputMaybe<Scalars['String']['input']>;
  reason: AccountClosureReasonEnum;
};

/** Autogenerated return type of CreateAccountClosureAttempt */
export type CreateAccountClosureAttemptPayload = {
  __typename?: 'CreateAccountClosureAttemptPayload';
  accountClosureAttempt?: Maybe<Attempt>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateAccountClosureAttemptError>>;
};

export type CreateAccountClosureAttemptValidationError = ErrorInterface & {
  __typename?: 'CreateAccountClosureAttemptValidationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateCardlyticsSessionTokenError = Error;

export type CreateCashAdvanceApplicationError = Error;

/** Autogenerated input type of CreateCashAdvanceApplication */
export type CreateCashAdvanceApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCashAdvanceApplication */
export type CreateCashAdvanceApplicationPayload = {
  __typename?: 'CreateCashAdvanceApplicationPayload';
  cashAdvanceApplication?: Maybe<CashAdvanceApplication>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateCashAdvanceApplicationError>>;
};

export type CreateCashAdvanceRequestError = Error;

/** Autogenerated input type of CreateCashAdvanceRequest */
export type CreateCashAdvanceRequestInput = {
  amount: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tipAmount?: InputMaybe<Scalars['String']['input']>;
  transferType: CashAdvanceRequestTransferType;
};

/** Autogenerated return type of CreateCashAdvanceRequest */
export type CreateCashAdvanceRequestPayload = {
  __typename?: 'CreateCashAdvanceRequestPayload';
  cashAdvanceRequest?: Maybe<CashAdvanceRequest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateCashAdvanceRequestError>>;
};

export type CreateChatTokenError = Error;

/** Autogenerated input type of CreateChatToken */
export type CreateChatTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateChatToken */
export type CreateChatTokenPayload = {
  __typename?: 'CreateChatTokenPayload';
  chatUser?: Maybe<ChatUser>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateChatTokenError>>;
};

export type CreateChatkitSessionError = Error;

export type CreateClosureRequestAlreadyClosingError = ErrorInterface & {
  __typename?: 'CreateClosureRequestAlreadyClosingError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateClosureRequestCashAdvanceRequestNotRepaidError = ErrorInterface & {
  __typename?: 'CreateClosureRequestCashAdvanceRequestNotRepaidError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateClosureRequestError = CreateClosureRequestAlreadyClosingError | CreateClosureRequestCashAdvanceRequestNotRepaidError | CreateClosureRequestUnableToRetrieveAchAccountNumberError | Error;

/** Autogenerated input type of CreateClosureRequest */
export type CreateClosureRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateClosureRequest */
export type CreateClosureRequestPayload = {
  __typename?: 'CreateClosureRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateClosureRequestError>>;
  success: Scalars['Boolean']['output'];
};

export type CreateClosureRequestUnableToRetrieveAchAccountNumberError = ErrorInterface & {
  __typename?: 'CreateClosureRequestUnableToRetrieveACHAccountNumberError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateCtaClickUrlError = Error;

/** Autogenerated input type of CreateCtaClickUrl */
export type CreateCtaClickUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partnerOfferId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCtaClickUrl */
export type CreateCtaClickUrlPayload = {
  __typename?: 'CreateCtaClickUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateCtaClickUrlError>>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateLinkTokenError = Error;

/** Autogenerated return type of CreateLinkToken */
export type CreateLinkTokenPayload = {
  __typename?: 'CreateLinkTokenPayload';
  errors?: Maybe<Array<CreateLinkTokenError>>;
  linkToken?: Maybe<PlaidLinkToken>;
};

export type CreateMissingRewardReportErrors = Error | MissingRewardInvalidInputError | MissingRewardValidationError;

/** Autogenerated input type of CreateMissingRewardReport */
export type CreateMissingRewardReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of the missing reward issue. */
  note: Scalars['String']['input'];
  /** The ID of the partner. */
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the specific partner offer. */
  partnerOfferId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateMissingRewardReport */
export type CreateMissingRewardReportPayload = {
  __typename?: 'CreateMissingRewardReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateMissingRewardReportErrors>>;
  missingRewardReport?: Maybe<MissingRewardReport>;
};

export type CreateOnetimeDepositError = Error;

/** Autogenerated input type of CreateOnetimeDeposit */
export type CreateOnetimeDepositInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  request: OnetimeDeposit;
};

/** Autogenerated return type of CreateOnetimeDeposit */
export type CreateOnetimeDepositPayload = {
  __typename?: 'CreateOnetimeDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateOnetimeDepositError>>;
  transaction?: Maybe<UserOnetimeDeposit>;
};

export type CreatePartnerReviewErrors = Error | InvalidRatingError | NotEligibleError | PartnerNotFoundError | ValidationError;

/** Autogenerated input type of CreatePartnerReview */
export type CreatePartnerReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional comment for the review. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the partner to review. */
  partnerId: Scalars['ID']['input'];
  /** The rating from 1 to 5. */
  rating: Scalars['Int']['input'];
};

/** Autogenerated return type of CreatePartnerReview */
export type CreatePartnerReviewPayload = {
  __typename?: 'CreatePartnerReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreatePartnerReviewErrors>>;
  partnerReview?: Maybe<PartnerReview>;
};

export type CreatePaymentAccountError = AccountTypeError | AddressVerificationError | BadRequest | CvvVerificationError | CardDeclinedError | CardHolderNameVerificationError | CommonError | Conflict | DuplicateCardOtherUserError | DuplicateCardSameUserError | Error | InvalidAddressError | InvalidCardNumberError | InvalidExpirationDateError | MissingCardDataError | MissingUserDataError | PaymentAccountLinkedOverLimitError | PaymentAccountMissingTransferMethodError | RateLimitExceeded;

/** Autogenerated input type of CreatePaymentAccount */
export type CreatePaymentAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tabaPayCard: TabaPayCard;
};

/** Autogenerated return type of CreatePaymentAccount */
export type CreatePaymentAccountPayload = {
  __typename?: 'CreatePaymentAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreatePaymentAccountError>>;
  paymentAccount?: Maybe<BankAccount>;
};

/** Autogenerated input type of CreateSession */
export type CreateSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSession */
export type CreateSessionPayload = {
  __typename?: 'CreateSessionPayload';
  chatkitSession?: Maybe<ChatkitSession>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateChatkitSessionError>>;
};

/** Autogenerated return type of CreateSessionToken */
export type CreateSessionTokenPayload = {
  __typename?: 'CreateSessionTokenPayload';
  errors?: Maybe<Array<CreateCardlyticsSessionTokenError>>;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sessionToken?: Maybe<Scalars['String']['output']>;
};

export type CreateSubscriptionError = Error | ExistingSubscriptionError | NoLinkedCardError | NotSupportedSubscriptionProductError;

/** Autogenerated input type of CreateSubscription */
export type CreateSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  productKey: SubscriptionProductEnum;
};

/** Autogenerated return type of CreateSubscription */
export type CreateSubscriptionPayload = {
  __typename?: 'CreateSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateSubscriptionError>>;
  subscription?: Maybe<Subscription>;
};

export type CreateUpdateLinkTokenError = Error;

/** Autogenerated input type of CreateUpdateLinkToken */
export type CreateUpdateLinkTokenInput = {
  androidNative?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateUpdateLinkToken */
export type CreateUpdateLinkTokenPayload = {
  __typename?: 'CreateUpdateLinkTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateUpdateLinkTokenError>>;
  linkToken?: Maybe<PlaidLinkToken>;
};

export type CreateUserError = Error;

export type CreateUserFeatureOptInError = Error;

/** Autogenerated input type of CreateUserFeatureOptIn */
export type CreateUserFeatureOptInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feature: Scalars['String']['input'];
  optedIn?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateUserFeatureOptIn */
export type CreateUserFeatureOptInPayload = {
  __typename?: 'CreateUserFeatureOptInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateUserFeatureOptInError>>;
  userFeatureOptIn?: Maybe<UserFeatureOptIn>;
};

/** Autogenerated input type of CreateUser */
export type CreateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Phone;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateUser */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  authentication?: Maybe<Authentication>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateUserError>>;
  user: User;
};

/** Input Type for creating a recurring deposit */
export type CreateUserRecurringDeposit = {
  amount: Scalars['String']['input'];
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  depositInterval: DepositIntervalEnum;
};

/** Autogenerated input type of CreateUserRecurringDeposit */
export type CreateUserRecurringDepositInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recurringDeposit: CreateUserRecurringDeposit;
};

/** Autogenerated return type of CreateUserRecurringDeposit */
export type CreateUserRecurringDepositPayload = {
  __typename?: 'CreateUserRecurringDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userRecurringDeposit?: Maybe<UserRecurringDepositConfiguration>;
};

export type CreateWithdrawalError = Error;

/** Autogenerated input type of CreateWithdrawal */
export type CreateWithdrawalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  request: WithdrawalRequest;
};

/** Autogenerated return type of CreateWithdrawal */
export type CreateWithdrawalPayload = {
  __typename?: 'CreateWithdrawalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateWithdrawalError>>;
  transaction?: Maybe<Withdrawal>;
};

export type DailyTask = {
  __typename?: 'DailyTask';
  category: Scalars['String']['output'];
  completed: Scalars['Boolean']['output'];
  completionText: Scalars['String']['output'];
  currentProgress: Scalars['Int']['output'];
  deepLink?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  difficulty: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  targetCompletions: Scalars['Int']['output'];
  taskKey: Scalars['String']['output'];
};

export type DailyTaskList = {
  __typename?: 'DailyTaskList';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedTasksCount: Scalars['Int']['output'];
  completionPercentage: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  selectionStrategy: Scalars['String']['output'];
  taskDate: Scalars['ISO8601Date']['output'];
  tasks: Array<DailyTask>;
  totalTasksCount: Scalars['Int']['output'];
};

export type DataDividend = Transaction & {
  __typename?: 'DataDividend';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Deal = BasePartnerOffer & WithTimestamps & {
  __typename?: 'Deal';
  /** Whether the user can leave a review for this partner. */
  canReview: Scalars['Boolean']['output'];
  /** The card description for an offer */
  cardDescription?: Maybe<Scalars['String']['output']>;
  /** The card headline for an offer */
  cardHeadline?: Maybe<Scalars['String']['output']>;
  /** When the offer was completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The call to action of an offer */
  cta?: Maybe<Scalars['String']['output']>;
  /** The click url for a user offer */
  ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum;
  /** The click url for a user offer */
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Details about an offer */
  description?: Maybe<Scalars['String']['output']>;
  /** Legal notice related an offer in Markdown syntax. Normally includes Terms and Conditions */
  disclosure?: Maybe<Scalars['String']['output']>;
  expectedRewardTimeline?: Maybe<Scalars['String']['output']>;
  /**
   * The click url for a user offer
   * @deprecated Prefer cta_click_behavior instead
   */
  externalCtaUrl: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  myMonetizedProgress?: Maybe<MonetizedProgressConnection>;
  myProgress: PartnerOfferProgressConnection;
  /** The response the user made for this offer */
  myResponse?: Maybe<UserPartnerBidResponse>;
  /** Transactions for the current user related to this offer */
  myTransactions?: Maybe<TransactionConnection>;
  /** The type of offer */
  offerType: PartnerOfferTypeEnum;
  /** The partner for an offer */
  partner: Partner;
  /** The potential reward for this offer that can be earned. */
  potentialRewardTotal?: Maybe<PartnerOfferPotentialRewardTotal>;
  /** The savings amount for this offer */
  savingsAmount?: Maybe<Scalars['String']['output']>;
  /** The Served Impression ID that was served to the user. */
  servedImpressionId: Scalars['ID']['output'];
  /** Whether or not to skip the offer details page */
  skipOfferDetails: Scalars['Boolean']['output'];
  /** The url linking to the terms and conditions for an offer */
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type DealMyMonetizedProgressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DealMyProgressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DealMyTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of DeleteUserRecurringDeposit */
export type DeleteUserRecurringDepositInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteUserRecurringDeposit */
export type DeleteUserRecurringDepositPayload = {
  __typename?: 'DeleteUserRecurringDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userRecurringDeposit?: Maybe<UserRecurringDepositConfiguration>;
};

export enum DepositIntervalEnum {
  /** A monthly deposit interval */
  Monthly = 'MONTHLY',
  /** A weekly deposit interval */
  Weekly = 'WEEKLY'
}

export type DeviceIntegrity = {
  __typename?: 'DeviceIntegrity';
  challengeNonce: Scalars['String']['output'];
  verifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type DuplicateCardOtherUserError = ErrorInterface & {
  __typename?: 'DuplicateCardOtherUserError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type DuplicateCardSameUserError = ErrorInterface & {
  __typename?: 'DuplicateCardSameUserError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Reasons why a user might not be eligible for a cash advance */
export enum EligibilityFailureReasonEnum {
  /** Missing recent income */
  MissingRecentIncome = 'MISSING_RECENT_INCOME',
  /** Account balance is not positive */
  NegativeAccountBalance = 'NEGATIVE_ACCOUNT_BALANCE',
  /** Other eligibility issues */
  Other = 'OTHER',
  /** Subscription is past due */
  SubscriptionPastDue = 'SUBSCRIPTION_PAST_DUE'
}

export enum EmploymentStatusEnum {
  /** Employed */
  Employed = 'EMPLOYED',
  /** Retired */
  Retired = 'RETIRED',
  /** Self Employed / Business Owner */
  SelfEmployed = 'SELF_EMPLOYED',
  /** Student */
  Student = 'STUDENT',
  /** Not Employed */
  Unemployed = 'UNEMPLOYED'
}

export type EquityPosition = {
  __typename?: 'EquityPosition';
  availableForTradingQty: Scalars['Float']['output'];
  avgPrice: Scalars['Float']['output'];
  marketValue: Scalars['Float']['output'];
  mktPrice: Scalars['Float']['output'];
  openQty: Scalars['Float']['output'];
  priorClose: Scalars['Float']['output'];
  side: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  unrealizedDayPL: Scalars['Float']['output'];
  unrealizedDayPLPercent: Scalars['Float']['output'];
  unrealizedPL: Scalars['Float']['output'];
};

export type Error = ErrorInterface & {
  __typename?: 'Error';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type ErrorInterface = {
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type EvaluationAlreadyRunError = ErrorInterface & {
  __typename?: 'EvaluationAlreadyRunError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type ExistingSubscriptionError = ErrorInterface & {
  __typename?: 'ExistingSubscriptionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type FavoritePartnerError = Error;

/** Autogenerated input type of FavoritePartner */
export type FavoritePartnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['ID']['input'];
};

/** Autogenerated return type of FavoritePartner */
export type FavoritePartnerPayload = {
  __typename?: 'FavoritePartnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<FavoritePartnerError>>;
  /** Indicates if the partner was successfully favorited. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FeeAlreadySettledError = ErrorInterface & {
  __typename?: 'FeeAlreadySettledError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type FinancialInsight = {
  __typename?: 'FinancialInsight';
  actionData?: Maybe<Scalars['JSON']['output']>;
  actionedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  dismissedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  emoji: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insightId: Scalars['String']['output'];
  insightType: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  suggestedAction?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['ID']['output'];
};

/** Autogenerated input type of ForgotPassword */
export type ForgotPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Phone>;
};

export type GenericBudgetError = ErrorInterface & {
  __typename?: 'GenericBudgetError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type GenericCalibrationError = ErrorInterface & {
  __typename?: 'GenericCalibrationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type GenericError = ErrorInterface & {
  __typename?: 'GenericError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** A single block on the home screen. Carries the shared presentation "chrome"; concrete implementers add their own content (offers, tags, components). */
export type HomeBlock = {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The cell rendering style for this block */
  cellStyle?: Maybe<HomeBlockCellStyleEnum>;
  /** Wide-screen column hint; null when the placement sets none. Clients map it to breakpoints */
  column?: Maybe<HomeBlockColumnEnum>;
  /** Column count when layout is GRID */
  columns?: Maybe<Scalars['Int']['output']>;
  /** Optional call-to-action label */
  cta?: Maybe<Scalars['String']['output']>;
  /** Optional call-to-action deeplink */
  ctaDeeplink?: Maybe<Scalars['String']['output']>;
  /** The placement id backing this block */
  id: Scalars['ID']['output'];
  /** How the block lays out its contents */
  layout?: Maybe<HomeBlockLayoutEnum>;
  /** The background color of the block contents (legacy layout.backgroundColor) */
  layoutBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The maximum number of items to render in this block */
  maxCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the block shows a "View all" link (legacy showViewAll) */
  showViewAll?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleColor?: Maybe<Scalars['String']['output']>;
};

/** The cell rendering style for a home screen block */
export enum HomeBlockCellStyleEnum {
  /** Banner cell */
  Banner = 'BANNER',
  /** Banner card cell (Android) */
  BannerCard = 'BANNER_CARD',
  /** Gradient banner card cell (Android) */
  BannerCardGradient = 'BANNER_CARD_GRADIENT',
  /** Split banner card cell (Android) */
  BannerCardSplit = 'BANNER_CARD_SPLIT',
  /** Large banner cell */
  BannerLarge = 'BANNER_LARGE',
  /** Basic cell (Android) */
  Basic = 'BASIC',
  /** Large basic cell (Android) */
  BasicLarge = 'BASIC_LARGE',
  /** Standard long card cell */
  BasicLong = 'BASIC_LONG',
  /** Medium basic cell (Android) */
  BasicMedium = 'BASIC_MEDIUM',
  /** Combined card cell */
  CombinedCard = 'COMBINED_CARD',
  /** Combined carousel cell */
  CombinedCarousel = 'COMBINED_CAROUSEL',
  /** Combined feed carousel cell */
  CombinedFeedCarousel = 'COMBINED_FEED_CAROUSEL',
  /** Icon and amount cell */
  IconAmount = 'ICON_AMOUNT',
  /** Icon/image cell */
  IconImage = 'ICON_IMAGE',
  /** Icon, name and amount long cell */
  IconNameAmountLong = 'ICON_NAME_AMOUNT_LONG',
  /** Small icon and amount cell */
  SmallIconAmount = 'SMALL_ICON_AMOUNT',
  /** Small icon and amount card cell */
  SmallIconAmountCard = 'SMALL_ICON_AMOUNT_CARD',
  /** Swipe-dismissable card stack (Android) */
  SwipeDismissableCardStack = 'SWIPE_DISMISSABLE_CARD_STACK'
}

/** Which column a home screen block prefers on a wide screen; clients map it to their own breakpoints */
export enum HomeBlockColumnEnum {
  /** Spans every column */
  FullWidth = 'FULL_WIDTH',
  /** The main column */
  Primary = 'PRIMARY',
  /** The side column */
  Secondary = 'SECONDARY'
}

/** How a home screen block lays out its contents */
export enum HomeBlockLayoutEnum {
  /** Contents fill a grid of HomeBlock.columns columns (iOS) */
  Grid = 'GRID',
  /** Contents scroll horizontally */
  Horizontal = 'HORIZONTAL',
  /** Contents stack vertically */
  Vertical = 'VERTICAL'
}

/** A first-party component or promo tile inside an InternalBlock */
export type HomeComponent = {
  __typename?: 'HomeComponent';
  androidPlacementId?: Maybe<Scalars['ID']['output']>;
  /** The client component to render (e.g. cash_advance_card); null for a promo tile */
  componentKey?: Maybe<Scalars['String']['output']>;
  copy?: Maybe<Scalars['String']['output']>;
  deeplink?: Maybe<Scalars['String']['output']>;
  foregroundImageUrl?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  iosPlacementId?: Maybe<Scalars['ID']['output']>;
  maxCount?: Maybe<Scalars['Int']['output']>;
  /** The raw layout item, for component-specific keys not modelled above */
  params: Scalars['JSON']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** Component-specific variant (e.g. "2", "quadrant") */
  variant?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

/** The typed, co-resolved home screen. One query returns the full layout with offers resolvable inline (and @defer-able). */
export type HomeScreen = {
  __typename?: 'HomeScreen';
  /** The ordered blocks that make up the home screen */
  blocks: Array<HomeBlock>;
  /** "<testName>:<variant>" of the hp-v2 experiment that supplied the layout, else "default" */
  layoutVariant: Scalars['String']['output'];
  /** The applied layout policy; EXPERIMENT when personalization is unavailable */
  layoutVersion: HomeScreenLayoutVersion;
};

export enum HomeScreenLayoutVersion {
  /** The assigned experiment layout (default) */
  Experiment = 'EXPERIMENT',
  /** Behavioral section ordering, when enabled; requires X-Session-Id */
  PersonalizedV1 = 'PERSONALIZED_V1'
}

export type HtmlAd = BaseAd & WithTimestamps & {
  __typename?: 'HtmlAd';
  /** The specific type of ad. */
  adType: AdTypeEnum;
  /** The HTML content or an error response. */
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The Served Impression ID that was served to the user. */
  servedImpressionId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type HtmlAdInput = {
  /** Which versions of mraid the ad supports */
  supportedMraidVersions?: InputMaybe<Array<AdMraidVersionEnum>>;
  /** The supported sizes for the ad */
  supportedSizes: Array<AdSupportedSizeEnum>;
};

export type InactivityFeeDisplay = Transaction & {
  __typename?: 'InactivityFeeDisplay';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** ISO 3166-2 formatted administrative area (division such as state or provence) */
export type InputAdministrativeArea = Question & {
  __typename?: 'InputAdministrativeArea';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputBoolean = Question & {
  __typename?: 'InputBoolean';
  createdAt: Scalars['String']['output'];
  falseOptionLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  trueOptionLabel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputButtonSelection = Question & {
  __typename?: 'InputButtonSelection';
  buttons: Array<Button>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  minSelections?: Maybe<Scalars['Int']['output']>;
  multiple: Scalars['Boolean']['output'];
  rank: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputChipsSelection = Question & {
  __typename?: 'InputChipsSelection';
  chips: Array<Chip>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  minSelections?: Maybe<Scalars['Int']['output']>;
  multiple: Scalars['Boolean']['output'];
  rank: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputCurrency = Question & {
  __typename?: 'InputCurrency';
  createdAt: Scalars['String']['output'];
  /** @deprecated no longer supported */
  currencyCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputDate = Question & {
  __typename?: 'InputDate';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputGroup = Question & {
  __typename?: 'InputGroup';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  questions?: Maybe<Array<Question>>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputListSelection = Question & {
  __typename?: 'InputListSelection';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  options: Array<Option>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputNumber = Question & {
  __typename?: 'InputNumber';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

/** postal code input type */
export type InputPostalCode = Question & {
  __typename?: 'InputPostalCode';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputStyledButtonSelection = Question & {
  __typename?: 'InputStyledButtonSelection';
  buttons: Array<StyledButton>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  minSelections?: Maybe<Scalars['Int']['output']>;
  multiple: Scalars['Boolean']['output'];
  rank: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputText = Question & {
  __typename?: 'InputText';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InsightNotFoundError = ErrorInterface & {
  __typename?: 'InsightNotFoundError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type InstrumentFundamentals = {
  __typename?: 'InstrumentFundamentals';
  askPrice: Scalars['Float']['output'];
  bidPrice: Scalars['Float']['output'];
  bookValuePerShare?: Maybe<Scalars['Float']['output']>;
  cashFlowPerShare?: Maybe<Scalars['Float']['output']>;
  close?: Maybe<Scalars['Float']['output']>;
  closePrior?: Maybe<Scalars['Float']['output']>;
  cumulativeVolume?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  dividend?: Maybe<Scalars['Float']['output']>;
  dividendYield?: Maybe<Scalars['Float']['output']>;
  earningsPerShare?: Maybe<Scalars['Float']['output']>;
  fiftyTwoWeekHighPrice?: Maybe<Scalars['Float']['output']>;
  fiftyTwoWeekLowPrice?: Maybe<Scalars['Float']['output']>;
  highPrice: Scalars['Float']['output'];
  lowPrice: Scalars['Float']['output'];
  marketCap?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  openPrice: Scalars['Float']['output'];
  operatingIncome?: Maybe<Scalars['Float']['output']>;
  pbRatio?: Maybe<Scalars['Float']['output']>;
  peRatio?: Maybe<Scalars['Float']['output']>;
  priceMovingAverage50Day?: Maybe<Scalars['Float']['output']>;
  priceMovingAverage150Day?: Maybe<Scalars['Float']['output']>;
  priceMovingAverage200Day?: Maybe<Scalars['Float']['output']>;
  roe?: Maybe<Scalars['Float']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  sharesOutstanding?: Maybe<Scalars['Float']['output']>;
  symbol: Scalars['String']['output'];
  volumeMovingAverage10Day?: Maybe<Scalars['Float']['output']>;
  volumeMovingAverage25Day?: Maybe<Scalars['Float']['output']>;
  volumeMovingAverage50Day?: Maybe<Scalars['Float']['output']>;
};

export type InstrumentLabel = {
  __typename?: 'InstrumentLabel';
  emoji: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type InternalBlock = HomeBlock & {
  __typename?: 'InternalBlock';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The cell rendering style for this block */
  cellStyle?: Maybe<HomeBlockCellStyleEnum>;
  /** Wide-screen column hint; null when the placement sets none. Clients map it to breakpoints */
  column?: Maybe<HomeBlockColumnEnum>;
  /** Column count when layout is GRID */
  columns?: Maybe<Scalars['Int']['output']>;
  /** The first-party components and promo tiles rendered in this block, in order */
  components: Array<HomeComponent>;
  /** Optional call-to-action label */
  cta?: Maybe<Scalars['String']['output']>;
  /** Optional call-to-action deeplink */
  ctaDeeplink?: Maybe<Scalars['String']['output']>;
  /** The placement id backing this block */
  id: Scalars['ID']['output'];
  /** How the block lays out its contents */
  layout?: Maybe<HomeBlockLayoutEnum>;
  /** The background color of the block contents (legacy layout.backgroundColor) */
  layoutBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The maximum number of items to render in this block */
  maxCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the block shows a "View all" link (legacy showViewAll) */
  showViewAll?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleColor?: Maybe<Scalars['String']['output']>;
};

export type InternalNativeCreativeLayout = {
  __typename?: 'InternalNativeCreativeLayout';
  height?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type InvalidAddressError = ErrorInterface & {
  __typename?: 'InvalidAddressError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type InvalidCardNumberError = ErrorInterface & {
  __typename?: 'InvalidCardNumberError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type InvalidExpirationDateError = ErrorInterface & {
  __typename?: 'InvalidExpirationDateError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type InvalidRatingError = ErrorInterface & {
  __typename?: 'InvalidRatingError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type InvalidRefreshTokenError = ErrorInterface & {
  __typename?: 'InvalidRefreshTokenError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type InvalidSubscriptionTransitionError = ErrorInterface & {
  __typename?: 'InvalidSubscriptionTransitionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type InvalidUserAttributionError = ErrorInterface & {
  __typename?: 'InvalidUserAttributionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type InvestmentAccount = {
  __typename?: 'InvestmentAccount';
  aggregated?: Maybe<InvestmentAccountAggregated>;
  id: Scalars['ID']['output'];
  portfolio: Portfolio;
  provisioningCompletedAt?: Maybe<Scalars['String']['output']>;
  provisioningInitiatedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<InvestmentAccountStatusEnum>;
};

export type InvestmentAccountAggregated = {
  __typename?: 'InvestmentAccountAggregated';
  aggregatedAddonInstruments: Array<AggregatedAddonInstrument>;
  aggregatedCorePortfolio: AggregatedCorePortfolio;
};

export enum InvestmentAccountStatusEnum {
  /** Closed */
  Closed = 'closed',
  /** Failed KYC */
  FailedKyc = 'failed_kyc',
  /** Failed Provisioning */
  FailedProvisioning = 'failed_provisioning',
  /** Open */
  Open = 'open',
  /** Open, No Trades */
  OpenNoTrades = 'open_no_trades',
  /** Pending Close */
  PendingClose = 'pending_close',
  /** Provisioning */
  Provisioning = 'provisioning'
}

export type InvestmentApplicationInput = {
  broker?: InputMaybe<Scalars['Boolean']['input']>;
  citizenshipCountry?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  directorOf?: InputMaybe<Scalars['String']['input']>;
  employmentStatus: EmploymentStatusEnum;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  politicallyExposedNames?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentDeposit = Transaction & {
  __typename?: 'InvestmentDeposit';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type InvestmentWithdrawal = Transaction & {
  __typename?: 'InvestmentWithdrawal';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type KeepAccessSubscriptionAlreadyUsedDiscountError = ErrorInterface & {
  __typename?: 'KeepAccessSubscriptionAlreadyUsedDiscountError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type KeepAccessSubscriptionErrors = Error | KeepAccessSubscriptionAlreadyUsedDiscountError | KeepAccessSubscriptionInvalidDiscountError | KeepAccessSubscriptionNoSubscriptionError;

/** Autogenerated input type of KeepAccessSubscription */
export type KeepAccessSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type KeepAccessSubscriptionInvalidDiscountError = ErrorInterface & {
  __typename?: 'KeepAccessSubscriptionInvalidDiscountError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type KeepAccessSubscriptionNoSubscriptionError = ErrorInterface & {
  __typename?: 'KeepAccessSubscriptionNoSubscriptionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of KeepAccessSubscription */
export type KeepAccessSubscriptionPayload = {
  __typename?: 'KeepAccessSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<KeepAccessSubscriptionErrors>>;
  subscription?: Maybe<Subscription>;
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  /** Counts of rewards by type for the selected period */
  countsByType?: Maybe<Array<TypeCount>>;
  entries: Array<LeaderboardEntry>;
  period: LeaderboardPeriodEnum;
  /** Total number of users in the leaderboard */
  totalUsers: Scalars['Int']['output'];
  type: LeaderboardTypeEnum;
  /** Current user's reward amount in the leaderboard */
  userAmount?: Maybe<Scalars['Float']['output']>;
  /** Current user's rank in the leaderboard */
  userRank?: Maybe<Scalars['Int']['output']>;
};

export type LeaderboardEntry = {
  __typename?: 'LeaderboardEntry';
  /** The reward amount earned by the user */
  amount: Scalars['Float']['output'];
  /** Number of rewards contributing to the amount (nil for overall) */
  count?: Maybe<Scalars['Int']['output']>;
  rank: Scalars['Int']['output'];
  user: LeaderboardUserUnion;
};

/** Time periods for reward leaderboards */
export enum LeaderboardPeriodEnum {
  /** Daily leaderboard */
  Daily = 'DAILY',
  /** Monthly leaderboard */
  Monthly = 'MONTHLY',
  /** Weekly leaderboard */
  Weekly = 'WEEKLY'
}

/** Types of reward leaderboards */
export enum LeaderboardTypeEnum {
  /** Data rewards leaderboard */
  DataReward = 'DATA_REWARD',
  /** Gaming rewards leaderboard */
  Gaming = 'GAMING',
  /** Overall rewards leaderboard */
  Overall = 'OVERALL',
  /** Partner rewards leaderboard */
  PartnerReward = 'PARTNER_REWARD',
  /** Referral rewards leaderboard */
  ReferralReward = 'REFERRAL_REWARD',
  /** Survey rewards leaderboard */
  Survey = 'SURVEY'
}

export type LeaderboardUserUnion = OtherUser | User;

/** Link monitored bank account input object */
export type LinkAccount = {
  provider: Provider;
};

/** Autogenerated input type of LinkAccount */
export type LinkAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<LinkAccount>;
};

/** Autogenerated return type of LinkAccount */
export type LinkAccountPayload = {
  __typename?: 'LinkAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<LinkMonitoredAccountError>>;
  monitoredBankAccounts?: Maybe<Array<MonitoredBankAccount>>;
};

export enum LinkAccountTypeEnum {
  /** Monitored account */
  Monitored = 'monitored',
  /** Payment account */
  Payment = 'payment'
}

export type LinkBankAccountError = Error;

/** Autogenerated input type of LinkBankAccount */
export type LinkBankAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: Provider;
};

/** Autogenerated return type of LinkBankAccount */
export type LinkBankAccountPayload = {
  __typename?: 'LinkBankAccountPayload';
  bankAccount?: Maybe<BankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<LinkBankAccountError>>;
};

export type LinkBlockedError = ErrorInterface & {
  __typename?: 'LinkBlockedError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type LinkMonitoredAccountError = Error;

export type LinkedAccountConflictError = ErrorInterface & {
  __typename?: 'LinkedAccountConflictError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type LinkedCardInvalidError = ErrorInterface & {
  __typename?: 'LinkedCardInvalidError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type LinkedOverLimitError = ErrorInterface & {
  __typename?: 'LinkedOverLimitError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  storeNumber?: Maybe<Scalars['String']['output']>;
};

export type MarketStatus = {
  __typename?: 'MarketStatus';
  isOpen: Scalars['Boolean']['output'];
};

export type MaxAccountChangesReachedError = ErrorInterface & {
  __typename?: 'MaxAccountChangesReachedError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type MissingCardDataError = ErrorInterface & {
  __typename?: 'MissingCardDataError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type MissingRewardInvalidInputError = ErrorInterface & {
  __typename?: 'MissingRewardInvalidInputError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type MissingRewardReport = {
  __typename?: 'MissingRewardReport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerOfferId?: Maybe<Scalars['ID']['output']>;
  status: MissingRewardReportStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

/** Status of a missing reward report */
export enum MissingRewardReportStatus {
  /** Report is being investigated */
  Investigating = 'INVESTIGATING',
  /** Report is pending review */
  Pending = 'PENDING',
  /** Report has been rejected */
  Rejected = 'REJECTED',
  /** Report has been resolved */
  Resolved = 'RESOLVED'
}

export type MissingRewardValidationError = ErrorInterface & {
  __typename?: 'MissingRewardValidationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type MissingUserDataError = ErrorInterface & {
  __typename?: 'MissingUserDataError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type MonetizedProgress = {
  __typename?: 'MonetizedProgress';
  /** The time the event was completed at */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The max amount of times this event can be completed */
  maxCompletionTimes: Scalars['Int']['output'];
  /** The amount that can be earned for this event */
  rewardAmount: Scalars['String']['output'];
  /** The description to be used for displaying purposes */
  rewardCriteriaDescription: Scalars['String']['output'];
  /** The type of reward that can be earned for this event */
  rewardType: PartnerRewardTypeEnum;
  /** The status of the progress the current node is in. */
  status: MonetizedProgressStatusEnum;
  /** The amount of times this event has been completed */
  timesCompleted: Scalars['Int']['output'];
};

/** The connection type for MonetizedProgress. */
export type MonetizedProgressConnection = {
  __typename?: 'MonetizedProgressConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MonetizedProgressEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MonetizedProgress>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MonetizedProgressEdge = {
  __typename?: 'MonetizedProgressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MonetizedProgress>;
};

export enum MonetizedProgressStatusEnum {
  Completed = 'COMPLETED',
  Incomplete = 'INCOMPLETE',
  InProgress = 'IN_PROGRESS'
}

export type MonitoredBankAccount = {
  __typename?: 'MonitoredBankAccount';
  balance?: Maybe<Scalars['Float']['output']>;
  balanceLastUpdatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether this account can be disconnected from monitoring */
  canUnlink: Scalars['Boolean']['output'];
  cardlyticsHasOffers: Scalars['Boolean']['output'];
  cardlyticsLinked: Scalars['Boolean']['output'];
  cardlyticsLinkedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601Date']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  displayAccountNumber?: Maybe<Scalars['String']['output']>;
  /** A problem the user should resolve, or null when healthy */
  health?: Maybe<BankAccountHealthEnum>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requireReauth?: Maybe<Scalars['Boolean']['output']>;
  subtype?: Maybe<MonitoredBankAccountSubtypeEnum>;
  type?: Maybe<MonitoredBankAccountTypeEnum>;
};

export enum MonitoredBankAccountSubtypeEnum {
  /** Auto loan */
  Auto = 'AUTO',
  /** Standard brokerage account */
  Brokerage = 'BROKERAGE',
  /** Business loan */
  Business = 'BUSINESS',
  /** Individual Savings Account (ISA) that pays interest tax-free (UK) */
  CashIsa = 'CASH_ISA',
  /** A cash management account, typically a cash account at a brokerage */
  CashManagement = 'CASH_MANAGEMENT',
  /** Certificate of deposit account */
  Cd = 'CD',
  /** Checking account */
  Checking = 'CHECKING',
  /** Commercial loan */
  Commercial = 'COMMERCIAL',
  /** Construction loan */
  Construction = 'CONSTRUCTION',
  /** Consumer loan */
  Consumer = 'CONSUMER',
  /** Bank-issued credit card */
  CreditCard = 'CREDIT_CARD',
  /** Standard cryptocurrency exchange account */
  CryptoExchange = 'CRYPTO_EXCHANGE',
  /** An Electronic Benefit Transfer (EBT) account, used by certain public assistance programs to distribute funds (US only) */
  Ebt = 'EBT',
  /** Tax-advantaged Coverdell Education Savings Account (ESA) (US) */
  EducationSavingsAccount = 'EDUCATION_SAVINGS_ACCOUNT',
  /** Fixed annuity */
  FixedAnnuity = 'FIXED_ANNUITY',
  /** Guaranteed Investment Certificate (Canada) */
  Gic = 'GIC',
  /** Tax-advantaged Health Reimbursement Arrangement (HRA) benefit plan (US) */
  HealthReimbursementArrangement = 'HEALTH_REIMBURSEMENT_ARRANGEMENT',
  /** Home Equity Line of Credit (HELOC) */
  HomeEquity = 'HOME_EQUITY',
  /** Health Savings Account */
  Hsa = 'HSA',
  /** Traditional Individual Retirement Account (IRA) (US) */
  Ira = 'IRA',
  /** Non-cash Individual Savings Account (ISA) (UK) */
  Isa = 'ISA',
  /** Employer-sponsored money-purchase 401(a) retirement plan (US) */
  I_401A = 'I_401A',
  /** Standard 401(k) retirement account (US) */
  I_401K = 'I_401K',
  /** 403(b) retirement savings account for non-profits and schools (US) */
  I_403B = 'I_403B',
  /** Tax-advantaged deferred-compensation 457(b) retirement plan for governments and non-profits (US) */
  I_457B = 'I_457B',
  /** Tax-advantaged college savings and prepaid tuition 529 plans (US) */
  I_529 = 'I_529',
  /** Keogh self-employed retirement plan (US) */
  Keogh = 'KEOGH',
  /** Life Income Fund (LIF) retirement account (Canada) */
  Lif = 'LIF',
  /** Life insurance account */
  LifeInsurance = 'LIFE_INSURANCE',
  /** Pre-approved line of credit */
  LineOfCredit = 'LINE_OF_CREDIT',
  /** Locked-in Retirement Account (LIRA) (Canada) */
  Lira = 'LIRA',
  /** General loan */
  Loan = 'LOAN',
  /** Locked-in Retirement Income Fund (LRIF) (Canada) */
  Lrif = 'LRIF',
  /** Locked-in Retirement Savings Plan (Canada) */
  Lrsp = 'LRSP',
  /** Money market account */
  MoneyMarket = 'MONEY_MARKET',
  /** Mortgage loan */
  Mortgage = 'MORTGAGE',
  /** Mutual fund account */
  MutualFund = 'MUTUAL_FUND',
  /** A cryptocurrency wallet where the user controls the private key */
  NonCustodialWallet = 'NON_CUSTODIAL_WALLET',
  /** A non-taxable brokerage account that is not covered by a more specific subtype */
  NonTaxableBrokerageAccount = 'NON_TAXABLE_BROKERAGE_ACCOUNT',
  /** Other or unknown account type */
  Other = 'OTHER',
  /** An annuity account not covered by other subtypes */
  OtherAnnuity = 'OTHER_ANNUITY',
  /** An insurance account not covered by other subtypes */
  OtherInsurance = 'OTHER_INSURANCE',
  /** Pre-approved overdraft account, usually tied to a checking account */
  Overdraft = 'OVERDRAFT',
  /** PayPal depository account */
  Paypal = 'PAYPAL',
  /** PayPal-issued credit card */
  PaypalCredit = 'PAYPAL_CREDIT',
  /** Standard pension account */
  Pension = 'PENSION',
  /** Prepaid debit card */
  Prepaid = 'PREPAID',
  /** Prescribed Registered Retirement Income Fund (Canada) */
  Prif = 'PRIF',
  /** Plan that gives employees share of company profits */
  ProfitSharingPlan = 'PROFIT_SHARING_PLAN',
  /** Qualifying share account */
  Qshr = 'QSHR',
  /** Registered Disability Savings Plan (RSDP) (Canada) */
  Rdsp = 'RDSP',
  /** Registered Education Savings Plan (Canada) */
  Resp = 'RESP',
  /** Retirement account not covered by other subtypes */
  Retirement = 'RETIREMENT',
  /** Restricted Life Income Fund (RLIF) (Canada) */
  Rlif = 'RLIF',
  /** Roth IRA (US) */
  Roth = 'ROTH',
  /** Employer-sponsored Roth 401(k) plan (US) */
  Roth_401K = 'ROTH_401K',
  /** Registered Retirement Income Fund (RRIF) (Canada) */
  Rrif = 'RRIF',
  /** Registered Retirement Savings Plan (Canadian, similar to US 401(k)) */
  Rrsp = 'RRSP',
  /** Salary Reduction Simplified Employee Pension Plan (SARSEP), discontinued retirement plan (US) */
  Sarsep = 'SARSEP',
  /** Savings account */
  Savings = 'SAVINGS',
  /** Simplified Employee Pension IRA (SEP IRA), retirement plan for small businesses and self-employed (US) */
  SepIra = 'SEP_IRA',
  /** Savings Incentive Match Plan for Employees IRA, retirement plan for small businesses (US) */
  SimpleIra = 'SIMPLE_IRA',
  /** Self-Invested Personal Pension (SIPP) (UK) */
  Sipp = 'SIPP',
  /** Standard stock plan account */
  StockPlan = 'STOCK_PLAN',
  /** Student loan */
  Student = 'STUDENT',
  /** Tax-Free Savings Account (TFSA), a retirement plan similar to a Roth IRA (Canada) */
  Tfsa = 'TFSA',
  /** Account representing funds or assets held by a trustee for the benefit of a beneficiary. Includes both revocable and irrevocable trusts. */
  Trust = 'TRUST',
  /** 'Uniform Gift to Minors Act' (brokerage account for minors, US) */
  Ugma = 'UGMA',
  /** 'Uniform Transfers to Minors Act' (brokerage account for minors, US) */
  Utma = 'UTMA',
  /** Tax-deferred capital accumulation annuity contract */
  VariableAnnuity = 'VARIABLE_ANNUITY'
}

export type MonitoredBankAccountTransaction = {
  __typename?: 'MonitoredBankAccountTransaction';
  amount: Scalars['Float']['output'];
  date: Scalars['ISO8601Date']['output'];
  deleted: Scalars['Boolean']['output'];
  detailedCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ignored: Scalars['Boolean']['output'];
  location?: Maybe<Location>;
  merchantLogoUrl?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  monitoredBankAccountId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameOverride?: Maybe<Scalars['String']['output']>;
  needsCategorization: Scalars['Boolean']['output'];
  paymentChannel?: Maybe<PaymentChannelEnum>;
  pending: Scalars['Boolean']['output'];
  primaryCategory?: Maybe<Scalars['String']['output']>;
  primaryCategoryOverride?: Maybe<Scalars['String']['output']>;
  recurringTransactionId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

/** The connection type for MonitoredBankAccountTransaction. */
export type MonitoredBankAccountTransactionConnection = {
  __typename?: 'MonitoredBankAccountTransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MonitoredBankAccountTransactionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MonitoredBankAccountTransaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MonitoredBankAccountTransactionEdge = {
  __typename?: 'MonitoredBankAccountTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MonitoredBankAccountTransaction>;
};

export enum MonitoredBankAccountTypeEnum {
  /** A credit card type account. */
  Credit = 'CREDIT',
  /** An account type holding cash, in which funds are deposited. */
  Depository = 'DEPOSITORY',
  /** An investment type account. */
  Investment = 'INVESTMENT',
  /** A loan type account. */
  Loan = 'LOAN',
  /** An account type not covered by other types */
  Other = 'OTHER'
}

export type Mutation = {
  __typename?: 'Mutation';
  address?: Maybe<AddressPayload>;
  answerQuestion?: Maybe<AnswerQuestionPayload>;
  assignAddon?: Maybe<AssignAddonPayload>;
  assignBankAccountToCashAdvanceApplication?: Maybe<AssignBankAccountToCashAdvanceApplicationPayload>;
  batchPublishClientEvents?: Maybe<BatchPublishClientEventsPayload>;
  bidResponse?: Maybe<PartnerBidResponsePayload>;
  calibrateBudgets: CalibrateBudgetsPayload;
  cancelCashAdvanceApplication?: Maybe<CancelCashAdvanceApplicationPayload>;
  changeBankAccount: ChangeBankAccountPayload;
  confirmEmail: ConfirmEmailPayload;
  confirmPhone: ConfirmPhonePayload;
  createAccountClosureAttempt: CreateAccountClosureAttemptPayload;
  createCardlyticsSessionToken?: Maybe<CreateSessionTokenPayload>;
  createCashAdvanceApplication?: Maybe<CreateCashAdvanceApplicationPayload>;
  createCashAdvanceRequest?: Maybe<CreateCashAdvanceRequestPayload>;
  createChatToken: CreateChatTokenPayload;
  createChatkitSession: CreateSessionPayload;
  createClosureRequest: CreateClosureRequestPayload;
  createCtaClickUrl: CreateCtaClickUrlPayload;
  createLinkToken?: Maybe<CreateLinkTokenPayload>;
  /** Creates a report for missing rewards from partner offers. */
  createMissingRewardReport?: Maybe<CreateMissingRewardReportPayload>;
  createOnetimeDeposit?: Maybe<CreateOnetimeDepositPayload>;
  /** Creates or updates a review for a partner if the user has completed a reward from them. */
  createPartnerReview?: Maybe<CreatePartnerReviewPayload>;
  createPaymentAccount: CreatePaymentAccountPayload;
  createSubscription: CreateSubscriptionPayload;
  createUpdateLinkToken: CreateUpdateLinkTokenPayload;
  createUser: CreateUserPayload;
  /** @deprecated Use upsertUserFeatureOptIn instead */
  createUserFeatureOptIn: CreateUserFeatureOptInPayload;
  createUserRecurringDeposit?: Maybe<CreateUserRecurringDepositPayload>;
  createWithdrawal?: Maybe<CreateWithdrawalPayload>;
  deleteUserRecurringDeposit?: Maybe<DeleteUserRecurringDepositPayload>;
  favoritePartner?: Maybe<FavoritePartnerPayload>;
  forgotPassword: Scalars['Boolean']['output'];
  keepAccessSubscription?: Maybe<KeepAccessSubscriptionPayload>;
  linkBankAccount: LinkBankAccountPayload;
  linkMonitoredAccount: LinkAccountPayload;
  mutePartner?: Maybe<MutePartnerPayload>;
  notifyReferredUser?: Maybe<NotifyReferredUserPayload>;
  oAuthCreateUser: OAuthCreateUserPayload;
  oAuthSignInUser: OAuthSignInUserPayload;
  pauseCashAdvanceSubscription?: Maybe<PauseCashAdvanceSubscriptionPayload>;
  pauseSubscription?: Maybe<PauseSubscriptionPayload>;
  payOutstandingFee?: Maybe<PayOutstandingFeePayload>;
  publishBackgroundEvent?: Maybe<PublishBackgroundEventPayload>;
  publishClientEvent?: Maybe<PublishClientEventPayload>;
  publishEvent?: Maybe<PublishEventPayload>;
  publishWebEvent?: Maybe<PublishWebEventPayload>;
  refreshTransactions?: Maybe<RefreshTransactionsPayload>;
  refreshUserSession?: Maybe<RefreshUserSessionPayload>;
  registrationComplete: RegistrationCompletePayload;
  relinkPaymentAccount?: Maybe<RelinkPaymentAccountPayload>;
  removeAddon?: Maybe<RemoveAddonPayload>;
  repayCashAdvanceRequest?: Maybe<RepayCashAdvanceRequestPayload>;
  resendEmailVerification?: Maybe<ResendEmailVerificationPayload>;
  resendPhoneVerification?: Maybe<ResendPhoneVerificationPayload>;
  resetPassword: ResetPasswordPayload;
  resubmitInvestmentApplication?: Maybe<ResubmitInvestmentApplicationPayload>;
  resumeSubscription?: Maybe<ResumeSubscriptionPayload>;
  runCashAdvanceEvaluation?: Maybe<RunCashAdvanceEvaluationPayload>;
  sendSignInSms?: Maybe<SendSignInSmsPayload>;
  setMonitoredTransactionOverrides: SetOverridesPayload;
  setUserAttribution: SetUserAttributionPayload;
  signInUser?: Maybe<SignInUserPayload>;
  signOutUser?: Maybe<Scalars['Boolean']['output']>;
  skipContainer?: Maybe<SkipContainerPayload>;
  submitCashAdvanceApplication?: Maybe<SubmitCashAdvanceApplicationPayload>;
  submitIntegrityResponse?: Maybe<SubmitIntegrityResponsePayload>;
  submitInvestmentApplication?: Maybe<SubmitInvestmentApplicationPayload>;
  switchSubscription: SwitchSubscriptionPayload;
  unlinkBankAccount: UnlinkBankAccountPayload;
  unlinkMonitoredAccount: UnlinkAccountPayload;
  updateFinancialInsightStatus: UpdateFinancialInsightStatusPayload;
  updatePaymentAccount: UpdatePaymentAccountPayload;
  updatePaymentAccountExpiration: UpdatePaymentAccountExpirationPayload;
  updatePhone: UpdatePhonePayload;
  updateUser: UpdateUserPayload;
  updateUserRecurringDeposit?: Maybe<UpdateUserRecurringDepositPayload>;
  upsertBudget: UpsertBudgetPayload;
  upsertUserFeatureOptIn: UpsertUserFeatureOptInPayload;
};


export type MutationAddressArgs = {
  input: AddressInput;
};


export type MutationAnswerQuestionArgs = {
  input: AnswerQuestionInput;
};


export type MutationAssignAddonArgs = {
  input: AssignAddonInput;
};


export type MutationAssignBankAccountToCashAdvanceApplicationArgs = {
  input: AssignBankAccountToCashAdvanceApplicationInput;
};


export type MutationBatchPublishClientEventsArgs = {
  input: BatchPublishClientEventsInput;
};


export type MutationBidResponseArgs = {
  input: PartnerBidResponseInput;
};


export type MutationCalibrateBudgetsArgs = {
  input: CalibrateBudgetsInput;
};


export type MutationCancelCashAdvanceApplicationArgs = {
  input: CancelCashAdvanceApplicationInput;
};


export type MutationChangeBankAccountArgs = {
  input: ChangeBankAccountInput;
};


export type MutationConfirmEmailArgs = {
  input: ConfirmEmailInput;
};


export type MutationConfirmPhoneArgs = {
  input: ConfirmPhoneInput;
};


export type MutationCreateAccountClosureAttemptArgs = {
  input: CreateAccountClosureAttemptInput;
};


export type MutationCreateCashAdvanceApplicationArgs = {
  input: CreateCashAdvanceApplicationInput;
};


export type MutationCreateCashAdvanceRequestArgs = {
  input: CreateCashAdvanceRequestInput;
};


export type MutationCreateChatTokenArgs = {
  input: CreateChatTokenInput;
};


export type MutationCreateChatkitSessionArgs = {
  input: CreateSessionInput;
};


export type MutationCreateClosureRequestArgs = {
  input: CreateClosureRequestInput;
};


export type MutationCreateCtaClickUrlArgs = {
  input: CreateCtaClickUrlInput;
};


export type MutationCreateLinkTokenArgs = {
  androidNative?: InputMaybe<Scalars['Boolean']['input']>;
  linkAccountType?: InputMaybe<LinkAccountTypeEnum>;
};


export type MutationCreateMissingRewardReportArgs = {
  input: CreateMissingRewardReportInput;
};


export type MutationCreateOnetimeDepositArgs = {
  input: CreateOnetimeDepositInput;
};


export type MutationCreatePartnerReviewArgs = {
  input: CreatePartnerReviewInput;
};


export type MutationCreatePaymentAccountArgs = {
  input: CreatePaymentAccountInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateUpdateLinkTokenArgs = {
  input: CreateUpdateLinkTokenInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserFeatureOptInArgs = {
  input: CreateUserFeatureOptInInput;
};


export type MutationCreateUserRecurringDepositArgs = {
  input: CreateUserRecurringDepositInput;
};


export type MutationCreateWithdrawalArgs = {
  input: CreateWithdrawalInput;
};


export type MutationDeleteUserRecurringDepositArgs = {
  input: DeleteUserRecurringDepositInput;
};


export type MutationFavoritePartnerArgs = {
  input: FavoritePartnerInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationKeepAccessSubscriptionArgs = {
  input: KeepAccessSubscriptionInput;
};


export type MutationLinkBankAccountArgs = {
  input: LinkBankAccountInput;
};


export type MutationLinkMonitoredAccountArgs = {
  input: LinkAccountInput;
};


export type MutationMutePartnerArgs = {
  input: MutePartnerInput;
};


export type MutationNotifyReferredUserArgs = {
  input: NotifyReferredUserInput;
};


export type MutationOAuthCreateUserArgs = {
  input: OAuthCreateUserInput;
};


export type MutationOAuthSignInUserArgs = {
  input: OAuthSignInUserInput;
};


export type MutationPauseCashAdvanceSubscriptionArgs = {
  input: PauseCashAdvanceSubscriptionInput;
};


export type MutationPauseSubscriptionArgs = {
  input: PauseSubscriptionInput;
};


export type MutationPayOutstandingFeeArgs = {
  input: PayOutstandingFeeInput;
};


export type MutationPublishBackgroundEventArgs = {
  input: PublishBackgroundEventInput;
};


export type MutationPublishClientEventArgs = {
  input: PublishClientEventInput;
};


export type MutationPublishEventArgs = {
  input: PublishEventInput;
};


export type MutationPublishWebEventArgs = {
  input: PublishWebEventInput;
};


export type MutationRefreshTransactionsArgs = {
  input: RefreshTransactionsInput;
};


export type MutationRefreshUserSessionArgs = {
  input: RefreshUserSessionInput;
};


export type MutationRegistrationCompleteArgs = {
  input: RegistrationCompleteInput;
};


export type MutationRelinkPaymentAccountArgs = {
  input: RelinkPaymentAccountInput;
};


export type MutationRemoveAddonArgs = {
  input: RemoveAddonInput;
};


export type MutationRepayCashAdvanceRequestArgs = {
  input: RepayCashAdvanceRequestInput;
};


export type MutationResendEmailVerificationArgs = {
  input: ResendEmailVerificationInput;
};


export type MutationResendPhoneVerificationArgs = {
  input: ResendPhoneVerificationInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResubmitInvestmentApplicationArgs = {
  input: ResubmitInvestmentApplicationInput;
};


export type MutationResumeSubscriptionArgs = {
  input: ResumeSubscriptionInput;
};


export type MutationRunCashAdvanceEvaluationArgs = {
  input: RunCashAdvanceEvaluationInput;
};


export type MutationSendSignInSmsArgs = {
  input: SendSignInSmsInput;
};


export type MutationSetMonitoredTransactionOverridesArgs = {
  input: SetOverridesInput;
};


export type MutationSetUserAttributionArgs = {
  input: SetUserAttributionInput;
};


export type MutationSignInUserArgs = {
  input: SignInUserInput;
};


export type MutationSignOutUserArgs = {
  input: SignOutUserInput;
};


export type MutationSkipContainerArgs = {
  input: SkipContainerInput;
};


export type MutationSubmitCashAdvanceApplicationArgs = {
  input: SubmitCashAdvanceApplicationInput;
};


export type MutationSubmitIntegrityResponseArgs = {
  input: SubmitIntegrityResponseInput;
};


export type MutationSubmitInvestmentApplicationArgs = {
  input: SubmitInvestmentApplicationInput;
};


export type MutationSwitchSubscriptionArgs = {
  input: SwitchSubscriptionInput;
};


export type MutationUnlinkBankAccountArgs = {
  input: UnlinkBankAccountInput;
};


export type MutationUnlinkMonitoredAccountArgs = {
  input: UnlinkAccountInput;
};


export type MutationUpdateFinancialInsightStatusArgs = {
  input: UpdateFinancialInsightStatusInput;
};


export type MutationUpdatePaymentAccountArgs = {
  input: UpdatePaymentAccountInput;
};


export type MutationUpdatePaymentAccountExpirationArgs = {
  input: UpdatePaymentAccountExpirationInput;
};


export type MutationUpdatePhoneArgs = {
  input: UpdatePhoneInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserRecurringDepositArgs = {
  input: UpdateUserRecurringDepositInput;
};


export type MutationUpsertBudgetArgs = {
  input: UpsertBudgetInput;
};


export type MutationUpsertUserFeatureOptInArgs = {
  input: UpsertUserFeatureOptInInput;
};

export type MutePartnerError = Error;

/** Autogenerated input type of MutePartner */
export type MutePartnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['ID']['input'];
};

/** Autogenerated return type of MutePartner */
export type MutePartnerPayload = {
  __typename?: 'MutePartnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<MutePartnerError>>;
  /** Indicates if the partner was successfully muted/unmuted. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type NativeAd = BaseAd & WithTimestamps & {
  __typename?: 'NativeAd';
  /** The specific type of ad. */
  adType: AdTypeEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The title of a creative */
  cta: Scalars['String']['output'];
  /** The call to action url for a creative */
  ctaUri: Scalars['String']['output'];
  /** The deeplink url for a creative */
  deeplinkUri?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Legal notice related an offer in Markdown syntax. Normally includes Terms and Conditions */
  disclosure?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The internal (atm) layout for a creative */
  internalLayout?: Maybe<InternalNativeCreativeLayout>;
  /** The creative that is linked to this creative */
  linkedAd?: Maybe<AdUnion>;
  /** The main image url for a creative */
  mainImageUrl?: Maybe<Scalars['String']['output']>;
  /** The Served Impression ID that was served to the user. */
  servedImpressionId: Scalars['ID']['output'];
  /** The url linking to the terms and conditions for a creative or offer */
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  /** The title shown at the top of a Braze interstitial or a headline without emojis */
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type NoBankAccountError = ErrorInterface & {
  __typename?: 'NoBankAccountError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type NoCashAdvanceApplicationError = ErrorInterface & {
  __typename?: 'NoCashAdvanceApplicationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type NoLinkedCardError = ErrorInterface & {
  __typename?: 'NoLinkedCardError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type NoOutStandingFeeError = ErrorInterface & {
  __typename?: 'NoOutStandingFeeError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type NoPaymentAccountError = ErrorInterface & {
  __typename?: 'NoPaymentAccountError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type NoValidPaymentAccountError = ErrorInterface & {
  __typename?: 'NoValidPaymentAccountError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type NotEligibleError = ErrorInterface & {
  __typename?: 'NotEligibleError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type NotSupportedSubscriptionProductError = ErrorInterface & {
  __typename?: 'NotSupportedSubscriptionProductError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type NotifyReferredUserError = Error | RateLimitExceededError | ReferralNotFoundError;

/** Autogenerated input type of NotifyReferredUser */
export type NotifyReferredUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referralId: Scalars['ID']['input'];
};

/** Autogenerated return type of NotifyReferredUser */
export type NotifyReferredUserPayload = {
  __typename?: 'NotifyReferredUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<NotifyReferredUserError>>;
};

export type OAuthCreateUserError = Error | OAuthCreateUserExistingOAuthError | OAuthCreateUserExistingUserError | OAuthCreateUserInvalidTokenError | OAuthCreateUserTokenExpiredError;

export type OAuthCreateUserExistingOAuthError = ErrorInterface & {
  __typename?: 'OAuthCreateUserExistingOAuthError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type OAuthCreateUserExistingUserError = ErrorInterface & {
  __typename?: 'OAuthCreateUserExistingUserError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of OAuthCreateUser */
export type OAuthCreateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: OAuthProviderEnum;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type OAuthCreateUserInvalidTokenError = ErrorInterface & {
  __typename?: 'OAuthCreateUserInvalidTokenError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of OAuthCreateUser */
export type OAuthCreateUserPayload = {
  __typename?: 'OAuthCreateUserPayload';
  authentication?: Maybe<Authentication>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<OAuthCreateUserError>>;
  user?: Maybe<User>;
};

export type OAuthCreateUserTokenExpiredError = ErrorInterface & {
  __typename?: 'OAuthCreateUserTokenExpiredError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export enum OAuthProviderEnum {
  /** Sign In with Apple */
  AppleSignIn = 'APPLE_SIGN_IN',
  /** Google OAuth 2 */
  GoogleOauth2 = 'GOOGLE_OAUTH2'
}

export type OAuthSignInNotRegisteredError = ErrorInterface & {
  __typename?: 'OAuthSignInNotRegisteredError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type OAuthSignInUserAccountClosedError = ErrorInterface & {
  __typename?: 'OAuthSignInUserAccountClosedError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type OAuthSignInUserError = Error | OAuthSignInNotRegisteredError | OAuthSignInUserAccountClosedError | OAuthSignInUserInvalidTokenError | OAuthSignInUserTokenExpiredError;

/** Autogenerated input type of OAuthSignInUser */
export type OAuthSignInUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: OAuthProviderEnum;
  token: Scalars['String']['input'];
};

export type OAuthSignInUserInvalidTokenError = ErrorInterface & {
  __typename?: 'OAuthSignInUserInvalidTokenError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of OAuthSignInUser */
export type OAuthSignInUserPayload = {
  __typename?: 'OAuthSignInUserPayload';
  authentication?: Maybe<Authentication>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<OAuthSignInUserError>>;
  user?: Maybe<User>;
};

export type OAuthSignInUserTokenExpiredError = ErrorInterface & {
  __typename?: 'OAuthSignInUserTokenExpiredError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type OfferFeedBlock = HomeBlock & {
  __typename?: 'OfferFeedBlock';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The offer category backing this feed */
  categoryId?: Maybe<Scalars['ID']['output']>;
  /** The cell rendering style for this block */
  cellStyle?: Maybe<HomeBlockCellStyleEnum>;
  /** Wide-screen column hint; null when the placement sets none. Clients map it to breakpoints */
  column?: Maybe<HomeBlockColumnEnum>;
  /** Column count when layout is GRID */
  columns?: Maybe<Scalars['Int']['output']>;
  /** Optional call-to-action label */
  cta?: Maybe<Scalars['String']['output']>;
  /** Optional call-to-action deeplink */
  ctaDeeplink?: Maybe<Scalars['String']['output']>;
  /** The placement id backing this block */
  id: Scalars['ID']['output'];
  /** How the block lays out its contents */
  layout?: Maybe<HomeBlockLayoutEnum>;
  /** The background color of the block contents (legacy layout.backgroundColor) */
  layoutBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The maximum number of items to render in this block */
  maxCount?: Maybe<Scalars['Int']['output']>;
  /** Partner offers for this feed, co-resolved inline */
  offers?: Maybe<PartnerOfferUnionConnection>;
  /** Whether the block shows a "View all" link (legacy showViewAll) */
  showViewAll?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleColor?: Maybe<Scalars['String']['output']>;
};


export type OfferFeedBlockOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferTagBlock = HomeBlock & {
  __typename?: 'OfferTagBlock';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The cell rendering style for this block */
  cellStyle?: Maybe<HomeBlockCellStyleEnum>;
  /** Wide-screen column hint; null when the placement sets none. Clients map it to breakpoints */
  column?: Maybe<HomeBlockColumnEnum>;
  /** Column count when layout is GRID */
  columns?: Maybe<Scalars['Int']['output']>;
  /** Optional call-to-action label */
  cta?: Maybe<Scalars['String']['output']>;
  /** Optional call-to-action deeplink */
  ctaDeeplink?: Maybe<Scalars['String']['output']>;
  /** The placement id backing this block */
  id: Scalars['ID']['output'];
  /** How the block lays out its contents */
  layout?: Maybe<HomeBlockLayoutEnum>;
  /** The background color of the block contents (legacy layout.backgroundColor) */
  layoutBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The maximum number of items to render in this block */
  maxCount?: Maybe<Scalars['Int']['output']>;
  /** Partner offers for this block, co-resolved inline */
  offers?: Maybe<PartnerOfferUnionConnection>;
  /** Whether the block shows a "View all" link (legacy showViewAll) */
  showViewAll?: Maybe<Scalars['Boolean']['output']>;
  /** The tags surfaced by this block */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  titleColor?: Maybe<Scalars['String']['output']>;
};


export type OfferTagBlockOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** One-time deposit request input type */
export type OnetimeDeposit = {
  amount: Scalars['String']['input'];
};

export type Option = {
  __typename?: 'Option';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** A user other than the currently authenticated user */
export type OtherUser = {
  __typename?: 'OtherUser';
  /** Number of days in the user's current streak */
  currentStreakDays?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastInitial?: Maybe<Scalars['String']['output']>;
  /** Number of days in the user's longest streak */
  longestStreakDays?: Maybe<Scalars['Int']['output']>;
  /** Recent reward transactions for the user with obfuscated IDs */
  recentTransactions?: Maybe<TransactionConnection>;
};


/** A user other than the currently authenticated user */
export type OtherUserRecentTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Partner = {
  __typename?: 'Partner';
  /** The average rating of the partner based on user reviews. */
  aggregateRating?: Maybe<Scalars['Float']['output']>;
  bannerSlimImageUrl?: Maybe<Scalars['String']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  dataUsageDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  favorite: Scalars['Boolean']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use iconUrl only */
  logoUrl?: Maybe<Scalars['String']['output']>;
  minimalOfferDetailOverride: Scalars['Boolean']['output'];
  muted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  portraitBannerImageUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the partner requires the device advertising identifier (IDFA). */
  requireIdfa: Scalars['Boolean']['output'];
  /** The number of reviews for this partner. */
  reviewCount?: Maybe<Scalars['Int']['output']>;
  /** Key points extracted from customer reviews, AI-generated for display. */
  reviewKeyPoints?: Maybe<Array<Scalars['String']['output']>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type PartnerBid = {
  __typename?: 'PartnerBid';
  activeFrom?: Maybe<Scalars['ISO8601DateTime']['output']>;
  activeTo?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dataVaultContainers?: Maybe<Array<QuestionContainer>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  partner: Partner;
  partnerOffer?: Maybe<PartnerOfferUnion>;
  reward?: Maybe<PartnerBidReward>;
};

export enum PartnerBidActionChoiceEnum {
  /** Later */
  Later = 'LATER',
  /** No */
  No = 'NO',
  /** Yes */
  Yes = 'YES'
}

/** The connection type for PartnerBid. */
export type PartnerBidConnection = {
  __typename?: 'PartnerBidConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerBidEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PartnerBid>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PartnerBidEdge = {
  __typename?: 'PartnerBidEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PartnerBid>;
};

/** Autogenerated input type of PartnerBidResponse */
export type PartnerBidResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  response: PartnerBidResponseInput1;
};

/** Partner Bid Response Input Object */
export type PartnerBidResponseInput1 = {
  actionChoice: PartnerBidActionChoiceEnum;
  bidId: Scalars['ID']['input'];
};

/** Autogenerated return type of PartnerBidResponse */
export type PartnerBidResponsePayload = {
  __typename?: 'PartnerBidResponsePayload';
  bidResponseId?: Maybe<Scalars['ID']['output']>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<BidResponseError>>;
  offerId?: Maybe<Scalars['ID']['output']>;
  partnerBid?: Maybe<PartnerBid>;
};

export type PartnerBidReward = {
  __typename?: 'PartnerBidReward';
  amount?: Maybe<Scalars['String']['output']>;
  type: PartnerBidRewardEnum;
};

export enum PartnerBidRewardEnum {
  /** United States Dollar */
  Usd = 'USD'
}

export type PartnerNotFoundError = ErrorInterface & {
  __typename?: 'PartnerNotFoundError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type PartnerOfferCategory = {
  __typename?: 'PartnerOfferCategory';
  /** The url for the banner image */
  bannerUrl?: Maybe<Scalars['String']['output']>;
  /** Customized data for a category */
  displayMetadata: PartnerOfferCategoryDisplayMetadata;
  id: Scalars['ID']['output'];
  /** Featured offers inside of a category */
  myFeaturedPartnerOffers1: PartnerOfferUnionConnection;
  /** All offers related to a specific category for a user */
  myFullPartnerOffers1: PartnerOfferUnionConnection;
  /** Offers related to a specific category, with a limit defined */
  myPartnerOffers1: PartnerOfferUnionConnection;
  /** The category name */
  name: Scalars['String']['output'];
  /** The position of the category to be displayed at. */
  priorityOrder?: Maybe<Scalars['Int']['output']>;
};


export type PartnerOfferCategoryMyFeaturedPartnerOffers1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PartnerOfferCategoryMyFullPartnerOffers1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PartnerOfferCategoryMyPartnerOffers1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for PartnerOfferCategory. */
export type PartnerOfferCategoryConnection = {
  __typename?: 'PartnerOfferCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerOfferCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PartnerOfferCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Metadata specific to category */
export type PartnerOfferCategoryDisplayMetadata = {
  __typename?: 'PartnerOfferCategoryDisplayMetadata';
  /**
   * Dynamically determine how the tiles should be displayed/styled per each category on the detail view in the main section.
   * @deprecated Prefer detail_display_styling
   */
  detailDisplayStyle: CategoryDetailDisplayStyleEnum;
  /** Determine how the tiles should be displayed/styled per each category on the detail view in the main section. */
  detailDisplayStyling: PartnerOfferCategoryDisplayStyling;
  /**
   * Dynamically determine how the tiles should be displayed/styled per each category on the detail view in the featured section.
   * @deprecated Prefer featured_display_styling
   */
  featuredDisplayStyle: CategoryFeaturedDisplayStyleEnum;
  /** Determine how the tiles should be displayed/styled per each category on the detail view in the featured section. */
  featuredDisplayStyling: PartnerOfferCategoryDisplayStyling;
  /**
   * Dynamically determine how the tiles should be displayed/styled per each category in the rewards portal view.
   * @deprecated Prefer main_display_styling
   */
  mainDisplayStyle: CategoryMainDisplayStyleEnum;
  /** Determine how the tiles should be displayed/styled per each category in the rewards portal view. */
  mainDisplayStyling: PartnerOfferCategoryDisplayStyling;
  /** The pagination amount to be used when viewing all category offers. This will default to 200. */
  viewAllPaginationAmount: Scalars['Int']['output'];
};

export type PartnerOfferCategoryDisplayStyling = {
  __typename?: 'PartnerOfferCategoryDisplayStyling';
  /** The axis of scrolling to be used for the category. */
  axis: Scalars['String']['output'];
  /** The hex background color to be used for the container */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The style of the card to be used for the category. */
  cardStyle: Scalars['String']['output'];
  /** The number of columns to be used for the category. Only used if axis is vertical. */
  columns?: Maybe<Scalars['Int']['output']>;
  /** The number of rows to be used for the category. Only used if axis is horizontal. */
  rows?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PartnerOfferCategoryEdge = {
  __typename?: 'PartnerOfferCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PartnerOfferCategory>;
};

export enum PartnerOfferCtaClickBehaviorEnum {
  /** External Browser */
  ExternalBrowser = 'EXTERNAL_BROWSER',
  /** Internal Browser */
  InternalBrowser = 'INTERNAL_BROWSER',
  /** Web View */
  Webview = 'WEBVIEW'
}

export type PartnerOfferIcon = {
  __typename?: 'PartnerOfferIcon';
  iconUrl?: Maybe<Scalars['String']['output']>;
  offerId: Scalars['ID']['output'];
};

export type PartnerOfferPotentialRewardTotal = {
  __typename?: 'PartnerOfferPotentialRewardTotal';
  /** The total amount that can be earned from this offer */
  amount: Scalars['String']['output'];
  /** The original value of this offers reward, pre limited time offers */
  originalAmount: Scalars['String']['output'];
  /** The specific type of reward being granted */
  rewardType: PartnerRewardTypeEnum;
};

export type PartnerOfferProgress = {
  __typename?: 'PartnerOfferProgress';
  /** The time the event was completed at */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Human readable name to be displayed */
  displayName: Scalars['String']['output'];
  /** The type of event */
  eventName: Scalars['String']['output'];
  /** If you see a 00000000-0000-0000-0000-000000000000 UUID, that is a temporary placeholder. */
  id: Scalars['ID']['output'];
  /** The max amount of times this event can be completed */
  maxCompletionTimes: Scalars['Int']['output'];
  /** The amount of times this event has been completed */
  timesCompleted: Scalars['Int']['output'];
};

/** The connection type for PartnerOfferProgress. */
export type PartnerOfferProgressConnection = {
  __typename?: 'PartnerOfferProgressConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerOfferProgressEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PartnerOfferProgress>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PartnerOfferProgressEdge = {
  __typename?: 'PartnerOfferProgressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PartnerOfferProgress>;
};

export type PartnerOfferTag = {
  __typename?: 'PartnerOfferTag';
  id: Scalars['ID']['output'];
  /** The tag name */
  name: Scalars['String']['output'];
  /** The position of the tag to be displayed at. */
  priorityOrder?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for PartnerOfferTag. */
export type PartnerOfferTagConnection = {
  __typename?: 'PartnerOfferTagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerOfferTagEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PartnerOfferTag>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PartnerOfferTagEdge = {
  __typename?: 'PartnerOfferTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PartnerOfferTag>;
};

export enum PartnerOfferTypeEnum {
  /** A deal */
  Deal = 'DEAL',
  /** A survey */
  Survey = 'SURVEY'
}

export type PartnerOfferUnion = Deal | Survey;

/** The connection type for PartnerOfferUnion. */
export type PartnerOfferUnionConnection = {
  __typename?: 'PartnerOfferUnionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerOfferUnionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PartnerOfferUnion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PartnerOfferUnionEdge = {
  __typename?: 'PartnerOfferUnionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PartnerOfferUnion>;
};

/** A review submitted by a user for a partner */
export type PartnerReview = {
  __typename?: 'PartnerReview';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  partner: Partner;
  rating: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export enum PartnerRewardTypeEnum {
  /** A fixed reward amount */
  Fixed = 'FIXED',
  /** A percentage of reward */
  Percentage = 'PERCENTAGE'
}

export type PauseCashAdvanceSubscriptionActiveAdvanceError = ErrorInterface & {
  __typename?: 'PauseCashAdvanceSubscriptionActiveAdvanceError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type PauseCashAdvanceSubscriptionCanceledError = ErrorInterface & {
  __typename?: 'PauseCashAdvanceSubscriptionCanceledError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type PauseCashAdvanceSubscriptionErrors = Error | PauseCashAdvanceSubscriptionActiveAdvanceError | PauseCashAdvanceSubscriptionCanceledError | PauseCashAdvanceSubscriptionInactiveError | PauseCashAdvanceSubscriptionNoSubscriptionError;

export type PauseCashAdvanceSubscriptionInactiveError = ErrorInterface & {
  __typename?: 'PauseCashAdvanceSubscriptionInactiveError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PauseCashAdvanceSubscription */
export type PauseCashAdvanceSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type PauseCashAdvanceSubscriptionNoSubscriptionError = ErrorInterface & {
  __typename?: 'PauseCashAdvanceSubscriptionNoSubscriptionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of PauseCashAdvanceSubscription */
export type PauseCashAdvanceSubscriptionPayload = {
  __typename?: 'PauseCashAdvanceSubscriptionPayload';
  cashAdvanceSubscription?: Maybe<CashAdvanceSubscription>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<PauseCashAdvanceSubscriptionErrors>>;
};

export type PauseSubscriptionActiveAdvanceError = ErrorInterface & {
  __typename?: 'PauseSubscriptionActiveAdvanceError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type PauseSubscriptionCanceledError = ErrorInterface & {
  __typename?: 'PauseSubscriptionCanceledError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type PauseSubscriptionErrors = Error | PauseSubscriptionActiveAdvanceError | PauseSubscriptionCanceledError | PauseSubscriptionInactiveError | PauseSubscriptionNoSubscriptionError;

export type PauseSubscriptionInactiveError = ErrorInterface & {
  __typename?: 'PauseSubscriptionInactiveError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PauseSubscription */
export type PauseSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type PauseSubscriptionNoSubscriptionError = ErrorInterface & {
  __typename?: 'PauseSubscriptionNoSubscriptionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of PauseSubscription */
export type PauseSubscriptionPayload = {
  __typename?: 'PauseSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<PauseSubscriptionErrors>>;
  subscription?: Maybe<Subscription>;
};

export type PayOutstandingFeeError = CardInBackoffError | Error | FeeAlreadySettledError | LinkedCardInvalidError | NoOutStandingFeeError | PaymentInProgressError;

/** Autogenerated input type of PayOutstandingFee */
export type PayOutstandingFeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PayOutstandingFee */
export type PayOutstandingFeePayload = {
  __typename?: 'PayOutstandingFeePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<PayOutstandingFeeError>>;
  subscriptionFee?: Maybe<SubscriptionFee>;
};

export enum PaymentAccountChangeAllowedStatus {
  /** Discouraged - Technically allowed, but do not encourage */
  Discouraged = 'DISCOURAGED',
  /** Max account changes reached */
  MaxAccountChangesReached = 'MAX_ACCOUNT_CHANGES_REACHED',
  /** Generic disabled */
  No = 'NO',
  /** OK */
  Ok = 'OK',
  /** Used for cash advance application */
  UsedForCashAdvanceApplication = 'USED_FOR_CASH_ADVANCE_APPLICATION',
  /** Withdrawal in progress */
  WithdrawalInProgress = 'WITHDRAWAL_IN_PROGRESS'
}

export type PaymentAccountLinkedError = ErrorInterface & {
  __typename?: 'PaymentAccountLinkedError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type PaymentAccountLinkedOverLimitError = ErrorInterface & {
  __typename?: 'PaymentAccountLinkedOverLimitError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type PaymentAccountMissingTransferMethodError = ErrorInterface & {
  __typename?: 'PaymentAccountMissingTransferMethodError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export enum PaymentAccountTransferMethod {
  /** ACH transfer. 3-5 Business days */
  Ach = 'ACH',
  /** Instant transfer. Within minutes */
  Card = 'CARD'
}

export type PaymentAccountUnusableError = ErrorInterface & {
  __typename?: 'PaymentAccountUnusableError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export enum PaymentChannelEnum {
  /** Transactions that are processed in a physical store. */
  InStore = 'IN_STORE',
  /** Transactions that are processed online. */
  Online = 'ONLINE',
  /** Transactions that do not fit the categories of in-store or online. */
  Other = 'OTHER'
}

export type PaymentInProgressError = ErrorInterface & {
  __typename?: 'PaymentInProgressError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type Performance = {
  __typename?: 'Performance';
  cash: Scalars['String']['output'];
  cumRealizedPL: Scalars['String']['output'];
  date: Scalars['String']['output'];
  deposits: Scalars['String']['output'];
  equity: Scalars['String']['output'];
  fees: Scalars['String']['output'];
  realizedDayPL: Scalars['String']['output'];
  unrealizedDayPL: Scalars['String']['output'];
  withdrawals: Scalars['String']['output'];
};

/** Phone Input Object */
export type Phone = {
  /** Country Calling Code */
  code: Scalars['Int']['input'];
  /** Phone Number */
  number: Scalars['String']['input'];
};

/** Additional information related to a phone number. This data comes from Twilio using their lookups. */
export type PhoneDetail = WithTimestamps & {
  __typename?: 'PhoneDetail';
  /** The mobile country code based on carrier */
  carrierMobileCountryCode?: Maybe<Scalars['String']['output']>;
  /** The mobile network code based on carrier */
  carrierMobileNetworkCode?: Maybe<Scalars['String']['output']>;
  /** The name of the carrier */
  carrierName?: Maybe<Scalars['String']['output']>;
  /** The type of carrier */
  carrierType?: Maybe<Scalars['String']['output']>;
  /** The country code of this phone number */
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The phone number */
  phone: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The user associated with this phone number. There is a possibility none are associated anymore. */
  user?: Maybe<User>;
};

/** A token to be used when linking Plaid */
export type PlaidLinkToken = {
  __typename?: 'PlaidLinkToken';
  expiration?: Maybe<Scalars['ISO8601DateTime']['output']>;
  linkToken?: Maybe<Scalars['String']['output']>;
};

export type Portfolio = {
  __typename?: 'Portfolio';
  addonInstruments?: Maybe<Array<Maybe<AddonInstrument>>>;
  corePortfolioId: Scalars['ID']['output'];
  corePortfolioName: Scalars['String']['output'];
};

/** Potential campaign reward totals for a user, scoped by partner, sorted by latest message descending. Grand totals returned at top of list (with null partner id). */
export type PotentialCampaignRewardTotal = {
  __typename?: 'PotentialCampaignRewardTotal';
  /** Total amount of potential rewards for the given partner id */
  amount?: Maybe<Scalars['String']['output']>;
  /** The id of a partner; grand total if null */
  partnerId?: Maybe<Scalars['ID']['output']>;
};

/** The connection type for PotentialCampaignRewardTotal. */
export type PotentialCampaignRewardTotalConnection = {
  __typename?: 'PotentialCampaignRewardTotalConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PotentialCampaignRewardTotalEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PotentialCampaignRewardTotal>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PotentialCampaignRewardTotalEdge = {
  __typename?: 'PotentialCampaignRewardTotalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PotentialCampaignRewardTotal>;
};

/** Provider Input Object */
export type Provider = {
  /** Plaid Account ID */
  accountId?: InputMaybe<Scalars['String']['input']>;
  /** Plaid Insitution ID */
  institutionId?: InputMaybe<Scalars['String']['input']>;
  /** Last 4 digits of the account number */
  mask?: InputMaybe<Scalars['String']['input']>;
  /** Plaid Public Token */
  publicToken?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of PublishBackgroundEvent */
export type PublishBackgroundEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  event: ClientEventInput;
};

/** Autogenerated return type of PublishBackgroundEvent */
export type PublishBackgroundEventPayload = {
  __typename?: 'PublishBackgroundEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ClientEventUnionErrors>>;
  /** The successful Request ID */
  eventId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of PublishClientEvent */
export type PublishClientEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  event: ClientEventInput;
};

/** Autogenerated return type of PublishClientEvent */
export type PublishClientEventPayload = {
  __typename?: 'PublishClientEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ClientEventUnionErrors>>;
  /** The successful Request ID */
  eventId?: Maybe<Scalars['ID']['output']>;
};

export type PublishEventError = Error;

/** Autogenerated input type of PublishEvent */
export type PublishEventInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  partnerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of PublishEvent */
export type PublishEventPayload = {
  __typename?: 'PublishEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<PublishEventError>>;
};

/** Autogenerated input type of PublishWebEvent */
export type PublishWebEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  event: ClientEventInput;
};

/** Autogenerated return type of PublishWebEvent */
export type PublishWebEventPayload = {
  __typename?: 'PublishWebEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ClientEventUnionErrors>>;
  /** The successful Request ID */
  eventId?: Maybe<Scalars['ID']['output']>;
};

export type Query = {
  __typename?: 'Query';
  adForPlacement?: Maybe<AdUnion>;
  addDataContainers: Array<Maybe<QuestionContainer>>;
  addonInstrument: AddonInstrument;
  addonInstrumentBar: Array<BarData>;
  addonInstruments: Array<AddonInstrument>;
  adjoeOffers: Array<AdjoeOffer>;
  adjoePromotionTag?: Maybe<AdjoePromotion>;
  adsForPlacement?: Maybe<AdUnionConnection>;
  appSettings: AppSettings;
  appVersionSupported: Scalars['Boolean']['output'];
  availableBids: PartnerBidConnection;
  availableFeatures?: Maybe<AvailableFeatures>;
  balance?: Maybe<Balance>;
  /** Next-7-day overdraft forecast for the cash-advance-linked bank account; null when the user has no scoreable account or the model is unavailable */
  balanceCalendar?: Maybe<BalanceCalendar>;
  bankAccount?: Maybe<BankAccount>;
  /** @deprecated Use monitoredBankAccountTransactions instead */
  bankAccountTransactions: Array<BankAccountTransaction>;
  budgets?: Maybe<Array<Budget>>;
  cashAdvanceActiveRequest?: Maybe<CashAdvanceRequest>;
  cashAdvanceActiveRequests: Array<CashAdvanceRequest>;
  cashAdvanceApplication?: Maybe<CashAdvanceApplication>;
  cashAdvanceApplicationCapability: Scalars['Boolean']['output'];
  cashAdvanceApprovedAmount: CashAdvanceApprovedAmount;
  cashAdvanceAsapFeeSchedule: Array<CashAdvanceFeeSchedule>;
  cashAdvanceQuote: CashAdvanceRequest;
  cashAdvanceRequests: Array<CashAdvanceRequest>;
  cashAdvanceSubscription?: Maybe<CashAdvanceSubscription>;
  cashAdvanceTransactions?: Maybe<TransactionConnection>;
  checkIdentifier: CheckIdentifierResult;
  customCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIntegrity: DeviceIntegrity;
  featuredQuestions: Array<Maybe<QuestionResult>>;
  financialInsights?: Maybe<Array<FinancialInsight>>;
  findPartnerOffer1?: Maybe<PartnerOfferUnion>;
  findPartnerOfferCategoryById?: Maybe<PartnerOfferCategory>;
  homeScreen?: Maybe<HomeScreen>;
  investmentAccountPerformance: Array<Performance>;
  investmentAccountPerformanceAggregated: AccountPerformance;
  keepAccessSubscriptionAllowed: Scalars['Boolean']['output'];
  marketStatus: MarketStatus;
  /** @deprecated Unpaged and scheduled for a hard page cap. Use monitoredBankAccountTransactionsConnection. */
  monitoredBankAccountTransactions: Array<MonitoredBankAccountTransaction>;
  monitoredBankAccountTransactionsConnection: MonitoredBankAccountTransactionConnection;
  monitoredBankAccounts?: Maybe<Array<MonitoredBankAccount>>;
  nextAvailableDataContainer?: Maybe<QuestionContainer>;
  offerForPlacement1?: Maybe<PartnerOfferUnion>;
  offerSearch?: Maybe<PartnerOfferUnionConnection>;
  offersForPlacement?: Maybe<PartnerOfferUnionConnection>;
  onboardingQuestionContainers: Array<Maybe<QuestionContainer>>;
  /** Get information about another user */
  otherUser?: Maybe<OtherUser>;
  partnerIconsByOfferIds: Array<PartnerOfferIcon>;
  partners: Array<Partner>;
  paymentAccountChangeAllowed: PaymentAccountChangeAllowedStatus;
  paymentAccounts?: Maybe<Array<BankAccount>>;
  publicOffersForPlacement?: Maybe<PartnerOfferUnionConnection>;
  publicOffersForUrl?: Maybe<PartnerOfferUnionConnection>;
  questionContainers: Array<Maybe<QuestionContainer>>;
  recentTransactions?: Maybe<TransactionConnection>;
  recommendedOffers?: Maybe<PartnerOfferUnionConnection>;
  recurringTransactions?: Maybe<Array<RecurringTransaction>>;
  referral?: Maybe<Referral>;
  rewardsLeaderboard?: Maybe<Leaderboard>;
  sharedUser?: Maybe<SharedUser>;
  similarOffers?: Maybe<PartnerOfferUnionConnection>;
  /** Recent rewards of at least $2 that users earned in the last 24 hours, newest first, one per user */
  socialEarnings: Array<SocialEarning>;
  statementUrl: Scalars['String']['output'];
  statementsConfirms: Array<Statement>;
  statementsMonthly: Array<Statement>;
  statementsTaxforms: Array<Statement>;
  streakDetails?: Maybe<StreakDetails>;
  streakstakesEvents?: Maybe<Array<StreakstakesEvent>>;
  subscriptionFeesOutstanding?: Maybe<Array<SubscriptionFee>>;
  subscriptionProducts?: Maybe<Array<SubscriptionProduct>>;
  subscriptions?: Maybe<Array<Subscription>>;
  transactionExport: TransactionExport;
  user?: Maybe<User>;
  userDataContainers: Array<Maybe<QuestionContainer>>;
  withdrawalCapability?: Maybe<WithdrawalCapability>;
  withdrawalFeeQuotes: Array<WithdrawalFeeQuote>;
};


export type QueryAdForPlacementArgs = {
  adId?: InputMaybe<Scalars['ID']['input']>;
  placementId: Scalars['ID']['input'];
  supportedAdAttributes?: InputMaybe<AdAttributesInput>;
  supportedAdTypes: Array<AdTypeEnum>;
};


export type QueryAddonInstrumentArgs = {
  symbol: Scalars['ID']['input'];
};


export type QueryAddonInstrumentBarArgs = {
  compression: CompressionEnum;
  period: Scalars['String']['input'];
  symbol: Scalars['ID']['input'];
};


export type QueryAdjoeOffersArgs = {
  category?: InputMaybe<AdjoeCategoryEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<AdjoeOfferSortFieldEnum>;
};


export type QueryAdsForPlacementArgs = {
  adId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placementId: Scalars['ID']['input'];
  supportedAdAttributes?: InputMaybe<AdAttributesInput>;
  supportedAdTypes: Array<AdTypeEnum>;
};


export type QueryAppVersionSupportedArgs = {
  platform: ClientPlatformEnum;
  version: Scalars['String']['input'];
};


export type QueryAvailableBidsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBankAccountTransactionsArgs = {
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  merchant?: InputMaybe<Scalars['String']['input']>;
  primaryCategory?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<BankAccountTransactionSort>;
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryBudgetsArgs = {
  month?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryCashAdvanceQuoteArgs = {
  amount: Scalars['String']['input'];
  tip?: InputMaybe<Scalars['String']['input']>;
  transferType: CashAdvanceRequestTransferType;
};


export type QueryCashAdvanceTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckIdentifierArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Phone>;
  provider?: InputMaybe<OAuthProviderEnum>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeaturedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFinancialInsightsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindPartnerOffer1Args = {
  id: Scalars['ID']['input'];
  servedImpressionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFindPartnerOfferCategoryByIdArgs = {
  id: Scalars['ID']['input'];
  placementId?: InputMaybe<Scalars['ID']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHomeScreenArgs = {
  layoutVersion?: InputMaybe<HomeScreenLayoutVersion>;
};


export type QueryInvestmentAccountPerformanceArgs = {
  accountId: Scalars['ID']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvestmentAccountPerformanceAggregatedArgs = {
  accountId: Scalars['ID']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKeepAccessSubscriptionAllowedArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};


export type QueryMonitoredBankAccountTransactionsArgs = {
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  merchant?: InputMaybe<Scalars['String']['input']>;
  monitoredBankAccountId?: InputMaybe<Scalars['ID']['input']>;
  primaryCategory?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<BankAccountTransactionSort>;
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryMonitoredBankAccountTransactionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  merchant?: InputMaybe<Scalars['String']['input']>;
  monitoredBankAccountId?: InputMaybe<Scalars['ID']['input']>;
  primaryCategory?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<BankAccountTransactionSort>;
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryNextAvailableDataContainerArgs = {
  placementName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOfferForPlacement1Args = {
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  placementId: Scalars['ID']['input'];
};


export type QueryOfferSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryOffersForPlacementArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placementId: Scalars['ID']['input'];
  tagId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOtherUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerIconsByOfferIdsArgs = {
  offerIds: Array<Scalars['ID']['input']>;
};


export type QueryPartnersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPaymentAccountChangeAllowedArgs = {
  transferMethod: PaymentAccountTransferMethod;
};


export type QueryPaymentAccountsArgs = {
  includeUnlinked?: InputMaybe<Scalars['Boolean']['input']>;
  transferMethod?: InputMaybe<PaymentAccountTransferMethod>;
};


export type QueryPublicOffersForPlacementArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  partnerOfferId?: InputMaybe<Scalars['ID']['input']>;
  placementId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublicOffersForUrlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placementId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};


export type QueryQuestionContainersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryRecentTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecommendedOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placementId: Scalars['ID']['input'];
};


export type QueryRewardsLeaderboardArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: LeaderboardPeriodEnum;
  type: LeaderboardTypeEnum;
};


export type QuerySimilarOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offerId: Scalars['ID']['input'];
  placementId: Scalars['ID']['input'];
};


export type QuerySocialEarningsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStatementUrlArgs = {
  accountId: Scalars['ID']['input'];
  fileKey: Scalars['String']['input'];
};


export type QueryStatementsConfirmsArgs = {
  accountId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStatementsMonthlyArgs = {
  accountId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStatementsTaxformsArgs = {
  accountId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTransactionExportArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryWithdrawalFeeQuotesArgs = {
  amount: Scalars['Float']['input'];
};

/** Question Input Which Can Be Rendered */
export type Question = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type QuestionAnswerResult = {
  __typename?: 'QuestionAnswerResult';
  percentage: Scalars['Float']['output'];
  responseText: Scalars['String']['output'];
};

export type QuestionContainer = {
  __typename?: 'QuestionContainer';
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonTooltipText?: Maybe<Scalars['String']['output']>;
  category: Category;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions?: Maybe<Array<Question>>;
};

export type QuestionImage = {
  __typename?: 'QuestionImage';
  url: Scalars['String']['output'];
};

/** Data Vault Question Response Input Object */
export type QuestionResponse = {
  questionId: Scalars['ID']['input'];
  response: Scalars['String']['input'];
};

export type QuestionResult = {
  __typename?: 'QuestionResult';
  answerResults: Array<QuestionAnswerResult>;
  currentUserResponse?: Maybe<Scalars['String']['output']>;
  questionText: Scalars['String']['output'];
};

export type RateLimitExceeded = ErrorInterface & {
  __typename?: 'RateLimitExceeded';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type RateLimitExceededError = ErrorInterface & {
  __typename?: 'RateLimitExceededError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type RecurringTransaction = {
  __typename?: 'RecurringTransaction';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  firstTransactionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  frequency: RecurringTransactionFrequencyEnum;
  id: Scalars['ID']['output'];
  lastTransactionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  merchantLogoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nextTransactionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  transactionCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export enum RecurringTransactionFrequencyEnum {
  /** Occurs every year */
  Annually = 'ANNUALLY',
  /** Occurs every 2 weeks */
  Biweekly = 'BIWEEKLY',
  /** Occurs every month */
  Monthly = 'MONTHLY',
  /** Occurs twice a month */
  Semimonthly = 'SEMIMONTHLY',
  /** Occurs every week */
  Weekly = 'WEEKLY'
}

export type Referral = {
  __typename?: 'Referral';
  code: Scalars['String']['output'];
  history: Array<ReferralHistory>;
  referrerName?: Maybe<Scalars['String']['output']>;
  rewardAmount: Scalars['String']['output'];
  rewardCriteria: ReferralRewardCriteriaEnum;
  rewardCriteriaDescription: Scalars['String']['output'];
};

export type ReferralHistory = {
  __typename?: 'ReferralHistory';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  qualifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  referralId?: Maybe<Scalars['ID']['output']>;
  rewardCriteria: ReferralRewardCriteriaEnum;
};

export type ReferralNotFoundError = ErrorInterface & {
  __typename?: 'ReferralNotFoundError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export enum ReferralRewardCriteriaEnum {
  /** Account Strength */
  AccountStrength = 'ACCOUNT_STRENGTH',
  /** Bank Link */
  BankLink = 'BANK_LINK',
  /** Invest Account */
  InvestAccount = 'INVEST_ACCOUNT',
  /** Register */
  Register = 'REGISTER',
  /** Subscription */
  Subscription = 'SUBSCRIPTION'
}

export type RefreshTransactionsErrors = Error | RefreshTransactionsUnauthorizedError;

/** Autogenerated input type of RefreshTransactions */
export type RefreshTransactionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RefreshTransactions */
export type RefreshTransactionsPayload = {
  __typename?: 'RefreshTransactionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RefreshTransactionsErrors>>;
  success: Scalars['Boolean']['output'];
};

export type RefreshTransactionsUnauthorizedError = ErrorInterface & {
  __typename?: 'RefreshTransactionsUnauthorizedError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type RefreshUserSessionError = Error | InvalidRefreshTokenError;

/** Autogenerated input type of RefreshUserSession */
export type RefreshUserSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  refreshToken: Scalars['String']['input'];
};

/** Autogenerated return type of RefreshUserSession */
export type RefreshUserSessionPayload = {
  __typename?: 'RefreshUserSessionPayload';
  authentication?: Maybe<Authentication>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RefreshUserSessionError>>;
};

export type RegistrationCompleteError = Error;

/** Autogenerated input type of RegistrationComplete */
export type RegistrationCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RegistrationComplete */
export type RegistrationCompletePayload = {
  __typename?: 'RegistrationCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RegistrationCompleteError>>;
};

export type RelinkPaymentAccountAlreadyLinkedError = ErrorInterface & {
  __typename?: 'RelinkPaymentAccountAlreadyLinkedError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type RelinkPaymentAccountCommonError = ErrorInterface & {
  __typename?: 'RelinkPaymentAccountCommonError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type RelinkPaymentAccountErrors = Error | RelinkPaymentAccountAlreadyLinkedError | RelinkPaymentAccountCommonError | RelinkPaymentAccountNotCardError | RelinkPaymentAccountNotFoundError;

/** Autogenerated input type of RelinkPaymentAccount */
export type RelinkPaymentAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentAccountId: Scalars['ID']['input'];
};

export type RelinkPaymentAccountNotCardError = ErrorInterface & {
  __typename?: 'RelinkPaymentAccountNotCardError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type RelinkPaymentAccountNotFoundError = ErrorInterface & {
  __typename?: 'RelinkPaymentAccountNotFoundError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of RelinkPaymentAccount */
export type RelinkPaymentAccountPayload = {
  __typename?: 'RelinkPaymentAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RelinkPaymentAccountErrors>>;
  paymentAccount?: Maybe<BankAccount>;
};

export type RemoveAddonError = Error;

/** Autogenerated input type of RemoveAddon */
export type RemoveAddonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  investmentAccountId: Scalars['ID']['input'];
  symbol: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveAddon */
export type RemoveAddonPayload = {
  __typename?: 'RemoveAddonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RemoveAddonError>>;
  investmentAccount?: Maybe<InvestmentAccount>;
};

export type RepayCashAdvanceRequestError = Error;

/** Autogenerated input type of RepayCashAdvanceRequest */
export type RepayCashAdvanceRequestInput = {
  cashAdvanceRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  transferType?: InputMaybe<CashAdvanceRepaymentTransferType>;
};

/** Autogenerated return type of RepayCashAdvanceRequest */
export type RepayCashAdvanceRequestPayload = {
  __typename?: 'RepayCashAdvanceRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RepayCashAdvanceRequestError>>;
  success: Scalars['Boolean']['output'];
};

export type ResendEmailVerificationError = Error;

/** Autogenerated input type of ResendEmailVerification */
export type ResendEmailVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ResendEmailVerification */
export type ResendEmailVerificationPayload = {
  __typename?: 'ResendEmailVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ResendEmailVerificationError>>;
};

export type ResendPhoneVerificationError = Error;

/** Autogenerated input type of ResendPhoneVerification */
export type ResendPhoneVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ResendPhoneVerification */
export type ResendPhoneVerificationPayload = {
  __typename?: 'ResendPhoneVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ResendPhoneVerificationError>>;
};

export type ResetPasswordError = Error;

/** Autogenerated input type of ResetPassword */
export type ResetPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};

/** Autogenerated return type of ResetPassword */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ResetPasswordError>>;
};

export type ResubmitInvestmentApplicationError = Error;

/** Autogenerated input type of ResubmitInvestmentApplication */
export type ResubmitInvestmentApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  investmentAccountId: Scalars['ID']['input'];
  investmentApplication: InvestmentApplicationInput;
};

/** Autogenerated return type of ResubmitInvestmentApplication */
export type ResubmitInvestmentApplicationPayload = {
  __typename?: 'ResubmitInvestmentApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ResubmitInvestmentApplicationError>>;
  investmentAccount?: Maybe<InvestmentAccount>;
};

export type ResumeSubscriptionActiveError = ErrorInterface & {
  __typename?: 'ResumeSubscriptionActiveError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type ResumeSubscriptionCanceledError = ErrorInterface & {
  __typename?: 'ResumeSubscriptionCanceledError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type ResumeSubscriptionErrors = Error | ResumeSubscriptionActiveError | ResumeSubscriptionCanceledError | ResumeSubscriptionLinkedCardUnhealthyError | ResumeSubscriptionNoSubscriptionError;

/** Autogenerated input type of ResumeSubscription */
export type ResumeSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type ResumeSubscriptionLinkedCardUnhealthyError = ErrorInterface & {
  __typename?: 'ResumeSubscriptionLinkedCardUnhealthyError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type ResumeSubscriptionNoSubscriptionError = ErrorInterface & {
  __typename?: 'ResumeSubscriptionNoSubscriptionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of ResumeSubscription */
export type ResumeSubscriptionPayload = {
  __typename?: 'ResumeSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ResumeSubscriptionErrors>>;
  subscription?: Maybe<Subscription>;
};

export type RunCashAdvanceEvaluationErrors = Error | EvaluationAlreadyRunError | NoPaymentAccountError | PaymentAccountUnusableError;

/** Autogenerated input type of RunCashAdvanceEvaluation */
export type RunCashAdvanceEvaluationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RunCashAdvanceEvaluation */
export type RunCashAdvanceEvaluationPayload = {
  __typename?: 'RunCashAdvanceEvaluationPayload';
  cashAdvanceEvaluation?: Maybe<CashAdvanceEvaluation>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RunCashAdvanceEvaluationErrors>>;
};

export type SameBankAccountError = ErrorInterface & {
  __typename?: 'SameBankAccountError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type SaveError = ErrorInterface & {
  __typename?: 'SaveError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type SendSignInSmsError = Error;

/** Autogenerated input type of SendSignInSMS */
export type SendSignInSmsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Phone>;
};

/** Autogenerated return type of SendSignInSMS */
export type SendSignInSmsPayload = {
  __typename?: 'SendSignInSMSPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<SendSignInSmsError>>;
};

export type SetOverridesErrors = Error | GenericError | SaveError | TransactionNotFoundError;

/** Autogenerated input type of SetOverrides */
export type SetOverridesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ignored?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetOverrides */
export type SetOverridesPayload = {
  __typename?: 'SetOverridesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<SetOverridesErrors>>;
};

export type SetUserAttributionError = Error | InvalidUserAttributionError;

/** Autogenerated input type of SetUserAttribution */
export type SetUserAttributionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userAttribution: UserAttributionInput;
};

/** Autogenerated return type of SetUserAttribution */
export type SetUserAttributionPayload = {
  __typename?: 'SetUserAttributionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<SetUserAttributionError>>;
};

export type SharedUser = {
  __typename?: 'SharedUser';
  /** Active experiments for a user. */
  activeExperiments?: Maybe<Array<ActiveExperiment>>;
  id: Scalars['ID']['output'];
  /** All the categories for a shared user */
  myCategories?: Maybe<PartnerOfferCategoryConnection>;
  /** All partner offer tags */
  myPartnerTags?: Maybe<PartnerOfferTagConnection>;
};


export type SharedUserMyCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};


export type SharedUserMyPartnerTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SignInUserError = Error;

/** Autogenerated input type of SignInUser */
export type SignInUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Phone>;
  smsVerificationCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SignInUser */
export type SignInUserPayload = {
  __typename?: 'SignInUserPayload';
  authentication?: Maybe<Authentication>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<SignInUserError>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of SignOutUser */
export type SignOutUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type SkipContainerError = Error;

/** Autogenerated input type of SkipContainer */
export type SkipContainerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  containerId: Scalars['ID']['input'];
};

/** Autogenerated return type of SkipContainer */
export type SkipContainerPayload = {
  __typename?: 'SkipContainerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<SkipContainerError>>;
};

export type SocialEarning = {
  __typename?: 'SocialEarning';
  amount: Scalars['Float']['output'];
  /** e.g. "Jane D." */
  displayName: Scalars['String']['output'];
  earnedAt: Scalars['ISO8601DateTime']['output'];
  firstName: Scalars['String']['output'];
  /** Obfuscated id, stable per reward */
  id: Scalars['ID']['output'];
  /** Partner icon, when known */
  imageUrl?: Maybe<Scalars['String']['output']>;
  kind: SocialEarningKindEnum;
  /** e.g. "D.", empty when the user has no last name */
  lastInitial: Scalars['String']['output'];
  /** Partner or game name, when known */
  title?: Maybe<Scalars['String']['output']>;
};

/** What a user did to earn a social earning feed reward */
export enum SocialEarningKindEnum {
  /** Playing a game */
  Game = 'GAME',
  /** Completing a partner offer */
  Offer = 'OFFER',
  /** Completing a survey */
  Survey = 'SURVEY'
}

export type Statement = {
  __typename?: 'Statement';
  displayName: Scalars['String']['output'];
  fileKey: Scalars['ID']['output'];
};

export type StreakActionCount = {
  __typename?: 'StreakActionCount';
  actionCount: Scalars['Int']['output'];
  source: TransactionSourceEnum;
};

export type StreakActionSummary = {
  __typename?: 'StreakActionSummary';
  actions: Array<StreakActionCount>;
  date: Scalars['ISO8601Date']['output'];
};

export type StreakDetails = {
  __typename?: 'StreakDetails';
  currentStreakDays?: Maybe<Scalars['Int']['output']>;
  dailyActionSummary?: Maybe<Array<StreakActionSummary>>;
  longestStreakDays?: Maybe<Scalars['Int']['output']>;
};

export enum StreaksSourceEnum {
  /** Colony Dividends */
  ColonyDividends = 'ColonyDividends',
  /** Course Dividends */
  CourseDividends = 'CourseDividends',
  /** Data Reward */
  DataReward = 'DataReward',
  /** Game Dividends */
  GameDividends = 'GameDividends',
  /** Location Dividends */
  LocationDividends = 'LocationDividends',
  /** Reward Dividends */
  RewardDividends = 'RewardDividends',
  /** Streak Bonus */
  StreakBonus = 'StreakBonus',
  /** Survey Dividends */
  SurveyDividends = 'SurveyDividends',
  /** Widget Bonus */
  WidgetBonus = 'WidgetBonus'
}

export type StreakstakesEntry = {
  __typename?: 'StreakstakesEntry';
  entryCount: Scalars['Int']['output'];
  source: StreaksSourceEnum;
};

export type StreakstakesEvent = {
  __typename?: 'StreakstakesEvent';
  endDate: Scalars['ISO8601DateTime']['output'];
  entries?: Maybe<Array<StreakstakesEntry>>;
  /** @deprecated User prizeTiers instead */
  prizeAmount: Scalars['Int']['output'];
  prizeTiers: Array<StreakstakesPrizeTier>;
  /** @deprecated Use prizeTiers instead */
  prizeWinners: Scalars['Int']['output'];
  startDate: Scalars['ISO8601DateTime']['output'];
  winners?: Maybe<Array<StreakstakesWinner>>;
};

export type StreakstakesPrizeTier = {
  __typename?: 'StreakstakesPrizeTier';
  amount: Scalars['Int']['output'];
  numberOfWinners: Scalars['Int']['output'];
};

export type StreakstakesWinner = {
  __typename?: 'StreakstakesWinner';
  amount: Scalars['Int']['output'];
  entryCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type StyledButton = {
  __typename?: 'StyledButton';
  buttonColor?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type SubmitCashAdvanceApplicationError = Error;

/** Autogenerated input type of SubmitCashAdvanceApplication */
export type SubmitCashAdvanceApplicationInput = {
  cashAdvanceApplicationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubmitCashAdvanceApplication */
export type SubmitCashAdvanceApplicationPayload = {
  __typename?: 'SubmitCashAdvanceApplicationPayload';
  cashAdvanceApplication?: Maybe<CashAdvanceApplication>;
  cashAdvanceEvaluation?: Maybe<CashAdvanceEvaluation>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<SubmitCashAdvanceApplicationError>>;
};

export type SubmitIntegrityResponseError = Error;

/** Autogenerated input type of SubmitIntegrityResponse */
export type SubmitIntegrityResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientResponse: Scalars['String']['input'];
};

/** Autogenerated return type of SubmitIntegrityResponse */
export type SubmitIntegrityResponsePayload = {
  __typename?: 'SubmitIntegrityResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deviceIntegrity: DeviceIntegrity;
  errors?: Maybe<Array<SubmitIntegrityResponseError>>;
};

export type SubmitInvestmentApplicationError = Error;

/** Autogenerated input type of SubmitInvestmentApplication */
export type SubmitInvestmentApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  investmentApplication: InvestmentApplicationInput;
};

/** Autogenerated return type of SubmitInvestmentApplication */
export type SubmitInvestmentApplicationPayload = {
  __typename?: 'SubmitInvestmentApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<SubmitInvestmentApplicationError>>;
  investmentAccount?: Maybe<InvestmentAccount>;
};

export type Subscription = {
  __typename?: 'Subscription';
  activeAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  inactiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  initialFeeChargedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextCalculatedFee: CalculatedFee;
  nextFeeChargedAt: Scalars['ISO8601DateTime']['output'];
  product: SubscriptionProduct;
  productKey: SubscriptionProductEnum;
  proratedRefundAmount?: Maybe<Scalars['Float']['output']>;
  status: CashAdvanceSubscriptionStatus;
};

export type SubscriptionFee = {
  __typename?: 'SubscriptionFee';
  amount: Scalars['Float']['output'];
  chargedAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastPaymentAttemptAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum SubscriptionFeeSchedule {
  /** Monthly */
  Monthly = 'monthly',
  /** Weekly */
  Weekly = 'weekly'
}

export type SubscriptionProduct = {
  __typename?: 'SubscriptionProduct';
  description: Scalars['String']['output'];
  features: Array<SubscriptionProductFeature>;
  fee: Scalars['Float']['output'];
  feeSchedule: SubscriptionFeeSchedule;
  footnotes: Array<Scalars['String']['output']>;
  key: SubscriptionProductEnum;
  name: Scalars['String']['output'];
  trialDurationDays: Scalars['Int']['output'];
};

export enum SubscriptionProductEnum {
  /** Cash Advance */
  InstantCash = 'instant_cash',
  /** Personal Finance Trial */
  PersonalFinanceTrial = 'personal_finance_trial',
  /** ATM Premium */
  Premium = 'premium',
  /** Just for testing */
  WeeklyTest = 'weekly_test'
}

export type SubscriptionProductFeature = {
  __typename?: 'SubscriptionProductFeature';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Survey = BasePartnerOffer & WithTimestamps & {
  __typename?: 'Survey';
  /** The card description for an offer */
  cardDescription?: Maybe<Scalars['String']['output']>;
  /** The card headline for an offer */
  cardHeadline?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The call to action of an offer */
  cta?: Maybe<Scalars['String']['output']>;
  /** The click url for a user offer */
  ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum;
  /** The click url for a user offer */
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Details about an offer */
  description?: Maybe<Scalars['String']['output']>;
  /** Legal notice related an offer in Markdown syntax. Normally includes Terms and Conditions */
  disclosure?: Maybe<Scalars['String']['output']>;
  /**
   * The click url for a user offer
   * @deprecated Prefer cta_click_behavior instead
   */
  externalCtaUrl: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The response the user made for this offer */
  myResponse?: Maybe<UserPartnerBidResponse>;
  /** The type of offer */
  offerType: PartnerOfferTypeEnum;
  /** The partner for an offer */
  partner: Partner;
  /** The potential reward for this offer that can be earned. */
  potentialRewardTotal?: Maybe<PartnerOfferPotentialRewardTotal>;
  /** The savings amount for this offer */
  savingsAmount?: Maybe<Scalars['String']['output']>;
  /** The Served Impression ID that was served to the user. */
  servedImpressionId: Scalars['ID']['output'];
  /** Whether or not to skip the offer details page */
  skipOfferDetails: Scalars['Boolean']['output'];
  /** The url linking to the terms and conditions for an offer */
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  /** The time it takes to complete the survey (in minutes by default) */
  timeToComplete?: Maybe<Scalars['String']['output']>;
  /** Whether the provider marks the survey as a top survey */
  top?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SurveyProvider = {
  __typename?: 'SurveyProvider';
  key: Scalars['String']['output'];
  qualifier?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

export type SwitchSubscriptionError = Error | InvalidSubscriptionTransitionError;

/** Autogenerated input type of SwitchSubscription */
export type SwitchSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newProductKey: SubscriptionProductEnum;
  subscriptionId: Scalars['ID']['input'];
};

/** Autogenerated return type of SwitchSubscription */
export type SwitchSubscriptionPayload = {
  __typename?: 'SwitchSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<SwitchSubscriptionError>>;
  subscription?: Maybe<Subscription>;
};

/** TabaPay Card Input Object */
export type TabaPayCard = {
  /** Encrypted card data */
  encryptedCardData?: InputMaybe<Scalars['String']['input']>;
  /** ID of the key used to excrypt the card */
  encryptedCardKeyId?: InputMaybe<Scalars['String']['input']>;
  /** Card token returned by the TabaPay iframe (used when linking cards from the web) */
  iframeToken?: InputMaybe<Scalars['String']['input']>;
};

/** Base Transaction Type */
export type Transaction = {
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Transaction. */
export type TransactionConnection = {
  __typename?: 'TransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TransactionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Transaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TransactionEdge = {
  __typename?: 'TransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Transaction>;
};

export type TransactionExport = {
  __typename?: 'TransactionExport';
  /** CSV content of the transaction export */
  csv: Scalars['String']['output'];
};

export type TransactionNotFoundError = ErrorInterface & {
  __typename?: 'TransactionNotFoundError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export enum TransactionSourceEnum {
  /** Colony Dividends */
  ColonyDividends = 'ColonyDividends',
  /** Course Dividends */
  CourseDividends = 'CourseDividends',
  /** Data Reward */
  DataReward = 'DataReward',
  /** Game Dividends */
  GameDividends = 'GameDividends',
  /** Location Dividends */
  LocationDividends = 'LocationDividends',
  /** Reward Dividends */
  RewardDividends = 'RewardDividends',
  /** Survey Dividends */
  SurveyDividends = 'SurveyDividends'
}

export enum TransactionStatusEnum {
  /** Charged Back */
  ChargeBack = 'ChargeBack',
  /** Earned */
  Earned = 'Earned',
  /** Failed */
  Failed = 'Failed',
  /** On Hold */
  Hold = 'Hold',
  /** Pending */
  Pending = 'Pending',
  /** Pending */
  PendingEarned = 'PendingEarned',
  /** Settled */
  Settled = 'Settled',
  /** Pending */
  TransferPending = 'TransferPending',
  /** Voided */
  Voided = 'Voided'
}

export type TypeCount = {
  __typename?: 'TypeCount';
  count: Scalars['Int']['output'];
  type: LeaderboardTypeEnum;
};

export type UnknownError = ErrorInterface & {
  __typename?: 'UnknownError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type UnlinkAccountErrors = AccountNotFoundError | Error | PaymentAccountLinkedError | UnlinkError;

/** Autogenerated input type of UnlinkAccount */
export type UnlinkAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the monitored bank account to unlink */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlinkAccount */
export type UnlinkAccountPayload = {
  __typename?: 'UnlinkAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UnlinkAccountErrors>>;
  monitoredBankAccounts?: Maybe<Array<MonitoredBankAccount>>;
};

export type UnlinkBankAccountError = Error;

/** Autogenerated input type of UnlinkBankAccount */
export type UnlinkBankAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlinkBankAccount */
export type UnlinkBankAccountPayload = {
  __typename?: 'UnlinkBankAccountPayload';
  bankAccount?: Maybe<BankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UnlinkBankAccountError>>;
};

export type UnlinkError = ErrorInterface & {
  __typename?: 'UnlinkError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateFinancialInsightStatus */
export type UpdateFinancialInsightStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dismiss?: InputMaybe<Scalars['Boolean']['input']>;
  insightId: Scalars['ID']['input'];
  markActioned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateFinancialInsightStatus */
export type UpdateFinancialInsightStatusPayload = {
  __typename?: 'UpdateFinancialInsightStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UpdateInsightErrors>>;
  insight?: Maybe<FinancialInsight>;
};

export type UpdateInsightError = ErrorInterface & {
  __typename?: 'UpdateInsightError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateInsightErrors = Error | InsightNotFoundError | UpdateInsightError;

export type UpdatePaymentAccountError = Error;

export type UpdatePaymentAccountExpirationError = AccountDoesNotMatchError | AccountTypeError | AddressVerificationError | BadRequest | CvvVerificationError | CardDeclinedError | CardHolderNameVerificationError | CommonError | Conflict | DuplicateCardOtherUserError | DuplicateCardSameUserError | Error | InvalidAddressError | InvalidCardNumberError | InvalidExpirationDateError | MissingCardDataError | MissingUserDataError | PaymentAccountLinkedOverLimitError;

/** Autogenerated input type of UpdatePaymentAccountExpiration */
export type UpdatePaymentAccountExpirationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  tabaPayCard?: InputMaybe<TabaPayCard>;
};

/** Autogenerated return type of UpdatePaymentAccountExpiration */
export type UpdatePaymentAccountExpirationPayload = {
  __typename?: 'UpdatePaymentAccountExpirationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UpdatePaymentAccountExpirationError>>;
  paymentAccount?: Maybe<BankAccount>;
};

/** Autogenerated input type of UpdatePaymentAccount */
export type UpdatePaymentAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  requireReauth?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdatePaymentAccount */
export type UpdatePaymentAccountPayload = {
  __typename?: 'UpdatePaymentAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UpdatePaymentAccountError>>;
  paymentAccount?: Maybe<BankAccount>;
};

export type UpdatePhoneError = Error;

/** Autogenerated input type of UpdatePhone */
export type UpdatePhoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phone: Phone;
};

/** Autogenerated return type of UpdatePhone */
export type UpdatePhonePayload = {
  __typename?: 'UpdatePhonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UpdatePhoneError>>;
};

export type UpdateUserError = Error;

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['ISO8601Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUser */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UpdateUserError>>;
  user?: Maybe<User>;
};

/** Input Type for updating a recurring deposit */
export type UpdateUserRecurringDeposit = {
  amount?: InputMaybe<Scalars['String']['input']>;
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  depositInterval?: InputMaybe<DepositIntervalEnum>;
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateUserRecurringDeposit */
export type UpdateUserRecurringDepositInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recurringDeposit: UpdateUserRecurringDeposit;
};

/** Autogenerated return type of UpdateUserRecurringDeposit */
export type UpdateUserRecurringDepositPayload = {
  __typename?: 'UpdateUserRecurringDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userRecurringDeposit?: Maybe<UserRecurringDepositConfiguration>;
};

export type UpsertBudgetErrors = BudgetNotFoundError | Error | GenericBudgetError;

/** Autogenerated input type of UpsertBudget */
export type UpsertBudgetInput = {
  amount: Scalars['Float']['input'];
  category: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inactiveAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  month: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of UpsertBudget */
export type UpsertBudgetPayload = {
  __typename?: 'UpsertBudgetPayload';
  budget?: Maybe<Budget>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UpsertBudgetErrors>>;
};

export type UpsertUserFeatureOptInError = Error;

/** Autogenerated input type of UpsertUserFeatureOptIn */
export type UpsertUserFeatureOptInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feature: Scalars['String']['input'];
  optedIn?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpsertUserFeatureOptIn */
export type UpsertUserFeatureOptInPayload = {
  __typename?: 'UpsertUserFeatureOptInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UpsertUserFeatureOptInError>>;
  userFeatureOptIn?: Maybe<UserFeatureOptIn>;
};

export type UsedForCashAdvanceApplicationError = ErrorInterface & {
  __typename?: 'UsedForCashAdvanceApplicationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  accountTaskLists?: Maybe<AccountTaskListConnection>;
  /** Active experiments for a user. */
  activeExperiments?: Maybe<Array<ActiveExperiment>>;
  addresses?: Maybe<Array<Address>>;
  bonusTaskLists?: Maybe<Array<BonusTaskList>>;
  broker?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has completed all the demographic DataVault container questions. */
  completedDemographicQuestions: Scalars['Boolean']['output'];
  confirmationSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dailyTaskList?: Maybe<DailyTaskList>;
  directorOf?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated Naming */
  eligibleForWithdrawal: Array<WithdrawalEligibilityEnum>;
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  employmentStatus?: Maybe<EmploymentStatusEnum>;
  featureOptIns?: Maybe<Array<UserFeatureOptIn>>;
  /** When the user first submitted a cash advance application */
  firstCashAdvanceApplicationSubmittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the earliest bank account used on a cash advance application was linked */
  firstCashAdvanceBankLinkedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the user created their first cash advance request */
  firstCashAdvanceRequestAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  investmentAccounts?: Maybe<Array<InvestmentAccount>>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** All the categories for a user */
  myCategories?: Maybe<PartnerOfferCategoryConnection>;
  /** All partner offer tags */
  myPartnerTags?: Maybe<PartnerOfferTagConnection>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneConfirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Additional details related to your phone number. */
  phoneDetail?: Maybe<PhoneDetail>;
  politicallyExposedNames?: Maybe<Scalars['String']['output']>;
  /** Potential reward totals */
  potentialCampaignRewardTotal?: Maybe<PotentialCampaignRewardTotalConnection>;
  registrationCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  /** Target cash percentage from 0-100 */
  targetCashPercentage: Scalars['Int']['output'];
  token?: Maybe<Scalars['String']['output']>;
  userAttribution?: Maybe<UserAttribution>;
  userRecurringDepositConfigurations?: Maybe<Array<UserRecurringDepositConfiguration>>;
  withdrawalEligibilityStatuses?: Maybe<Array<WithdrawalEligibilityEnum>>;
};


export type UserAccountTaskListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserMyCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserMyPartnerTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserPotentialCampaignRewardTotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** User Address input type */
export type UserAddress = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-2 formatted administrative area (division such as state or provence) */
  administrativeArea?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Locality / City */
  locality?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAttribution = {
  __typename?: 'UserAttribution';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Registration platform (ios, android, web) */
  platform?: Maybe<Scalars['String']['output']>;
  /** Campaign identifier */
  utmCampaign?: Maybe<Scalars['String']['output']>;
  /** Ad variant differentiator */
  utmContent?: Maybe<Scalars['String']['output']>;
  /** Campaign unique ID */
  utmId?: Maybe<Scalars['String']['output']>;
  /** Marketing medium (e.g., cpc, email, social) */
  utmMedium?: Maybe<Scalars['String']['output']>;
  /** Marketing source (e.g., google, facebook) */
  utmSource?: Maybe<Scalars['String']['output']>;
  /** Paid search keywords */
  utmTerm?: Maybe<Scalars['String']['output']>;
};

/** User Attribution input type for tracking registration sources and device information */
export type UserAttributionInput = {
  /** Mobile application version number (e.g., 1.2.3) */
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** Branch.io deep linking match identifier */
  branchMatchId?: InputMaybe<Scalars['String']['input']>;
  /** Unique browser identifier generated from device characteristics */
  browserFingerprint?: InputMaybe<Scalars['String']['input']>;
  /** Tracking identifier for affiliate marketing clicks */
  clickId?: InputMaybe<Scalars['String']['input']>;
  /** Device hardware model (e.g., iPhone 14 Pro, Samsung Galaxy S23) */
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  /** User's IPv4 address for geolocation and tracking */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  /** User's operating system name (e.g., iOS, Android, Windows, macOS) */
  os?: InputMaybe<Scalars['String']['input']>;
  /** Operating system version number (e.g., 16.5, 13.0) */
  osVersion?: InputMaybe<Scalars['String']['input']>;
  /** Registration platform (web, ios, android) */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** Screen height in pixels */
  screenHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Screen width in pixels */
  screenWidth?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier for the user's current session */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  /** Browser's user agent string containing browser and system information */
  userAgent?: InputMaybe<Scalars['String']['input']>;
  /** Specific marketing campaign identifier (e.g., spring_sale_2024) */
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  /** Differentiates similar content or links within the same ad (e.g., logo_link vs text_link) */
  utmContent?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the marketing campaign */
  utmId?: InputMaybe<Scalars['String']['input']>;
  /** Marketing medium or method used (e.g., cpc, email, social, referral) */
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  /** Marketing source that directed the user (e.g., google, facebook, linkedin) */
  utmSource?: InputMaybe<Scalars['String']['input']>;
  /** Paid search keywords or terms used in the campaign */
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type UserDataVaultQuestionResponse = {
  __typename?: 'UserDataVaultQuestionResponse';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  value: Scalars['String']['output'];
};

export type UserFeatureOptIn = {
  __typename?: 'UserFeatureOptIn';
  feature: Scalars['String']['output'];
  optedIn: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

export type UserOnetimeDeposit = Transaction & {
  __typename?: 'UserOnetimeDeposit';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type UserPartnerBidResponse = WithTimestamps & {
  __typename?: 'UserPartnerBidResponse';
  /** The action taken for this data-date */
  actionChoice: ActionChoiceEnum;
  /** When the data-date was responded to */
  actionTakenAt: Scalars['ISO8601DateTime']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type UserRecurringDeposit = Transaction & {
  __typename?: 'UserRecurringDeposit';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A Users recurring deposit configuration */
export type UserRecurringDepositConfiguration = {
  __typename?: 'UserRecurringDepositConfiguration';
  amount?: Maybe<Scalars['Float']['output']>;
  bankAccountId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  depositInterval?: Maybe<DepositIntervalEnum>;
  id?: Maybe<Scalars['ID']['output']>;
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

export type WithTimestamps = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Withdrawal = Transaction & {
  __typename?: 'Withdrawal';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WithdrawalCapability = {
  __typename?: 'WithdrawalCapability';
  availableToWithdraw: Scalars['String']['output'];
  minBalance: Scalars['Int']['output'];
  speeds: Array<WithdrawalSpeedCapability>;
  withdrawalIncrement: Scalars['Float']['output'];
  withdrawalMaxLimit: Scalars['Int']['output'];
  withdrawalMinLimit: Scalars['Int']['output'];
};

export enum WithdrawalEligibilityEnum {
  /** User is eligible for withdrawal */
  Eligible = 'ELIGIBLE',
  /** User has not confirmed their attached email */
  UnconfirmedEmail = 'UNCONFIRMED_EMAIL',
  /**
   * User has an in-flight withdrawal
   * @deprecated Advisor system now supports multiple in-flight withdrawals
   */
  WithdrawalInProgress = 'WITHDRAWAL_IN_PROGRESS'
}

export type WithdrawalFee = Transaction & {
  __typename?: 'WithdrawalFee';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  parentUserTransactionId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WithdrawalFeeQuote = {
  __typename?: 'WithdrawalFeeQuote';
  enabled: Scalars['Boolean']['output'];
  fee: Scalars['Float']['output'];
  speed: WithdrawalSpeed;
};

export type WithdrawalInProgressError = ErrorInterface & {
  __typename?: 'WithdrawalInProgressError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** Modal title. Null means the client shows its default title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Withdrawal request input type */
export type WithdrawalRequest = {
  amount: Scalars['String']['input'];
  /** Withdrawal speed */
  speed?: InputMaybe<WithdrawalSpeed>;
};

export enum WithdrawalSpeed {
  Ach = 'ACH',
  Asap = 'ASAP'
}

export type WithdrawalSpeedCapability = {
  __typename?: 'WithdrawalSpeedCapability';
  enabled: Scalars['Boolean']['output'];
  speed: WithdrawalSpeed;
};

export type QuestionImageFragmentFragment = { __typename?: 'QuestionImage', url: string };

export type UserDataVaultQuestionResponseFragmentFragment = { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null };

export type ButtonFragmentFragment = { __typename?: 'Button', label: string, value: string };

export type ChipFragmentFragment = { __typename?: 'Chip', label: string, value: string };

export type OptionFragmentFragment = { __typename?: 'Option', label: string, value: string };

export type StyledButtonFragmentFragment = { __typename?: 'StyledButton', label: string, value: string, buttonColor?: string | null, shortDescription?: string | null };

type QuestionFragment_InputAdministrativeArea_Fragment = { __typename?: 'InputAdministrativeArea', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

type QuestionFragment_InputBoolean_Fragment = { __typename?: 'InputBoolean', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

type QuestionFragment_InputButtonSelection_Fragment = { __typename?: 'InputButtonSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

type QuestionFragment_InputChipsSelection_Fragment = { __typename?: 'InputChipsSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

type QuestionFragment_InputCurrency_Fragment = { __typename?: 'InputCurrency', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

type QuestionFragment_InputDate_Fragment = { __typename?: 'InputDate', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

type QuestionFragment_InputGroup_Fragment = { __typename?: 'InputGroup', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

type QuestionFragment_InputListSelection_Fragment = { __typename?: 'InputListSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

type QuestionFragment_InputNumber_Fragment = { __typename?: 'InputNumber', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

type QuestionFragment_InputPostalCode_Fragment = { __typename?: 'InputPostalCode', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

type QuestionFragment_InputStyledButtonSelection_Fragment = { __typename?: 'InputStyledButtonSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

type QuestionFragment_InputText_Fragment = { __typename?: 'InputText', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type QuestionFragmentFragment = QuestionFragment_InputAdministrativeArea_Fragment | QuestionFragment_InputBoolean_Fragment | QuestionFragment_InputButtonSelection_Fragment | QuestionFragment_InputChipsSelection_Fragment | QuestionFragment_InputCurrency_Fragment | QuestionFragment_InputDate_Fragment | QuestionFragment_InputGroup_Fragment | QuestionFragment_InputListSelection_Fragment | QuestionFragment_InputNumber_Fragment | QuestionFragment_InputPostalCode_Fragment | QuestionFragment_InputStyledButtonSelection_Fragment | QuestionFragment_InputText_Fragment;

export type InputAdministrativeAreaFragmentFragment = { __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type InputBooleanFragmentFragment = { __typename?: 'InputBoolean', trueOptionLabel?: string | null, falseOptionLabel?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type InputButtonSelectionFragmentFragment = { __typename?: 'InputButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type InputChipsSelectionFragmentFragment = { __typename?: 'InputChipsSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, chips: Array<{ __typename?: 'Chip', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type InputCurrencyFragmentFragment = { __typename?: 'InputCurrency', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type InputDateFragmentFragment = { __typename?: 'InputDate', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type InputGroupFragmentFragment = { __typename?: 'InputGroup', id: string, text: string, required: boolean, rewardAmount?: number | null, questions?: Array<{ __typename: 'InputAdministrativeArea', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputBoolean', trueOptionLabel?: string | null, falseOptionLabel?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputChipsSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, chips: Array<{ __typename?: 'Chip', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputCurrency', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputDate', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputGroup', id: string, text: string, required: boolean, rewardAmount?: number | null } | { __typename: 'InputListSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputNumber', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputPostalCode', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputStyledButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'StyledButton', label: string, value: string, buttonColor?: string | null, shortDescription?: string | null }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputText', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type InputListSelectionFragmentFragment = { __typename?: 'InputListSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type InputNumberFragmentFragment = { __typename?: 'InputNumber', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type InputPostalCodeFragmentFragment = { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type InputStyledButtonSelectionFragmentFragment = { __typename?: 'InputStyledButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'StyledButton', label: string, value: string, buttonColor?: string | null, shortDescription?: string | null }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type InputTextFragmentFragment = { __typename?: 'InputText', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type QuestionContainerFragmentFragment = { __typename?: 'QuestionContainer', id: string, name: string, buttonLabel?: string | null, buttonTooltipText?: string | null, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename: 'InputAdministrativeArea', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputBoolean', trueOptionLabel?: string | null, falseOptionLabel?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputChipsSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, chips: Array<{ __typename?: 'Chip', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputCurrency', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputDate', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputGroup', id: string, text: string, required: boolean, rewardAmount?: number | null, questions?: Array<{ __typename: 'InputAdministrativeArea', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputBoolean', trueOptionLabel?: string | null, falseOptionLabel?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputChipsSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, chips: Array<{ __typename?: 'Chip', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputCurrency', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputDate', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputGroup', id: string, text: string, required: boolean, rewardAmount?: number | null } | { __typename: 'InputListSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputNumber', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputPostalCode', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputStyledButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'StyledButton', label: string, value: string, buttonColor?: string | null, shortDescription?: string | null }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputText', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputListSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputNumber', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputPostalCode', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputStyledButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'StyledButton', label: string, value: string, buttonColor?: string | null, shortDescription?: string | null }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputText', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null }> | null };

export type PlaidLinkTokenFragmentFragment = { __typename?: 'PlaidLinkToken', expiration?: any | null, linkToken?: string | null };

export type BankAccountFragmentFragment = { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null };

export type MonitoredBankAccountFragmentFragment = { __typename?: 'MonitoredBankAccount', balance?: number | null, balanceLastUpdatedAt?: any | null, canUnlink: boolean, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, createdAt: any, deletedAt?: string | null, displayAccountNumber?: string | null, id: string, logo?: string | null, name?: string | null, requireReauth?: boolean | null, subtype?: MonitoredBankAccountSubtypeEnum | null, type?: MonitoredBankAccountTypeEnum | null };

export type MonitoredBankAccountTransactionFragmentFragment = { __typename?: 'MonitoredBankAccountTransaction', amount: number, date: any, deleted: boolean, detailedCategory?: string | null, id: string, ignored: boolean, merchantLogoUrl?: string | null, merchantName?: string | null, monitoredBankAccountId: string, name: string, nameOverride?: string | null, needsCategorization: boolean, paymentChannel?: PaymentChannelEnum | null, pending: boolean, primaryCategory?: string | null, primaryCategoryOverride?: string | null, recurringTransactionId?: string | null, updatedAt: any, website?: string | null, location?: { __typename?: 'Location', address?: string | null, city?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, postalCode?: string | null, region?: string | null, storeNumber?: string | null } | null };

export type RecurringTransactionFragmentFragment = { __typename?: 'RecurringTransaction', id: string, amount: number, createdAt: any, firstTransactionDate?: any | null, frequency: RecurringTransactionFrequencyEnum, lastTransactionDate?: any | null, name: string, nextTransactionDate?: any | null, transactionCount?: number | null, updatedAt: any, userId: string };

export type LocationFragmentFragment = { __typename?: 'Location', address?: string | null, city?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, postalCode?: string | null, region?: string | null, storeNumber?: string | null };

export type BalanceFragmentFragment = { __typename?: 'Balance', available?: string | null, total?: string | null, availableToWithdraw?: string | null, cashTotal?: string | null, cumulativeEarned?: string | null, cumulativeEarnedPast30Days?: string | null, pending?: string | null };

export type BudgetFragmentFragment = { __typename?: 'Budget', id: string, amount: number, category: string, month: any, inactiveAt?: any | null, createdAt: any, updatedAt: any, userId: string };

export type CashAdvanceFeeFragmentFragment = { __typename?: 'CashAdvanceFee', amount: string, feeType: CashAdvanceFeeType };

export type CashAdvanceFeeScheduleFragmentFragment = { __typename?: 'CashAdvanceFeeSchedule', amount: string, label: string };

export type CashAdvanceRequestFragmentFragment = { __typename?: 'CashAdvanceRequest', id: string, amount: string, amountNeededToRepay?: string | null, amountRepaidViaRewards: string, createdAt?: any | null, expectedRepaymentDate?: any | null, inFlightPayment: boolean, repaymentAmount: string, status: CashAdvanceRequestStatus, transferType: CashAdvanceRequestTransferType, fees: Array<{ __typename?: 'CashAdvanceFee', amount: string, feeType: CashAdvanceFeeType }> };

export type CashAdvanceApplicationFragmentFragment = { __typename?: 'CashAdvanceApplication', id: string, pendingMessage?: string | null, plaidSyncInDarkHours: boolean, rejectionDetails?: Array<string> | null, status: CashAdvanceApplicationStatus, submittedAt?: any | null, bankAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null };

export type CashAdvanceApprovedAmountFragmentFragment = { __typename?: 'CashAdvanceApprovedAmount', amount?: string | null, approvedUntil?: any | null, eligibilityFailures: Array<EligibilityFailureReasonEnum>, rejectionMessages: Array<string> };

export type CashAdvanceEvaluationFragmentFragment = { __typename?: 'CashAdvanceEvaluation', id: string, allowedAmount?: number | null, eligibilityFailures: Array<EligibilityFailureReasonEnum>, rejectionMessages: Array<string> };

export type CreateChatTokenPayloadFragmentFragment = { __typename?: 'CreateChatTokenPayload', chatUser?: { __typename?: 'ChatUser', identity?: string | null, token?: string | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null };

export type ChatUserFragmentFragment = { __typename?: 'ChatUser', identity?: string | null, token?: string | null };

export type CreateSessionPayloadFragmentFragment = { __typename?: 'CreateSessionPayload', chatkitSession?: { __typename?: 'ChatkitSession', clientSecret: string } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null };

export type ErrorFragmentFragment = { __typename?: 'Error', message: string, path: Array<string> };

type OAuthAccountCreationError_Error_Fragment = { __typename?: 'Error', message: string, path: Array<string> };

type OAuthAccountCreationError_OAuthCreateUserExistingOAuthError_Fragment = { __typename?: 'OAuthCreateUserExistingOAuthError', message: string, path: Array<string> };

type OAuthAccountCreationError_OAuthCreateUserExistingUserError_Fragment = { __typename?: 'OAuthCreateUserExistingUserError', message: string, path: Array<string> };

type OAuthAccountCreationError_OAuthCreateUserInvalidTokenError_Fragment = { __typename?: 'OAuthCreateUserInvalidTokenError', message: string, path: Array<string> };

type OAuthAccountCreationError_OAuthCreateUserTokenExpiredError_Fragment = { __typename?: 'OAuthCreateUserTokenExpiredError', message: string, path: Array<string> };

export type OAuthAccountCreationErrorFragment = OAuthAccountCreationError_Error_Fragment | OAuthAccountCreationError_OAuthCreateUserExistingOAuthError_Fragment | OAuthAccountCreationError_OAuthCreateUserExistingUserError_Fragment | OAuthAccountCreationError_OAuthCreateUserInvalidTokenError_Fragment | OAuthAccountCreationError_OAuthCreateUserTokenExpiredError_Fragment;

type OAuthAccountSignInError_Error_Fragment = { __typename?: 'Error', message: string, path: Array<string> };

type OAuthAccountSignInError_OAuthSignInNotRegisteredError_Fragment = { __typename?: 'OAuthSignInNotRegisteredError', message: string, path: Array<string> };

type OAuthAccountSignInError_OAuthSignInUserAccountClosedError_Fragment = { __typename?: 'OAuthSignInUserAccountClosedError' };

type OAuthAccountSignInError_OAuthSignInUserInvalidTokenError_Fragment = { __typename?: 'OAuthSignInUserInvalidTokenError', message: string, path: Array<string> };

type OAuthAccountSignInError_OAuthSignInUserTokenExpiredError_Fragment = { __typename?: 'OAuthSignInUserTokenExpiredError', message: string, path: Array<string> };

export type OAuthAccountSignInErrorFragment = OAuthAccountSignInError_Error_Fragment | OAuthAccountSignInError_OAuthSignInNotRegisteredError_Fragment | OAuthAccountSignInError_OAuthSignInUserAccountClosedError_Fragment | OAuthAccountSignInError_OAuthSignInUserInvalidTokenError_Fragment | OAuthAccountSignInError_OAuthSignInUserTokenExpiredError_Fragment;

type NotifyReferredUserErrorFragment_Error_Fragment = { __typename?: 'Error', message: string, path: Array<string> };

type NotifyReferredUserErrorFragment_RateLimitExceededError_Fragment = { __typename?: 'RateLimitExceededError', message: string, path: Array<string> };

type NotifyReferredUserErrorFragment_ReferralNotFoundError_Fragment = { __typename?: 'ReferralNotFoundError', message: string, path: Array<string> };

export type NotifyReferredUserErrorFragmentFragment = NotifyReferredUserErrorFragment_Error_Fragment | NotifyReferredUserErrorFragment_RateLimitExceededError_Fragment | NotifyReferredUserErrorFragment_ReferralNotFoundError_Fragment;

type PauseSubscriptionErrorFragment_Error_Fragment = { __typename?: 'Error', message: string, path: Array<string> };

type PauseSubscriptionErrorFragment_PauseSubscriptionActiveAdvanceError_Fragment = { __typename?: 'PauseSubscriptionActiveAdvanceError', message: string, path: Array<string> };

type PauseSubscriptionErrorFragment_PauseSubscriptionCanceledError_Fragment = { __typename?: 'PauseSubscriptionCanceledError', message: string, path: Array<string> };

type PauseSubscriptionErrorFragment_PauseSubscriptionInactiveError_Fragment = { __typename?: 'PauseSubscriptionInactiveError', message: string, path: Array<string> };

type PauseSubscriptionErrorFragment_PauseSubscriptionNoSubscriptionError_Fragment = { __typename?: 'PauseSubscriptionNoSubscriptionError', message: string, path: Array<string> };

export type PauseSubscriptionErrorFragmentFragment = PauseSubscriptionErrorFragment_Error_Fragment | PauseSubscriptionErrorFragment_PauseSubscriptionActiveAdvanceError_Fragment | PauseSubscriptionErrorFragment_PauseSubscriptionCanceledError_Fragment | PauseSubscriptionErrorFragment_PauseSubscriptionInactiveError_Fragment | PauseSubscriptionErrorFragment_PauseSubscriptionNoSubscriptionError_Fragment;

type ResumeSubscriptionErrorFragment_Error_Fragment = { __typename?: 'Error', message: string, path: Array<string> };

type ResumeSubscriptionErrorFragment_ResumeSubscriptionActiveError_Fragment = { __typename?: 'ResumeSubscriptionActiveError', message: string, path: Array<string> };

type ResumeSubscriptionErrorFragment_ResumeSubscriptionCanceledError_Fragment = { __typename?: 'ResumeSubscriptionCanceledError', message: string, path: Array<string> };

type ResumeSubscriptionErrorFragment_ResumeSubscriptionLinkedCardUnhealthyError_Fragment = { __typename?: 'ResumeSubscriptionLinkedCardUnhealthyError', message: string, path: Array<string> };

type ResumeSubscriptionErrorFragment_ResumeSubscriptionNoSubscriptionError_Fragment = { __typename?: 'ResumeSubscriptionNoSubscriptionError', message: string, path: Array<string> };

export type ResumeSubscriptionErrorFragmentFragment = ResumeSubscriptionErrorFragment_Error_Fragment | ResumeSubscriptionErrorFragment_ResumeSubscriptionActiveError_Fragment | ResumeSubscriptionErrorFragment_ResumeSubscriptionCanceledError_Fragment | ResumeSubscriptionErrorFragment_ResumeSubscriptionLinkedCardUnhealthyError_Fragment | ResumeSubscriptionErrorFragment_ResumeSubscriptionNoSubscriptionError_Fragment;

type RunCashAdvanceEvaluationErrorFragment_Error_Fragment = { __typename?: 'Error' };

type RunCashAdvanceEvaluationErrorFragment_EvaluationAlreadyRunError_Fragment = { __typename?: 'EvaluationAlreadyRunError', message: string, path: Array<string> };

type RunCashAdvanceEvaluationErrorFragment_NoPaymentAccountError_Fragment = { __typename?: 'NoPaymentAccountError', message: string, path: Array<string> };

type RunCashAdvanceEvaluationErrorFragment_PaymentAccountUnusableError_Fragment = { __typename?: 'PaymentAccountUnusableError', message: string, path: Array<string> };

export type RunCashAdvanceEvaluationErrorFragmentFragment = RunCashAdvanceEvaluationErrorFragment_Error_Fragment | RunCashAdvanceEvaluationErrorFragment_EvaluationAlreadyRunError_Fragment | RunCashAdvanceEvaluationErrorFragment_NoPaymentAccountError_Fragment | RunCashAdvanceEvaluationErrorFragment_PaymentAccountUnusableError_Fragment;

type PayOutstandingFeeErrorFragment_CardInBackoffError_Fragment = { __typename?: 'CardInBackoffError' };

type PayOutstandingFeeErrorFragment_Error_Fragment = { __typename?: 'Error', message: string, path: Array<string> };

type PayOutstandingFeeErrorFragment_FeeAlreadySettledError_Fragment = { __typename?: 'FeeAlreadySettledError' };

type PayOutstandingFeeErrorFragment_LinkedCardInvalidError_Fragment = { __typename?: 'LinkedCardInvalidError' };

type PayOutstandingFeeErrorFragment_NoOutStandingFeeError_Fragment = { __typename?: 'NoOutStandingFeeError', message: string, path: Array<string> };

type PayOutstandingFeeErrorFragment_PaymentInProgressError_Fragment = { __typename?: 'PaymentInProgressError' };

export type PayOutstandingFeeErrorFragmentFragment = PayOutstandingFeeErrorFragment_CardInBackoffError_Fragment | PayOutstandingFeeErrorFragment_Error_Fragment | PayOutstandingFeeErrorFragment_FeeAlreadySettledError_Fragment | PayOutstandingFeeErrorFragment_LinkedCardInvalidError_Fragment | PayOutstandingFeeErrorFragment_NoOutStandingFeeError_Fragment | PayOutstandingFeeErrorFragment_PaymentInProgressError_Fragment;

type CreateAccountClosureAttemptErrorFragment_CreateAccountClosureAttemptValidationError_Fragment = { __typename?: 'CreateAccountClosureAttemptValidationError', message: string, path: Array<string> };

type CreateAccountClosureAttemptErrorFragment_Error_Fragment = { __typename?: 'Error', message: string, path: Array<string> };

export type CreateAccountClosureAttemptErrorFragmentFragment = CreateAccountClosureAttemptErrorFragment_CreateAccountClosureAttemptValidationError_Fragment | CreateAccountClosureAttemptErrorFragment_Error_Fragment;

type CreateClosureRequestErrorFragment_CreateClosureRequestAlreadyClosingError_Fragment = { __typename?: 'CreateClosureRequestAlreadyClosingError', message: string, path: Array<string> };

type CreateClosureRequestErrorFragment_CreateClosureRequestCashAdvanceRequestNotRepaidError_Fragment = { __typename?: 'CreateClosureRequestCashAdvanceRequestNotRepaidError', message: string, path: Array<string> };

type CreateClosureRequestErrorFragment_CreateClosureRequestUnableToRetrieveAchAccountNumberError_Fragment = { __typename?: 'CreateClosureRequestUnableToRetrieveACHAccountNumberError', message: string, path: Array<string> };

type CreateClosureRequestErrorFragment_Error_Fragment = { __typename?: 'Error', message: string, path: Array<string> };

export type CreateClosureRequestErrorFragmentFragment = CreateClosureRequestErrorFragment_CreateClosureRequestAlreadyClosingError_Fragment | CreateClosureRequestErrorFragment_CreateClosureRequestCashAdvanceRequestNotRepaidError_Fragment | CreateClosureRequestErrorFragment_CreateClosureRequestUnableToRetrieveAchAccountNumberError_Fragment | CreateClosureRequestErrorFragment_Error_Fragment;

type KeepAccessSubscriptionErrorFragment_Error_Fragment = { __typename?: 'Error', message: string, path: Array<string> };

type KeepAccessSubscriptionErrorFragment_KeepAccessSubscriptionAlreadyUsedDiscountError_Fragment = { __typename?: 'KeepAccessSubscriptionAlreadyUsedDiscountError', message: string, path: Array<string> };

type KeepAccessSubscriptionErrorFragment_KeepAccessSubscriptionInvalidDiscountError_Fragment = { __typename?: 'KeepAccessSubscriptionInvalidDiscountError', message: string, path: Array<string> };

type KeepAccessSubscriptionErrorFragment_KeepAccessSubscriptionNoSubscriptionError_Fragment = { __typename?: 'KeepAccessSubscriptionNoSubscriptionError', message: string, path: Array<string> };

export type KeepAccessSubscriptionErrorFragmentFragment = KeepAccessSubscriptionErrorFragment_Error_Fragment | KeepAccessSubscriptionErrorFragment_KeepAccessSubscriptionAlreadyUsedDiscountError_Fragment | KeepAccessSubscriptionErrorFragment_KeepAccessSubscriptionInvalidDiscountError_Fragment | KeepAccessSubscriptionErrorFragment_KeepAccessSubscriptionNoSubscriptionError_Fragment;

export type ClientEventFragmentFragment = { __typename?: 'ClientEvent', data?: any | null, name: string, partnerId?: string | null, partnerOfferId?: string | null, requestId: string, servedImpressionId?: string | null };

export type PartnerOfferCategoryDisplayStylingFragmentFragment = { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null };

export type PartnerOfferCategoryFragmentFragment = { __typename?: 'PartnerOfferCategory', id: string, name: string, bannerUrl?: string | null, priorityOrder?: number | null, displayMetadata: { __typename?: 'PartnerOfferCategoryDisplayMetadata', viewAllPaginationAmount: number, detailDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null }, featuredDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null }, mainDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null } } };

export type DealFragmentFragment = { __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } };

export type SurveyFragmentFragment = { __typename?: 'Survey', id: string, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, timeToComplete?: string | null, top?: boolean | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } };

type PartnerOfferUnionFragment_Deal_Fragment = { __typename: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } };

type PartnerOfferUnionFragment_Survey_Fragment = { __typename: 'Survey', id: string, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, timeToComplete?: string | null, top?: boolean | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } };

export type PartnerOfferUnionFragmentFragment = PartnerOfferUnionFragment_Deal_Fragment | PartnerOfferUnionFragment_Survey_Fragment;

export type UserOfferCategoryFragmentFragment = { __typename?: 'PartnerOfferCategory', id: string, name: string, bannerUrl?: string | null, priorityOrder?: number | null, myPartnerOffers1: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | { __typename?: 'Survey' } | null> | null }, displayMetadata: { __typename?: 'PartnerOfferCategoryDisplayMetadata', viewAllPaginationAmount: number, detailDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null }, featuredDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null }, mainDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null } } };

export type ReferralHistoryFragmentFragment = { __typename?: 'ReferralHistory', referralId?: string | null, firstName?: string | null, lastName?: string | null, amount: string, createdAt: any, qualifiedAt?: any | null, rewardCriteria: ReferralRewardCriteriaEnum };

export type ReferralFragmentFragment = { __typename?: 'Referral', code: string, referrerName?: string | null, rewardAmount: string, rewardCriteria: ReferralRewardCriteriaEnum, rewardCriteriaDescription: string, history: Array<{ __typename?: 'ReferralHistory', referralId?: string | null, firstName?: string | null, lastName?: string | null, amount: string, createdAt: any, qualifiedAt?: any | null, rewardCriteria: ReferralRewardCriteriaEnum }> };

export type CalculatedFeeFragmentFragment = { __typename?: 'CalculatedFee', amount: number, baseAmount: number, calculatedFeeDiscounts: Array<{ __typename?: 'CalculatedFeeDiscount', amount: number, code: string, name: string, subscriptionDiscountId: string }> };

export type SubscriptionProductFragmentFragment = { __typename?: 'SubscriptionProduct', key: SubscriptionProductEnum, name: string, description: string, fee: number, feeSchedule: SubscriptionFeeSchedule, footnotes: Array<string>, trialDurationDays: number, features: Array<{ __typename?: 'SubscriptionProductFeature', title: string, description: string }> };

export type SubscriptionFeeFragmentFragment = { __typename?: 'SubscriptionFee', id: string, amount: number, chargedAt: any, description?: string | null, lastPaymentAttemptAt?: any | null };

export type SubscriptionFragmentFragment = { __typename?: 'Subscription', id: string, activeAt?: any | null, cancelledAt?: any | null, createdAt: any, inactiveAt?: any | null, initialFeeChargedAt?: any | null, nextFeeChargedAt: any, productKey: SubscriptionProductEnum, proratedRefundAmount?: number | null, status: CashAdvanceSubscriptionStatus, product: { __typename?: 'SubscriptionProduct', key: SubscriptionProductEnum, name: string, description: string, fee: number, feeSchedule: SubscriptionFeeSchedule, footnotes: Array<string>, trialDurationDays: number, features: Array<{ __typename?: 'SubscriptionProductFeature', title: string, description: string }> }, nextCalculatedFee: { __typename?: 'CalculatedFee', amount: number, baseAmount: number, calculatedFeeDiscounts: Array<{ __typename?: 'CalculatedFeeDiscount', amount: number, code: string, name: string, subscriptionDiscountId: string }> } };

type TransactionFragment_AtmSubscriptionFee_Fragment = { __typename: 'AtmSubscriptionFee', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_AtmSubscriptionFeePayment_Fragment = { __typename: 'AtmSubscriptionFeePayment', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_CashAdvance_Fragment = { __typename: 'CashAdvance', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_CashAdvanceRepayment_Fragment = { __typename: 'CashAdvanceRepayment', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_CashAdvanceTip_Fragment = { __typename: 'CashAdvanceTip', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_CashAdvanceTransferFee_Fragment = { __typename: 'CashAdvanceTransferFee', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_DataDividend_Fragment = { __typename: 'DataDividend', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_InactivityFeeDisplay_Fragment = { __typename: 'InactivityFeeDisplay', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_InvestmentDeposit_Fragment = { __typename: 'InvestmentDeposit', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_InvestmentWithdrawal_Fragment = { __typename: 'InvestmentWithdrawal', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_UserOnetimeDeposit_Fragment = { __typename: 'UserOnetimeDeposit', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_UserRecurringDeposit_Fragment = { __typename: 'UserRecurringDeposit', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_Withdrawal_Fragment = { __typename: 'Withdrawal', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

type TransactionFragment_WithdrawalFee_Fragment = { __typename: 'WithdrawalFee', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null };

export type TransactionFragmentFragment = TransactionFragment_AtmSubscriptionFee_Fragment | TransactionFragment_AtmSubscriptionFeePayment_Fragment | TransactionFragment_CashAdvance_Fragment | TransactionFragment_CashAdvanceRepayment_Fragment | TransactionFragment_CashAdvanceTip_Fragment | TransactionFragment_CashAdvanceTransferFee_Fragment | TransactionFragment_DataDividend_Fragment | TransactionFragment_InactivityFeeDisplay_Fragment | TransactionFragment_InvestmentDeposit_Fragment | TransactionFragment_InvestmentWithdrawal_Fragment | TransactionFragment_UserOnetimeDeposit_Fragment | TransactionFragment_UserRecurringDeposit_Fragment | TransactionFragment_Withdrawal_Fragment | TransactionFragment_WithdrawalFee_Fragment;

export type UserFragmentFragment = { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, broker?: boolean | null, completedDemographicQuestions: boolean, directorOf?: string | null, employmentStatus?: EmploymentStatusEnum | null, politicallyExposedNames?: string | null, targetCashPercentage: number, withdrawalEligibilityStatuses?: Array<WithdrawalEligibilityEnum> | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null, bonusTaskLists?: Array<{ __typename?: 'BonusTaskList', bonusTaskList?: string | null, completedAt?: any | null, description?: string | null, expiresAt?: any | null, rewardAmount?: number | null, bonusTasks?: Array<{ __typename?: 'BonusTask', currentCompletions: number, deepLink: string, description: string, icon: string, instruction?: string | null, targetCompletions: number, completionCriteria?: { __typename?: 'CompletionCriteria', partnerId?: string | null, partnerOfferId?: string | null } | null }> | null }> | null, dailyTaskList?: { __typename?: 'DailyTaskList', id: string, completedAt?: any | null, completedTasksCount: number, completionPercentage: number, selectionStrategy: string, taskDate: any, totalTasksCount: number, tasks: Array<{ __typename?: 'DailyTask', category: string, completed: boolean, completionText: string, currentProgress: number, deepLink?: string | null, description: string, difficulty: string, icon: string, targetCompletions: number, taskKey: string }> } | null, featureOptIns?: Array<{ __typename?: 'UserFeatureOptIn', feature: string, optedIn: boolean, userId: string }> | null, investmentAccounts?: Array<{ __typename?: 'InvestmentAccount', id: string, provisioningCompletedAt?: string | null, provisioningInitiatedAt?: string | null, status?: InvestmentAccountStatusEnum | null }> | null, phoneDetail?: { __typename?: 'PhoneDetail', id: string, carrierMobileCountryCode?: string | null, carrierMobileNetworkCode?: string | null, carrierName?: string | null, carrierType?: string | null, countryCode?: string | null, phone: string, createdAt: any, updatedAt: any } | null, userAttribution?: { __typename?: 'UserAttribution', createdAt?: any | null, platform?: string | null, utmCampaign?: string | null, utmContent?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, utmTerm?: string | null } | null, userRecurringDepositConfigurations?: Array<{ __typename?: 'UserRecurringDepositConfiguration', id?: string | null, amount?: number | null, bankAccountId?: string | null, createdAt?: any | null, deactivatedAt?: any | null, deletedAt?: any | null, depositInterval?: DepositIntervalEnum | null, scheduledAt?: any | null, updatedAt?: any | null, userId?: string | null }> | null };

export type BonusTaskListFragmentFragment = { __typename?: 'BonusTaskList', bonusTaskList?: string | null, completedAt?: any | null, description?: string | null, expiresAt?: any | null, rewardAmount?: number | null, bonusTasks?: Array<{ __typename?: 'BonusTask', currentCompletions: number, deepLink: string, description: string, icon: string, instruction?: string | null, targetCompletions: number, completionCriteria?: { __typename?: 'CompletionCriteria', partnerId?: string | null, partnerOfferId?: string | null } | null }> | null };

export type BonusTaskFragmentFragment = { __typename?: 'BonusTask', currentCompletions: number, deepLink: string, description: string, icon: string, instruction?: string | null, targetCompletions: number, completionCriteria?: { __typename?: 'CompletionCriteria', partnerId?: string | null, partnerOfferId?: string | null } | null };

export type DailyTaskListFragmentFragment = { __typename?: 'DailyTaskList', id: string, completedAt?: any | null, completedTasksCount: number, completionPercentage: number, selectionStrategy: string, taskDate: any, totalTasksCount: number, tasks: Array<{ __typename?: 'DailyTask', category: string, completed: boolean, completionText: string, currentProgress: number, deepLink?: string | null, description: string, difficulty: string, icon: string, targetCompletions: number, taskKey: string }> };

export type DailyTaskFragmentFragment = { __typename?: 'DailyTask', category: string, completed: boolean, completionText: string, currentProgress: number, deepLink?: string | null, description: string, difficulty: string, icon: string, targetCompletions: number, taskKey: string };

export type UserFeatureOptInFragmentFragment = { __typename?: 'UserFeatureOptIn', feature: string, optedIn: boolean, userId: string };

export type InvestmentAccountFragmentFragment = { __typename?: 'InvestmentAccount', id: string, provisioningCompletedAt?: string | null, provisioningInitiatedAt?: string | null, status?: InvestmentAccountStatusEnum | null };

export type PhoneDetailFragmentFragment = { __typename?: 'PhoneDetail', id: string, carrierMobileCountryCode?: string | null, carrierMobileNetworkCode?: string | null, carrierName?: string | null, carrierType?: string | null, countryCode?: string | null, phone: string, createdAt: any, updatedAt: any };

export type UserAttributionFragmentFragment = { __typename?: 'UserAttribution', createdAt?: any | null, platform?: string | null, utmCampaign?: string | null, utmContent?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, utmTerm?: string | null };

export type UserRecurringDepositConfigurationFragmentFragment = { __typename?: 'UserRecurringDepositConfiguration', id?: string | null, amount?: number | null, bankAccountId?: string | null, createdAt?: any | null, deactivatedAt?: any | null, deletedAt?: any | null, depositInterval?: DepositIntervalEnum | null, scheduledAt?: any | null, updatedAt?: any | null, userId?: string | null };

export type ResetPasswordPayloadFragmentFragment = { __typename?: 'ResetPasswordPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null };

export type AddressFragmentFragment = { __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null };

export type ActiveExperimentFragmentFragment = { __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null };

export type AvailableFeaturesFragmentFragment = { __typename?: 'AvailableFeatures', cashAdvanceRequest: boolean, pfmAdditionalAccounts: boolean, pfmBase: boolean, pfmCustomCategories: boolean, pfmExports: boolean, pfmRefreshTransactions: boolean };

export type WithdrawalCapabilityFragmentFragment = { __typename?: 'WithdrawalCapability', availableToWithdraw: string, minBalance: number, withdrawalIncrement: number, withdrawalMinLimit: number, withdrawalMaxLimit: number, speeds: Array<{ __typename?: 'WithdrawalSpeedCapability', speed: WithdrawalSpeed, enabled: boolean }> };

export type CreateAccountClosureAttemptMutationVariables = Exact<{
  input: CreateAccountClosureAttemptInput;
}>;


export type CreateAccountClosureAttemptMutation = { __typename?: 'Mutation', createAccountClosureAttempt: { __typename?: 'CreateAccountClosureAttemptPayload', accountClosureAttempt?: { __typename?: 'Attempt', id: string, reason: AccountClosureReasonEnum } | null, errors?: Array<{ __typename?: 'CreateAccountClosureAttemptValidationError', message: string, path: Array<string> } | { __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type CreateClosureRequestMutationVariables = Exact<{
  input: CreateClosureRequestInput;
}>;


export type CreateClosureRequestMutation = { __typename?: 'Mutation', createClosureRequest: { __typename?: 'CreateClosureRequestPayload', success: boolean, errors?: Array<{ __typename?: 'CreateClosureRequestAlreadyClosingError', message: string, path: Array<string> } | { __typename?: 'CreateClosureRequestCashAdvanceRequestNotRepaidError', message: string, path: Array<string> } | { __typename?: 'CreateClosureRequestUnableToRetrieveACHAccountNumberError', message: string, path: Array<string> } | { __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type AnswerQuestionMutationVariables = Exact<{
  input: AnswerQuestionInput;
}>;


export type AnswerQuestionMutation = { __typename?: 'Mutation', answerQuestion?: { __typename?: 'AnswerQuestionPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null, nextAvailableDataContainer?: { __typename?: 'QuestionContainer', id: string, name: string, buttonLabel?: string | null, buttonTooltipText?: string | null, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename: 'InputAdministrativeArea', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputBoolean', trueOptionLabel?: string | null, falseOptionLabel?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputChipsSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, chips: Array<{ __typename?: 'Chip', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputCurrency', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputDate', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputGroup', id: string, text: string, required: boolean, rewardAmount?: number | null, questions?: Array<{ __typename: 'InputAdministrativeArea', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputBoolean', trueOptionLabel?: string | null, falseOptionLabel?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputChipsSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, chips: Array<{ __typename?: 'Chip', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputCurrency', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputDate', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputGroup', id: string, text: string, required: boolean, rewardAmount?: number | null } | { __typename: 'InputListSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputNumber', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputPostalCode', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputStyledButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'StyledButton', label: string, value: string, buttonColor?: string | null, shortDescription?: string | null }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputText', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputListSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputNumber', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputPostalCode', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputStyledButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'StyledButton', label: string, value: string, buttonColor?: string | null, shortDescription?: string | null }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputText', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null }> | null } | null, partnerBid?: { __typename?: 'PartnerBid', id: string } | null } | null };

export type SkipContainerMutationVariables = Exact<{
  input: SkipContainerInput;
}>;


export type SkipContainerMutation = { __typename?: 'Mutation', skipContainer?: { __typename?: 'SkipContainerPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type RefreshUserSessionMutationVariables = Exact<{
  input: RefreshUserSessionInput;
}>;


export type RefreshUserSessionMutation = { __typename?: 'Mutation', refreshUserSession?: { __typename?: 'RefreshUserSessionPayload', authentication?: { __typename?: 'Authentication', accessToken: string, refreshToken: string, accessTokenExpiresAt: any } | null, errors?: Array<{ __typename: 'Error', message: string, path: Array<string> } | { __typename: 'InvalidRefreshTokenError', message: string, path: Array<string> }> | null } | null };

export type CreateLinkTokenMutationVariables = Exact<{
  linkAccountType?: InputMaybe<LinkAccountTypeEnum>;
}>;


export type CreateLinkTokenMutation = { __typename?: 'Mutation', createLinkToken?: { __typename?: 'CreateLinkTokenPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null, linkToken?: { __typename?: 'PlaidLinkToken', expiration?: any | null, linkToken?: string | null } | null } | null };

export type ChangeBankAccountMutationVariables = Exact<{
  input: ChangeBankAccountInput;
}>;


export type ChangeBankAccountMutation = { __typename?: 'Mutation', changeBankAccount: { __typename?: 'ChangeBankAccountPayload', bankAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null, errors?: Array<{ __typename?: 'BlockedInstitutionError' } | { __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'LinkBlockedError' } | { __typename?: 'LinkedAccountConflictError' } | { __typename?: 'LinkedOverLimitError' } | { __typename?: 'MaxAccountChangesReachedError' } | { __typename?: 'NoBankAccountError' } | { __typename?: 'NoValidPaymentAccountError' } | { __typename?: 'SameBankAccountError' } | { __typename?: 'UnknownError' } | { __typename?: 'UsedForCashAdvanceApplicationError' } | { __typename?: 'WithdrawalInProgressError' }> | null } };

export type UnlinkBankAccountMutationVariables = Exact<{
  input: UnlinkBankAccountInput;
}>;


export type UnlinkBankAccountMutation = { __typename?: 'Mutation', unlinkBankAccount: { __typename?: 'UnlinkBankAccountPayload', bankAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type LinkMonitoredAccountMutationVariables = Exact<{
  input: LinkAccountInput;
}>;


export type LinkMonitoredAccountMutation = { __typename?: 'Mutation', linkMonitoredAccount: { __typename?: 'LinkAccountPayload', monitoredBankAccounts?: Array<{ __typename?: 'MonitoredBankAccount', balance?: number | null, balanceLastUpdatedAt?: any | null, canUnlink: boolean, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, createdAt: any, deletedAt?: string | null, displayAccountNumber?: string | null, id: string, logo?: string | null, name?: string | null, requireReauth?: boolean | null, subtype?: MonitoredBankAccountSubtypeEnum | null, type?: MonitoredBankAccountTypeEnum | null }> | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type UpsertBudgetMutationVariables = Exact<{
  input: UpsertBudgetInput;
}>;


export type UpsertBudgetMutation = { __typename?: 'Mutation', upsertBudget: { __typename?: 'UpsertBudgetPayload', budget?: { __typename?: 'Budget', id: string, amount: number, category: string, month: any, inactiveAt?: any | null, createdAt: any, updatedAt: any, userId: string } | null, errors?: Array<{ __typename?: 'BudgetNotFoundError' } | { __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'GenericBudgetError' }> | null } };

export type CalibrateBudgetsMutationVariables = Exact<{
  input: CalibrateBudgetsInput;
}>;


export type CalibrateBudgetsMutation = { __typename?: 'Mutation', calibrateBudgets: { __typename?: 'CalibrateBudgetsPayload', budgets?: Array<{ __typename?: 'Budget', id: string, amount: number, category: string, month: any, inactiveAt?: any | null, createdAt: any, updatedAt: any, userId: string }> | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'GenericCalibrationError' }> | null } };

export type CreatePaymentAccountMutationVariables = Exact<{
  input: CreatePaymentAccountInput;
}>;


export type CreatePaymentAccountMutation = { __typename?: 'Mutation', createPaymentAccount: { __typename?: 'CreatePaymentAccountPayload', paymentAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null, errors?: Array<{ __typename?: 'AccountTypeError', message: string, path: Array<string> } | { __typename?: 'AddressVerificationError', message: string, path: Array<string> } | { __typename?: 'BadRequest', message: string, path: Array<string> } | { __typename?: 'CVVVerificationError', message: string, path: Array<string> } | { __typename?: 'CardDeclinedError', message: string, path: Array<string> } | { __typename?: 'CardHolderNameVerificationError', message: string, path: Array<string> } | { __typename?: 'CommonError', message: string, path: Array<string> } | { __typename?: 'Conflict', message: string, path: Array<string> } | { __typename?: 'DuplicateCardOtherUserError', message: string, path: Array<string> } | { __typename?: 'DuplicateCardSameUserError', message: string, path: Array<string> } | { __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'InvalidAddressError', message: string, path: Array<string> } | { __typename?: 'InvalidCardNumberError', message: string, path: Array<string> } | { __typename?: 'InvalidExpirationDateError', message: string, path: Array<string> } | { __typename?: 'MissingCardDataError', message: string, path: Array<string> } | { __typename?: 'MissingUserDataError', message: string, path: Array<string> } | { __typename?: 'PaymentAccountLinkedOverLimitError', message: string, path: Array<string> } | { __typename?: 'PaymentAccountMissingTransferMethodError', message: string, path: Array<string> } | { __typename?: 'RateLimitExceeded', message: string, path: Array<string> }> | null } };

export type CreateCashAdvanceApplicationMutationVariables = Exact<{
  input: CreateCashAdvanceApplicationInput;
}>;


export type CreateCashAdvanceApplicationMutation = { __typename?: 'Mutation', createCashAdvanceApplication?: { __typename?: 'CreateCashAdvanceApplicationPayload', cashAdvanceApplication?: { __typename?: 'CashAdvanceApplication', id: string, pendingMessage?: string | null, plaidSyncInDarkHours: boolean, rejectionDetails?: Array<string> | null, status: CashAdvanceApplicationStatus, submittedAt?: any | null, bankAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type AssignBankAccountToCashAdvanceApplicationMutationVariables = Exact<{
  input: AssignBankAccountToCashAdvanceApplicationInput;
}>;


export type AssignBankAccountToCashAdvanceApplicationMutation = { __typename?: 'Mutation', assignBankAccountToCashAdvanceApplication?: { __typename?: 'AssignBankAccountToCashAdvanceApplicationPayload', cashAdvanceApplication?: { __typename?: 'CashAdvanceApplication', id: string, pendingMessage?: string | null, plaidSyncInDarkHours: boolean, rejectionDetails?: Array<string> | null, status: CashAdvanceApplicationStatus, submittedAt?: any | null, bankAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type SubmitCashAdvanceApplicationMutationVariables = Exact<{
  input: SubmitCashAdvanceApplicationInput;
}>;


export type SubmitCashAdvanceApplicationMutation = { __typename?: 'Mutation', submitCashAdvanceApplication?: { __typename?: 'SubmitCashAdvanceApplicationPayload', cashAdvanceApplication?: { __typename?: 'CashAdvanceApplication', id: string, pendingMessage?: string | null, plaidSyncInDarkHours: boolean, rejectionDetails?: Array<string> | null, status: CashAdvanceApplicationStatus, submittedAt?: any | null, bankAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null } | null, cashAdvanceEvaluation?: { __typename?: 'CashAdvanceEvaluation', id: string, allowedAmount?: number | null, eligibilityFailures: Array<EligibilityFailureReasonEnum>, rejectionMessages: Array<string> } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type CreateCashAdvanceRequestMutationVariables = Exact<{
  input: CreateCashAdvanceRequestInput;
}>;


export type CreateCashAdvanceRequestMutation = { __typename?: 'Mutation', createCashAdvanceRequest?: { __typename?: 'CreateCashAdvanceRequestPayload', cashAdvanceRequest?: { __typename?: 'CashAdvanceRequest', id: string, amount: string, amountNeededToRepay?: string | null, amountRepaidViaRewards: string, createdAt?: any | null, expectedRepaymentDate?: any | null, inFlightPayment: boolean, repaymentAmount: string, status: CashAdvanceRequestStatus, transferType: CashAdvanceRequestTransferType, fees: Array<{ __typename?: 'CashAdvanceFee', amount: string, feeType: CashAdvanceFeeType }> } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type RunCashAdvanceEvaluationMutationVariables = Exact<{
  input: RunCashAdvanceEvaluationInput;
}>;


export type RunCashAdvanceEvaluationMutation = { __typename?: 'Mutation', runCashAdvanceEvaluation?: { __typename?: 'RunCashAdvanceEvaluationPayload', cashAdvanceEvaluation?: { __typename?: 'CashAdvanceEvaluation', id: string, allowedAmount?: number | null, eligibilityFailures: Array<EligibilityFailureReasonEnum>, rejectionMessages: Array<string> } | null, errors?: Array<{ __typename?: 'Error' } | { __typename?: 'EvaluationAlreadyRunError', message: string, path: Array<string> } | { __typename?: 'NoPaymentAccountError', message: string, path: Array<string> } | { __typename?: 'PaymentAccountUnusableError', message: string, path: Array<string> }> | null } | null };

export type RepayCashAdvanceRequestMutationVariables = Exact<{
  input: RepayCashAdvanceRequestInput;
}>;


export type RepayCashAdvanceRequestMutation = { __typename?: 'Mutation', repayCashAdvanceRequest?: { __typename?: 'RepayCashAdvanceRequestPayload', success: boolean, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type UpdateCashAdvanceIdentityMutationVariables = Exact<{
  userInput: UpdateUserInput;
  addressInput: AddressInput;
}>;


export type UpdateCashAdvanceIdentityMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, dob?: any | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null }, address?: { __typename?: 'AddressPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type CreateChatTokenMutationVariables = Exact<{
  createChatTokenInput: CreateChatTokenInput;
}>;


export type CreateChatTokenMutation = { __typename?: 'Mutation', createChatToken: { __typename?: 'CreateChatTokenPayload', chatUser?: { __typename?: 'ChatUser', identity?: string | null, token?: string | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type CreateChatkitSessionMutationVariables = Exact<{
  createSessionInput: CreateSessionInput;
}>;


export type CreateChatkitSessionMutation = { __typename?: 'Mutation', createChatkitSession: { __typename?: 'CreateSessionPayload', chatkitSession?: { __typename?: 'ChatkitSession', clientSecret: string } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type PublishWebEventMutationVariables = Exact<{
  input: PublishWebEventInput;
}>;


export type PublishWebEventMutation = { __typename?: 'Mutation', publishWebEvent?: { __typename?: 'PublishWebEventPayload', eventId?: string | null, errors?: Array<{ __typename?: 'ClientEventError', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null, event: { __typename?: 'ClientEvent', data?: any | null, name: string, partnerId?: string | null, partnerOfferId?: string | null, requestId: string, servedImpressionId?: string | null } } | { __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type CreateUpdateLinkTokenMutationVariables = Exact<{
  input: CreateUpdateLinkTokenInput;
}>;


export type CreateUpdateLinkTokenMutation = { __typename?: 'Mutation', createUpdateLinkToken: { __typename?: 'CreateUpdateLinkTokenPayload', linkToken?: { __typename?: 'PlaidLinkToken', expiration?: any | null, linkToken?: string | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type UpdatePaymentAccountMutationVariables = Exact<{
  input: UpdatePaymentAccountInput;
}>;


export type UpdatePaymentAccountMutation = { __typename?: 'Mutation', updatePaymentAccount: { __typename?: 'UpdatePaymentAccountPayload', paymentAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type RelinkPaymentAccountMutationVariables = Exact<{
  input: RelinkPaymentAccountInput;
}>;


export type RelinkPaymentAccountMutation = { __typename?: 'Mutation', relinkPaymentAccount?: { __typename?: 'RelinkPaymentAccountPayload', paymentAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'RelinkPaymentAccountAlreadyLinkedError', message: string, path: Array<string> } | { __typename?: 'RelinkPaymentAccountCommonError', message: string, path: Array<string> } | { __typename?: 'RelinkPaymentAccountNotCardError', message: string, path: Array<string> } | { __typename?: 'RelinkPaymentAccountNotFoundError', message: string, path: Array<string> }> | null } | null };

export type NotifyReferredUserMutationVariables = Exact<{
  input: NotifyReferredUserInput;
}>;


export type NotifyReferredUserMutation = { __typename?: 'Mutation', notifyReferredUser?: { __typename?: 'NotifyReferredUserPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'RateLimitExceededError', message: string, path: Array<string> } | { __typename?: 'ReferralNotFoundError', message: string, path: Array<string> }> | null } | null };

export type PauseSubscriptionMutationVariables = Exact<{
  input: PauseSubscriptionInput;
}>;


export type PauseSubscriptionMutation = { __typename?: 'Mutation', pauseSubscription?: { __typename?: 'PauseSubscriptionPayload', subscription?: { __typename?: 'Subscription', id: string, activeAt?: any | null, cancelledAt?: any | null, createdAt: any, inactiveAt?: any | null, initialFeeChargedAt?: any | null, nextFeeChargedAt: any, productKey: SubscriptionProductEnum, proratedRefundAmount?: number | null, status: CashAdvanceSubscriptionStatus, product: { __typename?: 'SubscriptionProduct', key: SubscriptionProductEnum, name: string, description: string, fee: number, feeSchedule: SubscriptionFeeSchedule, footnotes: Array<string>, trialDurationDays: number, features: Array<{ __typename?: 'SubscriptionProductFeature', title: string, description: string }> }, nextCalculatedFee: { __typename?: 'CalculatedFee', amount: number, baseAmount: number, calculatedFeeDiscounts: Array<{ __typename?: 'CalculatedFeeDiscount', amount: number, code: string, name: string, subscriptionDiscountId: string }> } } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'PauseSubscriptionActiveAdvanceError', message: string, path: Array<string> } | { __typename?: 'PauseSubscriptionCanceledError', message: string, path: Array<string> } | { __typename?: 'PauseSubscriptionInactiveError', message: string, path: Array<string> } | { __typename?: 'PauseSubscriptionNoSubscriptionError', message: string, path: Array<string> }> | null } | null };

export type ResumeSubscriptionMutationVariables = Exact<{
  input: ResumeSubscriptionInput;
}>;


export type ResumeSubscriptionMutation = { __typename?: 'Mutation', resumeSubscription?: { __typename?: 'ResumeSubscriptionPayload', subscription?: { __typename?: 'Subscription', id: string, activeAt?: any | null, cancelledAt?: any | null, createdAt: any, inactiveAt?: any | null, initialFeeChargedAt?: any | null, nextFeeChargedAt: any, productKey: SubscriptionProductEnum, proratedRefundAmount?: number | null, status: CashAdvanceSubscriptionStatus, product: { __typename?: 'SubscriptionProduct', key: SubscriptionProductEnum, name: string, description: string, fee: number, feeSchedule: SubscriptionFeeSchedule, footnotes: Array<string>, trialDurationDays: number, features: Array<{ __typename?: 'SubscriptionProductFeature', title: string, description: string }> }, nextCalculatedFee: { __typename?: 'CalculatedFee', amount: number, baseAmount: number, calculatedFeeDiscounts: Array<{ __typename?: 'CalculatedFeeDiscount', amount: number, code: string, name: string, subscriptionDiscountId: string }> } } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'ResumeSubscriptionActiveError', message: string, path: Array<string> } | { __typename?: 'ResumeSubscriptionCanceledError', message: string, path: Array<string> } | { __typename?: 'ResumeSubscriptionLinkedCardUnhealthyError', message: string, path: Array<string> } | { __typename?: 'ResumeSubscriptionNoSubscriptionError', message: string, path: Array<string> }> | null } | null };

export type PayOutstandingFeeMutationVariables = Exact<{
  input: PayOutstandingFeeInput;
}>;


export type PayOutstandingFeeMutation = { __typename?: 'Mutation', payOutstandingFee?: { __typename?: 'PayOutstandingFeePayload', subscriptionFee?: { __typename?: 'SubscriptionFee', id: string, amount: number, chargedAt: any, description?: string | null, lastPaymentAttemptAt?: any | null } | null, errors?: Array<{ __typename?: 'CardInBackoffError' } | { __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'FeeAlreadySettledError' } | { __typename?: 'LinkedCardInvalidError' } | { __typename?: 'NoOutStandingFeeError', message: string, path: Array<string> } | { __typename?: 'PaymentInProgressError' }> | null } | null };

export type KeepAccessSubscriptionMutationVariables = Exact<{
  input: KeepAccessSubscriptionInput;
}>;


export type KeepAccessSubscriptionMutation = { __typename?: 'Mutation', keepAccessSubscription?: { __typename?: 'KeepAccessSubscriptionPayload', subscription?: { __typename?: 'Subscription', id: string, activeAt?: any | null, cancelledAt?: any | null, createdAt: any, inactiveAt?: any | null, initialFeeChargedAt?: any | null, nextFeeChargedAt: any, productKey: SubscriptionProductEnum, proratedRefundAmount?: number | null, status: CashAdvanceSubscriptionStatus, product: { __typename?: 'SubscriptionProduct', key: SubscriptionProductEnum, name: string, description: string, fee: number, feeSchedule: SubscriptionFeeSchedule, footnotes: Array<string>, trialDurationDays: number, features: Array<{ __typename?: 'SubscriptionProductFeature', title: string, description: string }> }, nextCalculatedFee: { __typename?: 'CalculatedFee', amount: number, baseAmount: number, calculatedFeeDiscounts: Array<{ __typename?: 'CalculatedFeeDiscount', amount: number, code: string, name: string, subscriptionDiscountId: string }> } } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'KeepAccessSubscriptionAlreadyUsedDiscountError', message: string, path: Array<string> } | { __typename?: 'KeepAccessSubscriptionInvalidDiscountError', message: string, path: Array<string> } | { __typename?: 'KeepAccessSubscriptionNoSubscriptionError', message: string, path: Array<string> }> | null } | null };

export type CreateUserMutationVariables = Exact<{
  createUserInput: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CreateUserPayload', user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, broker?: boolean | null, completedDemographicQuestions: boolean, directorOf?: string | null, employmentStatus?: EmploymentStatusEnum | null, politicallyExposedNames?: string | null, targetCashPercentage: number, withdrawalEligibilityStatuses?: Array<WithdrawalEligibilityEnum> | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null, bonusTaskLists?: Array<{ __typename?: 'BonusTaskList', bonusTaskList?: string | null, completedAt?: any | null, description?: string | null, expiresAt?: any | null, rewardAmount?: number | null, bonusTasks?: Array<{ __typename?: 'BonusTask', currentCompletions: number, deepLink: string, description: string, icon: string, instruction?: string | null, targetCompletions: number, completionCriteria?: { __typename?: 'CompletionCriteria', partnerId?: string | null, partnerOfferId?: string | null } | null }> | null }> | null, dailyTaskList?: { __typename?: 'DailyTaskList', id: string, completedAt?: any | null, completedTasksCount: number, completionPercentage: number, selectionStrategy: string, taskDate: any, totalTasksCount: number, tasks: Array<{ __typename?: 'DailyTask', category: string, completed: boolean, completionText: string, currentProgress: number, deepLink?: string | null, description: string, difficulty: string, icon: string, targetCompletions: number, taskKey: string }> } | null, featureOptIns?: Array<{ __typename?: 'UserFeatureOptIn', feature: string, optedIn: boolean, userId: string }> | null, investmentAccounts?: Array<{ __typename?: 'InvestmentAccount', id: string, provisioningCompletedAt?: string | null, provisioningInitiatedAt?: string | null, status?: InvestmentAccountStatusEnum | null }> | null, phoneDetail?: { __typename?: 'PhoneDetail', id: string, carrierMobileCountryCode?: string | null, carrierMobileNetworkCode?: string | null, carrierName?: string | null, carrierType?: string | null, countryCode?: string | null, phone: string, createdAt: any, updatedAt: any } | null, userAttribution?: { __typename?: 'UserAttribution', createdAt?: any | null, platform?: string | null, utmCampaign?: string | null, utmContent?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, utmTerm?: string | null } | null, userRecurringDepositConfigurations?: Array<{ __typename?: 'UserRecurringDepositConfiguration', id?: string | null, amount?: number | null, bankAccountId?: string | null, createdAt?: any | null, deactivatedAt?: any | null, deletedAt?: any | null, depositInterval?: DepositIntervalEnum | null, scheduledAt?: any | null, updatedAt?: any | null, userId?: string | null }> | null }, authentication?: { __typename?: 'Authentication', accessToken: string, refreshToken: string, accessTokenExpiresAt: any } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type OAuthCreateUserMutationVariables = Exact<{
  input: OAuthCreateUserInput;
}>;


export type OAuthCreateUserMutation = { __typename?: 'Mutation', oAuthCreateUser: { __typename?: 'OAuthCreateUserPayload', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, broker?: boolean | null, completedDemographicQuestions: boolean, directorOf?: string | null, employmentStatus?: EmploymentStatusEnum | null, politicallyExposedNames?: string | null, targetCashPercentage: number, withdrawalEligibilityStatuses?: Array<WithdrawalEligibilityEnum> | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null, bonusTaskLists?: Array<{ __typename?: 'BonusTaskList', bonusTaskList?: string | null, completedAt?: any | null, description?: string | null, expiresAt?: any | null, rewardAmount?: number | null, bonusTasks?: Array<{ __typename?: 'BonusTask', currentCompletions: number, deepLink: string, description: string, icon: string, instruction?: string | null, targetCompletions: number, completionCriteria?: { __typename?: 'CompletionCriteria', partnerId?: string | null, partnerOfferId?: string | null } | null }> | null }> | null, dailyTaskList?: { __typename?: 'DailyTaskList', id: string, completedAt?: any | null, completedTasksCount: number, completionPercentage: number, selectionStrategy: string, taskDate: any, totalTasksCount: number, tasks: Array<{ __typename?: 'DailyTask', category: string, completed: boolean, completionText: string, currentProgress: number, deepLink?: string | null, description: string, difficulty: string, icon: string, targetCompletions: number, taskKey: string }> } | null, featureOptIns?: Array<{ __typename?: 'UserFeatureOptIn', feature: string, optedIn: boolean, userId: string }> | null, investmentAccounts?: Array<{ __typename?: 'InvestmentAccount', id: string, provisioningCompletedAt?: string | null, provisioningInitiatedAt?: string | null, status?: InvestmentAccountStatusEnum | null }> | null, phoneDetail?: { __typename?: 'PhoneDetail', id: string, carrierMobileCountryCode?: string | null, carrierMobileNetworkCode?: string | null, carrierName?: string | null, carrierType?: string | null, countryCode?: string | null, phone: string, createdAt: any, updatedAt: any } | null, userAttribution?: { __typename?: 'UserAttribution', createdAt?: any | null, platform?: string | null, utmCampaign?: string | null, utmContent?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, utmTerm?: string | null } | null, userRecurringDepositConfigurations?: Array<{ __typename?: 'UserRecurringDepositConfiguration', id?: string | null, amount?: number | null, bankAccountId?: string | null, createdAt?: any | null, deactivatedAt?: any | null, deletedAt?: any | null, depositInterval?: DepositIntervalEnum | null, scheduledAt?: any | null, updatedAt?: any | null, userId?: string | null }> | null } | null, authentication?: { __typename?: 'Authentication', accessToken: string, refreshToken: string, accessTokenExpiresAt: any } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'OAuthCreateUserExistingOAuthError', message: string, path: Array<string> } | { __typename?: 'OAuthCreateUserExistingUserError', message: string, path: Array<string> } | { __typename?: 'OAuthCreateUserInvalidTokenError', message: string, path: Array<string> } | { __typename?: 'OAuthCreateUserTokenExpiredError', message: string, path: Array<string> }> | null } };

export type OAuthSignInUserMutationVariables = Exact<{
  input: OAuthSignInUserInput;
}>;


export type OAuthSignInUserMutation = { __typename?: 'Mutation', oAuthSignInUser: { __typename?: 'OAuthSignInUserPayload', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, broker?: boolean | null, completedDemographicQuestions: boolean, directorOf?: string | null, employmentStatus?: EmploymentStatusEnum | null, politicallyExposedNames?: string | null, targetCashPercentage: number, withdrawalEligibilityStatuses?: Array<WithdrawalEligibilityEnum> | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null, bonusTaskLists?: Array<{ __typename?: 'BonusTaskList', bonusTaskList?: string | null, completedAt?: any | null, description?: string | null, expiresAt?: any | null, rewardAmount?: number | null, bonusTasks?: Array<{ __typename?: 'BonusTask', currentCompletions: number, deepLink: string, description: string, icon: string, instruction?: string | null, targetCompletions: number, completionCriteria?: { __typename?: 'CompletionCriteria', partnerId?: string | null, partnerOfferId?: string | null } | null }> | null }> | null, dailyTaskList?: { __typename?: 'DailyTaskList', id: string, completedAt?: any | null, completedTasksCount: number, completionPercentage: number, selectionStrategy: string, taskDate: any, totalTasksCount: number, tasks: Array<{ __typename?: 'DailyTask', category: string, completed: boolean, completionText: string, currentProgress: number, deepLink?: string | null, description: string, difficulty: string, icon: string, targetCompletions: number, taskKey: string }> } | null, featureOptIns?: Array<{ __typename?: 'UserFeatureOptIn', feature: string, optedIn: boolean, userId: string }> | null, investmentAccounts?: Array<{ __typename?: 'InvestmentAccount', id: string, provisioningCompletedAt?: string | null, provisioningInitiatedAt?: string | null, status?: InvestmentAccountStatusEnum | null }> | null, phoneDetail?: { __typename?: 'PhoneDetail', id: string, carrierMobileCountryCode?: string | null, carrierMobileNetworkCode?: string | null, carrierName?: string | null, carrierType?: string | null, countryCode?: string | null, phone: string, createdAt: any, updatedAt: any } | null, userAttribution?: { __typename?: 'UserAttribution', createdAt?: any | null, platform?: string | null, utmCampaign?: string | null, utmContent?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, utmTerm?: string | null } | null, userRecurringDepositConfigurations?: Array<{ __typename?: 'UserRecurringDepositConfiguration', id?: string | null, amount?: number | null, bankAccountId?: string | null, createdAt?: any | null, deactivatedAt?: any | null, deletedAt?: any | null, depositInterval?: DepositIntervalEnum | null, scheduledAt?: any | null, updatedAt?: any | null, userId?: string | null }> | null } | null, authentication?: { __typename?: 'Authentication', accessToken: string, refreshToken: string, accessTokenExpiresAt: any } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'OAuthSignInNotRegisteredError', message: string, path: Array<string> } | { __typename?: 'OAuthSignInUserAccountClosedError' } | { __typename?: 'OAuthSignInUserInvalidTokenError', message: string, path: Array<string> } | { __typename?: 'OAuthSignInUserTokenExpiredError', message: string, path: Array<string> }> | null } };

export type ConfirmPhoneMutationVariables = Exact<{
  confirmPhoneInput: ConfirmPhoneInput;
}>;


export type ConfirmPhoneMutation = { __typename?: 'Mutation', confirmPhone: { __typename?: 'ConfirmPhonePayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type ResendEmailVerificationMutationVariables = Exact<{
  input: ResendEmailVerificationInput;
}>;


export type ResendEmailVerificationMutation = { __typename?: 'Mutation', resendEmailVerification?: { __typename?: 'ResendEmailVerificationPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type ResendPhoneVerificationMutationVariables = Exact<{
  input: ResendPhoneVerificationInput;
}>;


export type ResendPhoneVerificationMutation = { __typename?: 'Mutation', resendPhoneVerification?: { __typename?: 'ResendPhoneVerificationPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type RegistrationCompleteMutationVariables = Exact<{
  input: RegistrationCompleteInput;
}>;


export type RegistrationCompleteMutation = { __typename?: 'Mutation', registrationComplete: { __typename?: 'RegistrationCompletePayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type SignInMutationVariables = Exact<{
  signInUserInput: SignInUserInput;
}>;


export type SignInMutation = { __typename?: 'Mutation', signInUser?: { __typename?: 'SignInUserPayload', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, broker?: boolean | null, completedDemographicQuestions: boolean, directorOf?: string | null, employmentStatus?: EmploymentStatusEnum | null, politicallyExposedNames?: string | null, targetCashPercentage: number, withdrawalEligibilityStatuses?: Array<WithdrawalEligibilityEnum> | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null, bonusTaskLists?: Array<{ __typename?: 'BonusTaskList', bonusTaskList?: string | null, completedAt?: any | null, description?: string | null, expiresAt?: any | null, rewardAmount?: number | null, bonusTasks?: Array<{ __typename?: 'BonusTask', currentCompletions: number, deepLink: string, description: string, icon: string, instruction?: string | null, targetCompletions: number, completionCriteria?: { __typename?: 'CompletionCriteria', partnerId?: string | null, partnerOfferId?: string | null } | null }> | null }> | null, dailyTaskList?: { __typename?: 'DailyTaskList', id: string, completedAt?: any | null, completedTasksCount: number, completionPercentage: number, selectionStrategy: string, taskDate: any, totalTasksCount: number, tasks: Array<{ __typename?: 'DailyTask', category: string, completed: boolean, completionText: string, currentProgress: number, deepLink?: string | null, description: string, difficulty: string, icon: string, targetCompletions: number, taskKey: string }> } | null, featureOptIns?: Array<{ __typename?: 'UserFeatureOptIn', feature: string, optedIn: boolean, userId: string }> | null, investmentAccounts?: Array<{ __typename?: 'InvestmentAccount', id: string, provisioningCompletedAt?: string | null, provisioningInitiatedAt?: string | null, status?: InvestmentAccountStatusEnum | null }> | null, phoneDetail?: { __typename?: 'PhoneDetail', id: string, carrierMobileCountryCode?: string | null, carrierMobileNetworkCode?: string | null, carrierName?: string | null, carrierType?: string | null, countryCode?: string | null, phone: string, createdAt: any, updatedAt: any } | null, userAttribution?: { __typename?: 'UserAttribution', createdAt?: any | null, platform?: string | null, utmCampaign?: string | null, utmContent?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, utmTerm?: string | null } | null, userRecurringDepositConfigurations?: Array<{ __typename?: 'UserRecurringDepositConfiguration', id?: string | null, amount?: number | null, bankAccountId?: string | null, createdAt?: any | null, deactivatedAt?: any | null, deletedAt?: any | null, depositInterval?: DepositIntervalEnum | null, scheduledAt?: any | null, updatedAt?: any | null, userId?: string | null }> | null } | null, authentication?: { __typename?: 'Authentication', accessToken: string, refreshToken: string, accessTokenExpiresAt: any } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type SignOutUserMutationVariables = Exact<{
  input: SignOutUserInput;
}>;


export type SignOutUserMutation = { __typename?: 'Mutation', signOutUser?: boolean | null };

export type ConfirmEmailMutationVariables = Exact<{
  confirmEmailInput: ConfirmEmailInput;
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', confirmEmail: { __typename?: 'ConfirmEmailPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type ForgotPasswordMutationVariables = Exact<{
  forgotPasswordInput: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type ResetPasswordMutationVariables = Exact<{
  resetPasswordInput: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type SendSignInSmsMutationVariables = Exact<{
  input: SendSignInSmsInput;
}>;


export type SendSignInSmsMutation = { __typename?: 'Mutation', sendSignInSms?: { __typename?: 'SendSignInSMSPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, broker?: boolean | null, completedDemographicQuestions: boolean, directorOf?: string | null, employmentStatus?: EmploymentStatusEnum | null, politicallyExposedNames?: string | null, targetCashPercentage: number, withdrawalEligibilityStatuses?: Array<WithdrawalEligibilityEnum> | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null, bonusTaskLists?: Array<{ __typename?: 'BonusTaskList', bonusTaskList?: string | null, completedAt?: any | null, description?: string | null, expiresAt?: any | null, rewardAmount?: number | null, bonusTasks?: Array<{ __typename?: 'BonusTask', currentCompletions: number, deepLink: string, description: string, icon: string, instruction?: string | null, targetCompletions: number, completionCriteria?: { __typename?: 'CompletionCriteria', partnerId?: string | null, partnerOfferId?: string | null } | null }> | null }> | null, dailyTaskList?: { __typename?: 'DailyTaskList', id: string, completedAt?: any | null, completedTasksCount: number, completionPercentage: number, selectionStrategy: string, taskDate: any, totalTasksCount: number, tasks: Array<{ __typename?: 'DailyTask', category: string, completed: boolean, completionText: string, currentProgress: number, deepLink?: string | null, description: string, difficulty: string, icon: string, targetCompletions: number, taskKey: string }> } | null, featureOptIns?: Array<{ __typename?: 'UserFeatureOptIn', feature: string, optedIn: boolean, userId: string }> | null, investmentAccounts?: Array<{ __typename?: 'InvestmentAccount', id: string, provisioningCompletedAt?: string | null, provisioningInitiatedAt?: string | null, status?: InvestmentAccountStatusEnum | null }> | null, phoneDetail?: { __typename?: 'PhoneDetail', id: string, carrierMobileCountryCode?: string | null, carrierMobileNetworkCode?: string | null, carrierName?: string | null, carrierType?: string | null, countryCode?: string | null, phone: string, createdAt: any, updatedAt: any } | null, userAttribution?: { __typename?: 'UserAttribution', createdAt?: any | null, platform?: string | null, utmCampaign?: string | null, utmContent?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, utmTerm?: string | null } | null, userRecurringDepositConfigurations?: Array<{ __typename?: 'UserRecurringDepositConfiguration', id?: string | null, amount?: number | null, bankAccountId?: string | null, createdAt?: any | null, deactivatedAt?: any | null, deletedAt?: any | null, depositInterval?: DepositIntervalEnum | null, scheduledAt?: any | null, updatedAt?: any | null, userId?: string | null }> | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type UpdateAddressMutationVariables = Exact<{
  addressInput: AddressInput;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', address?: { __typename?: 'AddressPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type UpdatePhoneMutationVariables = Exact<{
  updatePhoneInput: UpdatePhoneInput;
}>;


export type UpdatePhoneMutation = { __typename?: 'Mutation', updatePhone: { __typename?: 'UpdatePhonePayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type CreateUserFeatureOptInMutationVariables = Exact<{
  input: CreateUserFeatureOptInInput;
}>;


export type CreateUserFeatureOptInMutation = { __typename?: 'Mutation', createUserFeatureOptIn: { __typename?: 'CreateUserFeatureOptInPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type UpsertUserFeatureOptInMutationVariables = Exact<{
  input: UpsertUserFeatureOptInInput;
}>;


export type UpsertUserFeatureOptInMutation = { __typename?: 'Mutation', upsertUserFeatureOptIn: { __typename?: 'UpsertUserFeatureOptInPayload', userFeatureOptIn?: { __typename?: 'UserFeatureOptIn', feature: string, optedIn: boolean, userId: string } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type SetUserAttributionMutationVariables = Exact<{
  input: SetUserAttributionInput;
}>;


export type SetUserAttributionMutation = { __typename?: 'Mutation', setUserAttribution: { __typename?: 'SetUserAttributionPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'InvalidUserAttributionError', message: string, path: Array<string> }> | null } };

export type CreateWithdrawalMutationVariables = Exact<{
  input: CreateWithdrawalInput;
}>;


export type CreateWithdrawalMutation = { __typename?: 'Mutation', createWithdrawal?: { __typename?: 'CreateWithdrawalPayload', transaction?: { __typename: 'Withdrawal', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type AccountClosureAppSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountClosureAppSettingsQuery = { __typename?: 'Query', appSettings: { __typename?: 'AppSettings', accountClosureLifetimeEarningsMinimumAmount: number, accountClosurePotentialEarningsLostAmount: number, accountClosureRetentionOfferCategoryIds: Array<string> } };

export type KeepAccessAppSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type KeepAccessAppSettingsQuery = { __typename?: 'Query', appSettings: { __typename?: 'AppSettings', keepAccessEligibleDiscountCode: string, keepAccessEligibleTitle: string, keepAccessEligibleSplash: string, keepAccessEligibleDescription: string, keepAccessEligibleButtonText: string, keepAccessIneligibleDiscountCode: string, keepAccessIneligibleTitle: string, keepAccessIneligibleSplash: string, keepAccessIneligibleDescription: string, keepAccessIneligibleButtonText: string } };

export type AddDataContainersQueryVariables = Exact<{ [key: string]: never; }>;


export type AddDataContainersQuery = { __typename?: 'Query', addDataContainers: Array<{ __typename?: 'QuestionContainer', id: string, name: string, buttonLabel?: string | null, buttonTooltipText?: string | null, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename: 'InputAdministrativeArea', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputBoolean', trueOptionLabel?: string | null, falseOptionLabel?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputChipsSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, chips: Array<{ __typename?: 'Chip', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputCurrency', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputDate', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputGroup', id: string, text: string, required: boolean, rewardAmount?: number | null, questions?: Array<{ __typename: 'InputAdministrativeArea', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputBoolean', trueOptionLabel?: string | null, falseOptionLabel?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputChipsSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, chips: Array<{ __typename?: 'Chip', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputCurrency', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputDate', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputGroup', id: string, text: string, required: boolean, rewardAmount?: number | null } | { __typename: 'InputListSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputNumber', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputPostalCode', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputStyledButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'StyledButton', label: string, value: string, buttonColor?: string | null, shortDescription?: string | null }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputText', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputListSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputNumber', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputPostalCode', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputStyledButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'StyledButton', label: string, value: string, buttonColor?: string | null, shortDescription?: string | null }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputText', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null }> | null } | null> };

export type NextAvailableDataContainerQueryVariables = Exact<{
  placementName?: InputMaybe<Scalars['String']['input']>;
}>;


export type NextAvailableDataContainerQuery = { __typename?: 'Query', nextAvailableDataContainer?: { __typename?: 'QuestionContainer', id: string, name: string, buttonLabel?: string | null, buttonTooltipText?: string | null, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename: 'InputAdministrativeArea', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputBoolean', trueOptionLabel?: string | null, falseOptionLabel?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputChipsSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, chips: Array<{ __typename?: 'Chip', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputCurrency', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputDate', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputGroup', id: string, text: string, required: boolean, rewardAmount?: number | null, questions?: Array<{ __typename: 'InputAdministrativeArea', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputBoolean', trueOptionLabel?: string | null, falseOptionLabel?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputChipsSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, chips: Array<{ __typename?: 'Chip', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputCurrency', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputDate', id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputGroup', id: string, text: string, required: boolean, rewardAmount?: number | null } | { __typename: 'InputListSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputNumber', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputPostalCode', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputStyledButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'StyledButton', label: string, value: string, buttonColor?: string | null, shortDescription?: string | null }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputText', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputListSelection', id: string, text: string, required: boolean, rewardAmount?: number | null, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputNumber', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputPostalCode', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputStyledButtonSelection', multiple: boolean, rank: boolean, minSelections?: number | null, id: string, text: string, required: boolean, rewardAmount?: number | null, buttons: Array<{ __typename?: 'StyledButton', label: string, value: string, buttonColor?: string | null, shortDescription?: string | null }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null } | { __typename: 'InputText', placeholderText?: string | null, id: string, text: string, required: boolean, rewardAmount?: number | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, createdAt?: any | null, updatedAt?: any | null } | null }> | null } | null };

export type MonitoredBankAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type MonitoredBankAccountsQuery = { __typename?: 'Query', monitoredBankAccounts?: Array<{ __typename?: 'MonitoredBankAccount', balance?: number | null, balanceLastUpdatedAt?: any | null, canUnlink: boolean, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, createdAt: any, deletedAt?: string | null, displayAccountNumber?: string | null, id: string, logo?: string | null, name?: string | null, requireReauth?: boolean | null, subtype?: MonitoredBankAccountSubtypeEnum | null, type?: MonitoredBankAccountTypeEnum | null }> | null };

export type MonitoredBankAccountTransactionsQueryVariables = Exact<{
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  merchant?: InputMaybe<Scalars['String']['input']>;
  monitoredBankAccountId?: InputMaybe<Scalars['ID']['input']>;
  primaryCategory?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<BankAccountTransactionSort>;
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type MonitoredBankAccountTransactionsQuery = { __typename?: 'Query', monitoredBankAccountTransactions: Array<{ __typename?: 'MonitoredBankAccountTransaction', amount: number, date: any, deleted: boolean, detailedCategory?: string | null, id: string, ignored: boolean, merchantLogoUrl?: string | null, merchantName?: string | null, monitoredBankAccountId: string, name: string, nameOverride?: string | null, needsCategorization: boolean, paymentChannel?: PaymentChannelEnum | null, pending: boolean, primaryCategory?: string | null, primaryCategoryOverride?: string | null, recurringTransactionId?: string | null, updatedAt: any, website?: string | null, location?: { __typename?: 'Location', address?: string | null, city?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, postalCode?: string | null, region?: string | null, storeNumber?: string | null } | null }> };

export type RecurringTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecurringTransactionsQuery = { __typename?: 'Query', recurringTransactions?: Array<{ __typename?: 'RecurringTransaction', id: string, amount: number, createdAt: any, firstTransactionDate?: any | null, frequency: RecurringTransactionFrequencyEnum, lastTransactionDate?: any | null, name: string, nextTransactionDate?: any | null, transactionCount?: number | null, updatedAt: any, userId: string }> | null };

export type BalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type BalanceQuery = { __typename?: 'Query', balance?: { __typename?: 'Balance', available?: string | null, total?: string | null, availableToWithdraw?: string | null, cashTotal?: string | null, cumulativeEarned?: string | null, cumulativeEarnedPast30Days?: string | null, pending?: string | null } | null };

export type BudgetsQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetsQuery = { __typename?: 'Query', budgets?: Array<{ __typename?: 'Budget', id: string, amount: number, category: string, month: any, inactiveAt?: any | null, createdAt: any, updatedAt: any, userId: string }> | null };

export type CashAdvanceStateQueryVariables = Exact<{ [key: string]: never; }>;


export type CashAdvanceStateQuery = { __typename?: 'Query', cashAdvanceApplicationCapability: boolean, cashAdvanceApplication?: { __typename?: 'CashAdvanceApplication', id: string, pendingMessage?: string | null, plaidSyncInDarkHours: boolean, rejectionDetails?: Array<string> | null, status: CashAdvanceApplicationStatus, submittedAt?: any | null, bankAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null } | null, cashAdvanceApprovedAmount: { __typename?: 'CashAdvanceApprovedAmount', amount?: string | null, approvedUntil?: any | null, eligibilityFailures: Array<EligibilityFailureReasonEnum>, rejectionMessages: Array<string> }, cashAdvanceActiveRequests: Array<{ __typename?: 'CashAdvanceRequest', id: string, amount: string, amountNeededToRepay?: string | null, amountRepaidViaRewards: string, createdAt?: any | null, expectedRepaymentDate?: any | null, inFlightPayment: boolean, repaymentAmount: string, status: CashAdvanceRequestStatus, transferType: CashAdvanceRequestTransferType, fees: Array<{ __typename?: 'CashAdvanceFee', amount: string, feeType: CashAdvanceFeeType }> }>, paymentAccounts?: Array<{ __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null }> | null };

export type CashAdvancePromoStateQueryVariables = Exact<{ [key: string]: never; }>;


export type CashAdvancePromoStateQuery = { __typename?: 'Query', cashAdvanceApplicationCapability: boolean, cashAdvanceApplication?: { __typename?: 'CashAdvanceApplication', id: string, pendingMessage?: string | null, plaidSyncInDarkHours: boolean, rejectionDetails?: Array<string> | null, status: CashAdvanceApplicationStatus, submittedAt?: any | null, bankAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null } | null, cashAdvanceApprovedAmount: { __typename?: 'CashAdvanceApprovedAmount', amount?: string | null, approvedUntil?: any | null, eligibilityFailures: Array<EligibilityFailureReasonEnum>, rejectionMessages: Array<string> }, cashAdvanceActiveRequests: Array<{ __typename?: 'CashAdvanceRequest', id: string, amount: string, amountNeededToRepay?: string | null, amountRepaidViaRewards: string, createdAt?: any | null, expectedRepaymentDate?: any | null, inFlightPayment: boolean, repaymentAmount: string, status: CashAdvanceRequestStatus, transferType: CashAdvanceRequestTransferType, fees: Array<{ __typename?: 'CashAdvanceFee', amount: string, feeType: CashAdvanceFeeType }> }> };

export type CashAdvanceApplicationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CashAdvanceApplicationStatusQuery = { __typename?: 'Query', cashAdvanceApplication?: { __typename?: 'CashAdvanceApplication', id: string, status: CashAdvanceApplicationStatus, pendingMessage?: string | null } | null };

export type CashAdvanceActiveRequestsStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CashAdvanceActiveRequestsStatusQuery = { __typename?: 'Query', cashAdvanceActiveRequests: Array<{ __typename?: 'CashAdvanceRequest', id: string, status: CashAdvanceRequestStatus, inFlightPayment: boolean, amountNeededToRepay?: string | null, repaymentAmount: string }> };

export type CashAdvanceQuoteQueryVariables = Exact<{
  amount: Scalars['String']['input'];
  tip?: InputMaybe<Scalars['String']['input']>;
  transferType: CashAdvanceRequestTransferType;
}>;


export type CashAdvanceQuoteQuery = { __typename?: 'Query', cashAdvanceQuote: { __typename?: 'CashAdvanceRequest', id: string, amount: string, amountNeededToRepay?: string | null, amountRepaidViaRewards: string, createdAt?: any | null, expectedRepaymentDate?: any | null, inFlightPayment: boolean, repaymentAmount: string, status: CashAdvanceRequestStatus, transferType: CashAdvanceRequestTransferType, fees: Array<{ __typename?: 'CashAdvanceFee', amount: string, feeType: CashAdvanceFeeType }> } };

export type CashAdvanceAsapFeeScheduleQueryVariables = Exact<{ [key: string]: never; }>;


export type CashAdvanceAsapFeeScheduleQuery = { __typename?: 'Query', cashAdvanceAsapFeeSchedule: Array<{ __typename?: 'CashAdvanceFeeSchedule', amount: string, label: string }> };

export type CashAdvanceAppSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CashAdvanceAppSettingsQuery = { __typename?: 'Query', appSettings: { __typename?: 'AppSettings', cashAdvanceMinimumAmount: number, cashAdvanceMaximumAmount: number, cashAdvanceMinimumMonthlyIncome: number, cashAdvanceMonthlyFee: number, cashAdvanceFirstMonthFee: number, cashAdvanceMembershipCopy: string, cashAdvanceAchTransferCopy: string, cashAdvanceDeclineScreenCategory: string } };

export type CashAdvanceTransactionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CashAdvanceTransactionsQuery = { __typename?: 'Query', cashAdvanceTransactions?: { __typename?: 'TransactionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename: 'AtmSubscriptionFee', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'AtmSubscriptionFeePayment', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'CashAdvance', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'CashAdvanceRepayment', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'CashAdvanceTip', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'CashAdvanceTransferFee', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'DataDividend', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'InactivityFeeDisplay', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'InvestmentDeposit', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'InvestmentWithdrawal', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'UserOnetimeDeposit', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'UserRecurringDeposit', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'Withdrawal', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'WithdrawalFee', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | null> | null } | null };

export type PublicOffersForUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
  placementId: Scalars['ID']['input'];
}>;


export type PublicOffersForUrlQuery = { __typename?: 'Query', publicOffersForUrl?: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | { __typename?: 'Survey' } | null> | null } | null };

export type FindPartnerOfferCategoryByIdQueryVariables = Exact<{
  categoryId: Scalars['ID']['input'];
  placementId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FindPartnerOfferCategoryByIdQuery = { __typename?: 'Query', findPartnerOfferCategoryById?: { __typename?: 'PartnerOfferCategory', id: string, name: string, bannerUrl?: string | null, priorityOrder?: number | null, myFullPartnerOffers1: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | { __typename: 'Survey', id: string, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, timeToComplete?: string | null, top?: boolean | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | null> | null }, displayMetadata: { __typename?: 'PartnerOfferCategoryDisplayMetadata', viewAllPaginationAmount: number, detailDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null }, featuredDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null }, mainDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null } } } | null };

export type PartnerOfferPlacementByIdOffersQueryVariables = Exact<{
  placementId: Scalars['ID']['input'];
  partnerOfferId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PartnerOfferPlacementByIdOffersQuery = { __typename?: 'Query', publicOffersForPlacement?: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | { __typename?: 'Survey' } | null> | null } | null };

export type PublicOffersForPlacementQueryVariables = Exact<{
  placementId: Scalars['ID']['input'];
  partnerOfferId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PublicOffersForPlacementQuery = { __typename?: 'Query', publicOffersForPlacement?: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | { __typename?: 'Survey' } | null> | null } | null };

export type PublicOffersForPlacementPartnerLinksQueryVariables = Exact<{
  placementId: Scalars['ID']['input'];
  partnerOfferId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PublicOffersForPlacementPartnerLinksQuery = { __typename?: 'Query', publicOffersForPlacement?: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename?: 'Deal', ctaUrl?: string | null, partner: { __typename?: 'Partner', name: string } } | { __typename?: 'Survey' } | null> | null } | null };

export type OffersForPlacementQueryVariables = Exact<{
  placementId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OffersForPlacementQuery = { __typename?: 'Query', offersForPlacement?: { __typename?: 'PartnerOfferUnionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Deal' } | { __typename?: 'Survey', id: string, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, timeToComplete?: string | null, top?: boolean | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | null> | null } | null };

export type MorePortalCategoriesQueryVariables = Exact<{
  categoriesFirst?: InputMaybe<Scalars['Int']['input']>;
  categoriesAfter?: InputMaybe<Scalars['String']['input']>;
  offersFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MorePortalCategoriesQuery = { __typename?: 'Query', user?: { __typename?: 'User', id?: string | null, myCategories?: { __typename?: 'PartnerOfferCategoryConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'PartnerOfferCategory', id: string, name: string, bannerUrl?: string | null, priorityOrder?: number | null, myPartnerOffers1: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | { __typename?: 'Survey' } | null> | null }, displayMetadata: { __typename?: 'PartnerOfferCategoryDisplayMetadata', viewAllPaginationAmount: number, detailDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null }, featuredDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null }, mainDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null } } } | null> | null } | null } | null };

export type PaymentAccountChangeAllowedQueryVariables = Exact<{
  transferMethod: PaymentAccountTransferMethod;
}>;


export type PaymentAccountChangeAllowedQuery = { __typename?: 'Query', paymentAccountChangeAllowed: PaymentAccountChangeAllowedStatus };

export type ReferralQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralQuery = { __typename?: 'Query', referral?: { __typename?: 'Referral', code: string, referrerName?: string | null, rewardAmount: string, rewardCriteria: ReferralRewardCriteriaEnum, rewardCriteriaDescription: string, history: Array<{ __typename?: 'ReferralHistory', referralId?: string | null, firstName?: string | null, lastName?: string | null, amount: string, createdAt: any, qualifiedAt?: any | null, rewardCriteria: ReferralRewardCriteriaEnum }> } | null };

export type SubscriptionsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SubscriptionsQuery = { __typename?: 'Query', subscriptions?: Array<{ __typename?: 'Subscription', id: string, activeAt?: any | null, cancelledAt?: any | null, createdAt: any, inactiveAt?: any | null, initialFeeChargedAt?: any | null, nextFeeChargedAt: any, productKey: SubscriptionProductEnum, proratedRefundAmount?: number | null, status: CashAdvanceSubscriptionStatus, product: { __typename?: 'SubscriptionProduct', key: SubscriptionProductEnum, name: string, description: string, fee: number, feeSchedule: SubscriptionFeeSchedule, footnotes: Array<string>, trialDurationDays: number, features: Array<{ __typename?: 'SubscriptionProductFeature', title: string, description: string }> }, nextCalculatedFee: { __typename?: 'CalculatedFee', amount: number, baseAmount: number, calculatedFeeDiscounts: Array<{ __typename?: 'CalculatedFeeDiscount', amount: number, code: string, name: string, subscriptionDiscountId: string }> } }> | null };

export type SubscriptionFeesOutstandingQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionFeesOutstandingQuery = { __typename?: 'Query', subscriptionFeesOutstanding?: Array<{ __typename?: 'SubscriptionFee', id: string, amount: number, chargedAt: any, description?: string | null, lastPaymentAttemptAt?: any | null }> | null };

export type KeepAccessSubscriptionAllowedQueryVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
}>;


export type KeepAccessSubscriptionAllowedQuery = { __typename?: 'Query', keepAccessSubscriptionAllowed: boolean };

export type UserQueryVariables = Exact<{
  categoriesFirst?: InputMaybe<Scalars['Int']['input']>;
  offersFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, broker?: boolean | null, completedDemographicQuestions: boolean, directorOf?: string | null, employmentStatus?: EmploymentStatusEnum | null, politicallyExposedNames?: string | null, targetCashPercentage: number, withdrawalEligibilityStatuses?: Array<WithdrawalEligibilityEnum> | null, myCategories?: { __typename?: 'PartnerOfferCategoryConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'PartnerOfferCategory', id: string, name: string, bannerUrl?: string | null, priorityOrder?: number | null, myPartnerOffers1: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | { __typename?: 'Survey' } | null> | null }, displayMetadata: { __typename?: 'PartnerOfferCategoryDisplayMetadata', viewAllPaginationAmount: number, detailDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null }, featuredDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null }, mainDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null } } } | null> | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null, bonusTaskLists?: Array<{ __typename?: 'BonusTaskList', bonusTaskList?: string | null, completedAt?: any | null, description?: string | null, expiresAt?: any | null, rewardAmount?: number | null, bonusTasks?: Array<{ __typename?: 'BonusTask', currentCompletions: number, deepLink: string, description: string, icon: string, instruction?: string | null, targetCompletions: number, completionCriteria?: { __typename?: 'CompletionCriteria', partnerId?: string | null, partnerOfferId?: string | null } | null }> | null }> | null, dailyTaskList?: { __typename?: 'DailyTaskList', id: string, completedAt?: any | null, completedTasksCount: number, completionPercentage: number, selectionStrategy: string, taskDate: any, totalTasksCount: number, tasks: Array<{ __typename?: 'DailyTask', category: string, completed: boolean, completionText: string, currentProgress: number, deepLink?: string | null, description: string, difficulty: string, icon: string, targetCompletions: number, taskKey: string }> } | null, featureOptIns?: Array<{ __typename?: 'UserFeatureOptIn', feature: string, optedIn: boolean, userId: string }> | null, investmentAccounts?: Array<{ __typename?: 'InvestmentAccount', id: string, provisioningCompletedAt?: string | null, provisioningInitiatedAt?: string | null, status?: InvestmentAccountStatusEnum | null }> | null, phoneDetail?: { __typename?: 'PhoneDetail', id: string, carrierMobileCountryCode?: string | null, carrierMobileNetworkCode?: string | null, carrierName?: string | null, carrierType?: string | null, countryCode?: string | null, phone: string, createdAt: any, updatedAt: any } | null, userAttribution?: { __typename?: 'UserAttribution', createdAt?: any | null, platform?: string | null, utmCampaign?: string | null, utmContent?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, utmTerm?: string | null } | null, userRecurringDepositConfigurations?: Array<{ __typename?: 'UserRecurringDepositConfiguration', id?: string | null, amount?: number | null, bankAccountId?: string | null, createdAt?: any | null, deactivatedAt?: any | null, deletedAt?: any | null, depositInterval?: DepositIntervalEnum | null, scheduledAt?: any | null, updatedAt?: any | null, userId?: string | null }> | null } | null };

export type AvailableFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableFeaturesQuery = { __typename?: 'Query', availableFeatures?: { __typename?: 'AvailableFeatures', cashAdvanceRequest: boolean, pfmAdditionalAccounts: boolean, pfmBase: boolean, pfmCustomCategories: boolean, pfmExports: boolean, pfmRefreshTransactions: boolean } | null };

export type CurrentUserIdentityQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserIdentityQuery = { __typename?: 'Query', user?: { __typename?: 'User', id?: string | null } | null };

export type CheckIdentifierQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Phone>;
}>;


export type CheckIdentifierQuery = { __typename?: 'Query', checkIdentifier: { __typename?: 'CheckIdentifierResult', action: string, message?: string | null } };

export type RecentTransactionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecentTransactionsQuery = { __typename?: 'Query', recentTransactions?: { __typename?: 'TransactionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename: 'AtmSubscriptionFee', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'AtmSubscriptionFeePayment', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'CashAdvance', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'CashAdvanceRepayment', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'CashAdvanceTip', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'CashAdvanceTransferFee', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'DataDividend', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'InactivityFeeDisplay', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'InvestmentDeposit', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'InvestmentWithdrawal', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'UserOnetimeDeposit', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'UserRecurringDeposit', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'Withdrawal', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | { __typename: 'WithdrawalFee', id: string, amount: string, createdAt: any, updatedAt: any, iconImageUrl: string, merchantName?: string | null, parentUserTransactionId?: string | null, partnerId?: string | null, source: string, status: TransactionStatusEnum, subtag?: string | null, tag?: string | null, title: string, criteria?: string | null, explainer?: string | null } | null> | null } | null };

export type WithdrawalCapabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type WithdrawalCapabilityQuery = { __typename?: 'Query', withdrawalCapability?: { __typename?: 'WithdrawalCapability', availableToWithdraw: string, minBalance: number, withdrawalIncrement: number, withdrawalMinLimit: number, withdrawalMaxLimit: number, speeds: Array<{ __typename?: 'WithdrawalSpeedCapability', speed: WithdrawalSpeed, enabled: boolean }> } | null };

export type WithdrawalFeeQuotesQueryVariables = Exact<{
  amount: Scalars['Float']['input'];
}>;


export type WithdrawalFeeQuotesQuery = { __typename?: 'Query', withdrawalFeeQuotes: Array<{ __typename?: 'WithdrawalFeeQuote', speed: WithdrawalSpeed, fee: number, enabled: boolean }> };

export type PaymentAccountsQueryVariables = Exact<{
  transferMethod?: InputMaybe<PaymentAccountTransferMethod>;
  includeUnlinked?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PaymentAccountsQuery = { __typename?: 'Query', paymentAccounts?: Array<{ __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, cardlyticsHasOffers: boolean, cardlyticsLinked: boolean, cardlyticsLinkedAt?: any | null, cashAdvanceUsable?: CashAdvanceUsableStatus | null, deletedAt?: string | null, displayAccountNumber?: string | null, expirationDate?: any | null, gatewayWithdrawalFee?: string | null, health?: BankAccountHealthEnum | null, id: string, logo?: string | null, name?: string | null, relinkable: boolean, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null }> | null };

export type WalletAppSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type WalletAppSettingsQuery = { __typename?: 'Query', appSettings: { __typename?: 'AppSettings', lifetimeEarningsInfoCopy: string, availableBalanceInfoCopy: string, pendingBalanceInfoCopy: string } };

export const QuestionImageFragmentFragmentDoc = gql`
    fragment QuestionImageFragment on QuestionImage {
  url
}
    `;
export const UserDataVaultQuestionResponseFragmentFragmentDoc = gql`
    fragment UserDataVaultQuestionResponseFragment on UserDataVaultQuestionResponse {
  value
  createdAt
  updatedAt
}
    `;
export const QuestionFragmentFragmentDoc = gql`
    fragment QuestionFragment on Question {
  id
  text
  required
  rewardAmount
  images {
    ...QuestionImageFragment
  }
  userResponse {
    ...UserDataVaultQuestionResponseFragment
  }
}
    ${QuestionImageFragmentFragmentDoc}
${UserDataVaultQuestionResponseFragmentFragmentDoc}`;
export const InputAdministrativeAreaFragmentFragmentDoc = gql`
    fragment InputAdministrativeAreaFragment on InputAdministrativeArea {
  ...QuestionFragment
  placeholderText
}
    ${QuestionFragmentFragmentDoc}`;
export const InputBooleanFragmentFragmentDoc = gql`
    fragment InputBooleanFragment on InputBoolean {
  ...QuestionFragment
  trueOptionLabel
  falseOptionLabel
}
    ${QuestionFragmentFragmentDoc}`;
export const ButtonFragmentFragmentDoc = gql`
    fragment ButtonFragment on Button {
  label
  value
}
    `;
export const InputButtonSelectionFragmentFragmentDoc = gql`
    fragment InputButtonSelectionFragment on InputButtonSelection {
  ...QuestionFragment
  multiple
  rank
  minSelections
  buttons {
    ...ButtonFragment
  }
}
    ${QuestionFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}`;
export const ChipFragmentFragmentDoc = gql`
    fragment ChipFragment on Chip {
  label
  value
}
    `;
export const InputChipsSelectionFragmentFragmentDoc = gql`
    fragment InputChipsSelectionFragment on InputChipsSelection {
  ...QuestionFragment
  multiple
  rank
  minSelections
  chips {
    ...ChipFragment
  }
}
    ${QuestionFragmentFragmentDoc}
${ChipFragmentFragmentDoc}`;
export const InputCurrencyFragmentFragmentDoc = gql`
    fragment InputCurrencyFragment on InputCurrency {
  ...QuestionFragment
  placeholderText
}
    ${QuestionFragmentFragmentDoc}`;
export const InputDateFragmentFragmentDoc = gql`
    fragment InputDateFragment on InputDate {
  ...QuestionFragment
}
    ${QuestionFragmentFragmentDoc}`;
export const OptionFragmentFragmentDoc = gql`
    fragment OptionFragment on Option {
  label
  value
}
    `;
export const InputListSelectionFragmentFragmentDoc = gql`
    fragment InputListSelectionFragment on InputListSelection {
  ...QuestionFragment
  options {
    ...OptionFragment
  }
}
    ${QuestionFragmentFragmentDoc}
${OptionFragmentFragmentDoc}`;
export const InputNumberFragmentFragmentDoc = gql`
    fragment InputNumberFragment on InputNumber {
  ...QuestionFragment
  placeholderText
}
    ${QuestionFragmentFragmentDoc}`;
export const InputPostalCodeFragmentFragmentDoc = gql`
    fragment InputPostalCodeFragment on InputPostalCode {
  ...QuestionFragment
  placeholderText
}
    ${QuestionFragmentFragmentDoc}`;
export const StyledButtonFragmentFragmentDoc = gql`
    fragment StyledButtonFragment on StyledButton {
  label
  value
  buttonColor
  shortDescription
}
    `;
export const InputStyledButtonSelectionFragmentFragmentDoc = gql`
    fragment InputStyledButtonSelectionFragment on InputStyledButtonSelection {
  ...QuestionFragment
  multiple
  rank
  minSelections
  buttons {
    ...StyledButtonFragment
  }
}
    ${QuestionFragmentFragmentDoc}
${StyledButtonFragmentFragmentDoc}`;
export const InputTextFragmentFragmentDoc = gql`
    fragment InputTextFragment on InputText {
  ...QuestionFragment
  placeholderText
}
    ${QuestionFragmentFragmentDoc}`;
export const InputGroupFragmentFragmentDoc = gql`
    fragment InputGroupFragment on InputGroup {
  ...QuestionFragment
  questions {
    __typename
    ... on InputAdministrativeArea {
      ...InputAdministrativeAreaFragment
    }
    ... on InputBoolean {
      ...InputBooleanFragment
    }
    ... on InputButtonSelection {
      ...InputButtonSelectionFragment
    }
    ... on InputChipsSelection {
      ...InputChipsSelectionFragment
    }
    ... on InputCurrency {
      ...InputCurrencyFragment
    }
    ... on InputDate {
      ...InputDateFragment
    }
    ... on InputListSelection {
      ...InputListSelectionFragment
    }
    ... on InputNumber {
      ...InputNumberFragment
    }
    ... on InputPostalCode {
      ...InputPostalCodeFragment
    }
    ... on InputStyledButtonSelection {
      ...InputStyledButtonSelectionFragment
    }
    ... on InputText {
      ...InputTextFragment
    }
    ... on InputGroup {
      id
      text
      required
      rewardAmount
    }
  }
}
    ${QuestionFragmentFragmentDoc}
${InputAdministrativeAreaFragmentFragmentDoc}
${InputBooleanFragmentFragmentDoc}
${InputButtonSelectionFragmentFragmentDoc}
${InputChipsSelectionFragmentFragmentDoc}
${InputCurrencyFragmentFragmentDoc}
${InputDateFragmentFragmentDoc}
${InputListSelectionFragmentFragmentDoc}
${InputNumberFragmentFragmentDoc}
${InputPostalCodeFragmentFragmentDoc}
${InputStyledButtonSelectionFragmentFragmentDoc}
${InputTextFragmentFragmentDoc}`;
export const QuestionContainerFragmentFragmentDoc = gql`
    fragment QuestionContainerFragment on QuestionContainer {
  id
  name
  buttonLabel
  buttonTooltipText
  category {
    name
  }
  questions {
    __typename
    ... on InputAdministrativeArea {
      ...InputAdministrativeAreaFragment
    }
    ... on InputBoolean {
      ...InputBooleanFragment
    }
    ... on InputButtonSelection {
      ...InputButtonSelectionFragment
    }
    ... on InputChipsSelection {
      ...InputChipsSelectionFragment
    }
    ... on InputCurrency {
      ...InputCurrencyFragment
    }
    ... on InputDate {
      ...InputDateFragment
    }
    ... on InputGroup {
      ...InputGroupFragment
    }
    ... on InputListSelection {
      ...InputListSelectionFragment
    }
    ... on InputNumber {
      ...InputNumberFragment
    }
    ... on InputPostalCode {
      ...InputPostalCodeFragment
    }
    ... on InputStyledButtonSelection {
      ...InputStyledButtonSelectionFragment
    }
    ... on InputText {
      ...InputTextFragment
    }
  }
}
    ${InputAdministrativeAreaFragmentFragmentDoc}
${InputBooleanFragmentFragmentDoc}
${InputButtonSelectionFragmentFragmentDoc}
${InputChipsSelectionFragmentFragmentDoc}
${InputCurrencyFragmentFragmentDoc}
${InputDateFragmentFragmentDoc}
${InputGroupFragmentFragmentDoc}
${InputListSelectionFragmentFragmentDoc}
${InputNumberFragmentFragmentDoc}
${InputPostalCodeFragmentFragmentDoc}
${InputStyledButtonSelectionFragmentFragmentDoc}
${InputTextFragmentFragmentDoc}`;
export const PlaidLinkTokenFragmentFragmentDoc = gql`
    fragment PlaidLinkTokenFragment on PlaidLinkToken {
  expiration
  linkToken
}
    `;
export const MonitoredBankAccountFragmentFragmentDoc = gql`
    fragment MonitoredBankAccountFragment on MonitoredBankAccount {
  balance
  balanceLastUpdatedAt
  canUnlink
  cardlyticsHasOffers
  cardlyticsLinked
  cardlyticsLinkedAt
  createdAt
  deletedAt
  displayAccountNumber
  id
  logo
  name
  requireReauth
  subtype
  type
}
    `;
export const LocationFragmentFragmentDoc = gql`
    fragment LocationFragment on Location {
  address
  city
  country
  latitude
  longitude
  postalCode
  region
  storeNumber
}
    `;
export const MonitoredBankAccountTransactionFragmentFragmentDoc = gql`
    fragment MonitoredBankAccountTransactionFragment on MonitoredBankAccountTransaction {
  amount
  date
  deleted
  detailedCategory
  id
  ignored
  location {
    ...LocationFragment
  }
  merchantLogoUrl
  merchantName
  monitoredBankAccountId
  name
  nameOverride
  needsCategorization
  paymentChannel
  pending
  primaryCategory
  primaryCategoryOverride
  recurringTransactionId
  updatedAt
  website
}
    ${LocationFragmentFragmentDoc}`;
export const RecurringTransactionFragmentFragmentDoc = gql`
    fragment RecurringTransactionFragment on RecurringTransaction {
  id
  amount
  createdAt
  firstTransactionDate
  frequency
  lastTransactionDate
  name
  nextTransactionDate
  transactionCount
  updatedAt
  userId
}
    `;
export const BalanceFragmentFragmentDoc = gql`
    fragment BalanceFragment on Balance {
  available
  total
  availableToWithdraw
  cashTotal
  cumulativeEarned
  cumulativeEarnedPast30Days
  pending
}
    `;
export const BudgetFragmentFragmentDoc = gql`
    fragment BudgetFragment on Budget {
  id
  amount
  category
  month
  inactiveAt
  createdAt
  updatedAt
  userId
}
    `;
export const CashAdvanceFeeScheduleFragmentFragmentDoc = gql`
    fragment CashAdvanceFeeScheduleFragment on CashAdvanceFeeSchedule {
  amount
  label
}
    `;
export const CashAdvanceFeeFragmentFragmentDoc = gql`
    fragment CashAdvanceFeeFragment on CashAdvanceFee {
  amount
  feeType
}
    `;
export const CashAdvanceRequestFragmentFragmentDoc = gql`
    fragment CashAdvanceRequestFragment on CashAdvanceRequest {
  id
  amount
  amountNeededToRepay
  amountRepaidViaRewards
  createdAt
  expectedRepaymentDate
  inFlightPayment
  repaymentAmount
  status
  transferType
  fees {
    ...CashAdvanceFeeFragment
  }
}
    ${CashAdvanceFeeFragmentFragmentDoc}`;
export const BankAccountFragmentFragmentDoc = gql`
    fragment BankAccountFragment on BankAccount {
  allowDeposit
  allowWithdrawal
  cardlyticsHasOffers
  cardlyticsLinked
  cardlyticsLinkedAt
  cashAdvanceUsable
  deletedAt
  displayAccountNumber
  expirationDate
  gatewayWithdrawalFee
  health
  id
  logo
  name
  relinkable
  requireReauth
  status
  transferMethod
}
    `;
export const CashAdvanceApplicationFragmentFragmentDoc = gql`
    fragment CashAdvanceApplicationFragment on CashAdvanceApplication {
  id
  pendingMessage
  plaidSyncInDarkHours
  rejectionDetails
  status
  submittedAt
  bankAccount {
    ...BankAccountFragment
  }
}
    ${BankAccountFragmentFragmentDoc}`;
export const CashAdvanceApprovedAmountFragmentFragmentDoc = gql`
    fragment CashAdvanceApprovedAmountFragment on CashAdvanceApprovedAmount {
  amount
  approvedUntil
  eligibilityFailures
  rejectionMessages
}
    `;
export const CashAdvanceEvaluationFragmentFragmentDoc = gql`
    fragment CashAdvanceEvaluationFragment on CashAdvanceEvaluation {
  id
  allowedAmount
  eligibilityFailures
  rejectionMessages
}
    `;
export const ChatUserFragmentFragmentDoc = gql`
    fragment ChatUserFragment on ChatUser {
  identity
  token
}
    `;
export const ErrorFragmentFragmentDoc = gql`
    fragment ErrorFragment on Error {
  message
  path
}
    `;
export const CreateChatTokenPayloadFragmentFragmentDoc = gql`
    fragment CreateChatTokenPayloadFragment on CreateChatTokenPayload {
  chatUser {
    ...ChatUserFragment
  }
  errors {
    ...ErrorFragment
  }
}
    ${ChatUserFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export const CreateSessionPayloadFragmentFragmentDoc = gql`
    fragment CreateSessionPayloadFragment on CreateSessionPayload {
  chatkitSession {
    clientSecret
  }
  errors {
    ...ErrorFragment
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const OAuthAccountCreationErrorFragmentDoc = gql`
    fragment OAuthAccountCreationError on OAuthCreateUserError {
  ... on Error {
    ...ErrorFragment
  }
  ... on OAuthCreateUserExistingOAuthError {
    message
    path
  }
  ... on OAuthCreateUserExistingUserError {
    message
    path
  }
  ... on OAuthCreateUserInvalidTokenError {
    message
    path
  }
  ... on OAuthCreateUserTokenExpiredError {
    message
    path
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const OAuthAccountSignInErrorFragmentDoc = gql`
    fragment OAuthAccountSignInError on OAuthSignInUserError {
  ... on Error {
    ...ErrorFragment
  }
  ... on OAuthSignInNotRegisteredError {
    message
    path
  }
  ... on OAuthSignInUserInvalidTokenError {
    message
    path
  }
  ... on OAuthSignInUserTokenExpiredError {
    message
    path
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const NotifyReferredUserErrorFragmentFragmentDoc = gql`
    fragment NotifyReferredUserErrorFragment on NotifyReferredUserError {
  ... on Error {
    ...ErrorFragment
  }
  ... on RateLimitExceededError {
    message
    path
  }
  ... on ReferralNotFoundError {
    message
    path
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const PauseSubscriptionErrorFragmentFragmentDoc = gql`
    fragment PauseSubscriptionErrorFragment on PauseSubscriptionErrors {
  ... on Error {
    ...ErrorFragment
  }
  ... on PauseSubscriptionActiveAdvanceError {
    message
    path
  }
  ... on PauseSubscriptionCanceledError {
    message
    path
  }
  ... on PauseSubscriptionInactiveError {
    message
    path
  }
  ... on PauseSubscriptionNoSubscriptionError {
    message
    path
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const ResumeSubscriptionErrorFragmentFragmentDoc = gql`
    fragment ResumeSubscriptionErrorFragment on ResumeSubscriptionErrors {
  ... on Error {
    ...ErrorFragment
  }
  ... on ResumeSubscriptionActiveError {
    message
    path
  }
  ... on ResumeSubscriptionCanceledError {
    message
    path
  }
  ... on ResumeSubscriptionLinkedCardUnhealthyError {
    message
    path
  }
  ... on ResumeSubscriptionNoSubscriptionError {
    message
    path
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const RunCashAdvanceEvaluationErrorFragmentFragmentDoc = gql`
    fragment RunCashAdvanceEvaluationErrorFragment on RunCashAdvanceEvaluationErrors {
  ... on EvaluationAlreadyRunError {
    message
    path
  }
  ... on NoPaymentAccountError {
    message
    path
  }
  ... on PaymentAccountUnusableError {
    message
    path
  }
}
    `;
export const PayOutstandingFeeErrorFragmentFragmentDoc = gql`
    fragment PayOutstandingFeeErrorFragment on PayOutstandingFeeError {
  ... on Error {
    ...ErrorFragment
  }
  ... on NoOutStandingFeeError {
    message
    path
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const CreateAccountClosureAttemptErrorFragmentFragmentDoc = gql`
    fragment CreateAccountClosureAttemptErrorFragment on CreateAccountClosureAttemptError {
  ... on Error {
    ...ErrorFragment
  }
  ... on CreateAccountClosureAttemptValidationError {
    message
    path
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const CreateClosureRequestErrorFragmentFragmentDoc = gql`
    fragment CreateClosureRequestErrorFragment on CreateClosureRequestError {
  ... on Error {
    ...ErrorFragment
  }
  ... on CreateClosureRequestAlreadyClosingError {
    message
    path
  }
  ... on CreateClosureRequestCashAdvanceRequestNotRepaidError {
    message
    path
  }
  ... on CreateClosureRequestUnableToRetrieveACHAccountNumberError {
    message
    path
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const KeepAccessSubscriptionErrorFragmentFragmentDoc = gql`
    fragment KeepAccessSubscriptionErrorFragment on KeepAccessSubscriptionErrors {
  ... on Error {
    ...ErrorFragment
  }
  ... on KeepAccessSubscriptionAlreadyUsedDiscountError {
    message
    path
  }
  ... on KeepAccessSubscriptionInvalidDiscountError {
    message
    path
  }
  ... on KeepAccessSubscriptionNoSubscriptionError {
    message
    path
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const ClientEventFragmentFragmentDoc = gql`
    fragment ClientEventFragment on ClientEvent {
  data
  name
  partnerId
  partnerOfferId
  requestId
  servedImpressionId
}
    `;
export const DealFragmentFragmentDoc = gql`
    fragment DealFragment on Deal {
  id
  completedAt
  createdAt
  cta
  ctaClickBehavior
  ctaUrl
  description
  disclosure
  expectedRewardTimeline
  offerType
  updatedAt
  termsAndConditionsUrl
  skipOfferDetails
  servedImpressionId
  savingsAmount
  potentialRewardTotal {
    amount
    originalAmount
    rewardType
  }
  partner {
    bannerUrl
    createdAt
    shortDescription
    name
    minimalOfferDetailOverride
    id
    iconUrl
    description
    dataUsageDescription
  }
  cardHeadline
  cardDescription
}
    `;
export const SurveyFragmentFragmentDoc = gql`
    fragment SurveyFragment on Survey {
  id
  createdAt
  cta
  ctaClickBehavior
  ctaUrl
  description
  disclosure
  offerType
  updatedAt
  termsAndConditionsUrl
  skipOfferDetails
  servedImpressionId
  savingsAmount
  potentialRewardTotal {
    amount
    originalAmount
    rewardType
  }
  partner {
    bannerUrl
    createdAt
    shortDescription
    name
    minimalOfferDetailOverride
    id
    iconUrl
    description
    dataUsageDescription
  }
  cardHeadline
  cardDescription
  timeToComplete
  top
}
    `;
export const PartnerOfferUnionFragmentFragmentDoc = gql`
    fragment PartnerOfferUnionFragment on PartnerOfferUnion {
  __typename
  ... on Deal {
    ...DealFragment
  }
  ... on Survey {
    ...SurveyFragment
  }
}
    ${DealFragmentFragmentDoc}
${SurveyFragmentFragmentDoc}`;
export const PartnerOfferCategoryDisplayStylingFragmentFragmentDoc = gql`
    fragment PartnerOfferCategoryDisplayStylingFragment on PartnerOfferCategoryDisplayStyling {
  axis
  backgroundColor
  cardStyle
  columns
  rows
}
    `;
export const PartnerOfferCategoryFragmentFragmentDoc = gql`
    fragment PartnerOfferCategoryFragment on PartnerOfferCategory {
  id
  name
  bannerUrl
  displayMetadata {
    detailDisplayStyling {
      ...PartnerOfferCategoryDisplayStylingFragment
    }
    featuredDisplayStyling {
      ...PartnerOfferCategoryDisplayStylingFragment
    }
    mainDisplayStyling {
      ...PartnerOfferCategoryDisplayStylingFragment
    }
    viewAllPaginationAmount
  }
  priorityOrder
}
    ${PartnerOfferCategoryDisplayStylingFragmentFragmentDoc}`;
export const UserOfferCategoryFragmentFragmentDoc = gql`
    fragment UserOfferCategoryFragment on PartnerOfferCategory {
  ...PartnerOfferCategoryFragment
  myPartnerOffers1(first: $offersFirst) {
    nodes {
      ... on Deal {
        ...DealFragment
      }
    }
  }
}
    ${PartnerOfferCategoryFragmentFragmentDoc}
${DealFragmentFragmentDoc}`;
export const ReferralHistoryFragmentFragmentDoc = gql`
    fragment ReferralHistoryFragment on ReferralHistory {
  referralId
  firstName
  lastName
  amount
  createdAt
  qualifiedAt
  rewardCriteria
}
    `;
export const ReferralFragmentFragmentDoc = gql`
    fragment ReferralFragment on Referral {
  code
  referrerName
  rewardAmount
  rewardCriteria
  rewardCriteriaDescription
  history {
    ...ReferralHistoryFragment
  }
}
    ${ReferralHistoryFragmentFragmentDoc}`;
export const SubscriptionFeeFragmentFragmentDoc = gql`
    fragment SubscriptionFeeFragment on SubscriptionFee {
  id
  amount
  chargedAt
  description
  lastPaymentAttemptAt
}
    `;
export const SubscriptionProductFragmentFragmentDoc = gql`
    fragment SubscriptionProductFragment on SubscriptionProduct {
  key
  name
  description
  fee
  feeSchedule
  footnotes
  trialDurationDays
  features {
    title
    description
  }
}
    `;
export const CalculatedFeeFragmentFragmentDoc = gql`
    fragment CalculatedFeeFragment on CalculatedFee {
  amount
  baseAmount
  calculatedFeeDiscounts {
    amount
    code
    name
    subscriptionDiscountId
  }
}
    `;
export const SubscriptionFragmentFragmentDoc = gql`
    fragment SubscriptionFragment on Subscription {
  id
  activeAt
  cancelledAt
  createdAt
  inactiveAt
  initialFeeChargedAt
  nextFeeChargedAt
  productKey
  proratedRefundAmount
  status
  product {
    ...SubscriptionProductFragment
  }
  nextCalculatedFee {
    ...CalculatedFeeFragment
  }
}
    ${SubscriptionProductFragmentFragmentDoc}
${CalculatedFeeFragmentFragmentDoc}`;
export const TransactionFragmentFragmentDoc = gql`
    fragment TransactionFragment on Transaction {
  __typename
  id
  amount
  createdAt
  updatedAt
  iconImageUrl
  merchantName
  parentUserTransactionId
  partnerId
  source
  status
  subtag
  tag
  title
  criteria
  explainer
}
    `;
export const AddressFragmentFragmentDoc = gql`
    fragment AddressFragment on Address {
  id
  address1
  address2
  administrativeArea
  locality
  postalCode
  primary
  createdAt
  deletedAt
  updatedAt
}
    `;
export const ActiveExperimentFragmentFragmentDoc = gql`
    fragment ActiveExperimentFragment on ActiveExperiment {
  testName
  variant
  details
}
    `;
export const BonusTaskFragmentFragmentDoc = gql`
    fragment BonusTaskFragment on BonusTask {
  completionCriteria {
    partnerId
    partnerOfferId
  }
  currentCompletions
  deepLink
  description
  icon
  instruction
  targetCompletions
}
    `;
export const BonusTaskListFragmentFragmentDoc = gql`
    fragment BonusTaskListFragment on BonusTaskList {
  bonusTaskList
  bonusTasks {
    ...BonusTaskFragment
  }
  completedAt
  description
  expiresAt
  rewardAmount
}
    ${BonusTaskFragmentFragmentDoc}`;
export const DailyTaskFragmentFragmentDoc = gql`
    fragment DailyTaskFragment on DailyTask {
  category
  completed
  completionText
  currentProgress
  deepLink
  description
  difficulty
  icon
  targetCompletions
  taskKey
}
    `;
export const DailyTaskListFragmentFragmentDoc = gql`
    fragment DailyTaskListFragment on DailyTaskList {
  id
  completedAt
  completedTasksCount
  completionPercentage
  selectionStrategy
  taskDate
  tasks {
    ...DailyTaskFragment
  }
  totalTasksCount
}
    ${DailyTaskFragmentFragmentDoc}`;
export const UserFeatureOptInFragmentFragmentDoc = gql`
    fragment UserFeatureOptInFragment on UserFeatureOptIn {
  feature
  optedIn
  userId
}
    `;
export const InvestmentAccountFragmentFragmentDoc = gql`
    fragment InvestmentAccountFragment on InvestmentAccount {
  id
  provisioningCompletedAt
  provisioningInitiatedAt
  status
}
    `;
export const PhoneDetailFragmentFragmentDoc = gql`
    fragment PhoneDetailFragment on PhoneDetail {
  id
  carrierMobileCountryCode
  carrierMobileNetworkCode
  carrierName
  carrierType
  countryCode
  phone
  createdAt
  updatedAt
}
    `;
export const UserAttributionFragmentFragmentDoc = gql`
    fragment UserAttributionFragment on UserAttribution {
  createdAt
  platform
  utmCampaign
  utmContent
  utmId
  utmMedium
  utmSource
  utmTerm
}
    `;
export const UserRecurringDepositConfigurationFragmentFragmentDoc = gql`
    fragment UserRecurringDepositConfigurationFragment on UserRecurringDepositConfiguration {
  id
  amount
  bankAccountId
  createdAt
  deactivatedAt
  deletedAt
  depositInterval
  scheduledAt
  updatedAt
  userId
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  id
  firstName
  lastName
  email
  dob
  gender
  phone
  confirmationSentAt
  phoneConfirmedAt
  emailConfirmedAt
  registrationCompletedAt
  broker
  completedDemographicQuestions
  directorOf
  employmentStatus
  politicallyExposedNames
  targetCashPercentage
  withdrawalEligibilityStatuses
  addresses {
    ...AddressFragment
  }
  activeExperiments {
    ...ActiveExperimentFragment
  }
  bonusTaskLists {
    ...BonusTaskListFragment
  }
  dailyTaskList {
    ...DailyTaskListFragment
  }
  featureOptIns {
    ...UserFeatureOptInFragment
  }
  investmentAccounts {
    ...InvestmentAccountFragment
  }
  phoneDetail {
    ...PhoneDetailFragment
  }
  userAttribution {
    ...UserAttributionFragment
  }
  userRecurringDepositConfigurations {
    ...UserRecurringDepositConfigurationFragment
  }
}
    ${AddressFragmentFragmentDoc}
${ActiveExperimentFragmentFragmentDoc}
${BonusTaskListFragmentFragmentDoc}
${DailyTaskListFragmentFragmentDoc}
${UserFeatureOptInFragmentFragmentDoc}
${InvestmentAccountFragmentFragmentDoc}
${PhoneDetailFragmentFragmentDoc}
${UserAttributionFragmentFragmentDoc}
${UserRecurringDepositConfigurationFragmentFragmentDoc}`;
export const ResetPasswordPayloadFragmentFragmentDoc = gql`
    fragment ResetPasswordPayloadFragment on ResetPasswordPayload {
  errors {
    ...ErrorFragment
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const AvailableFeaturesFragmentFragmentDoc = gql`
    fragment AvailableFeaturesFragment on AvailableFeatures {
  cashAdvanceRequest
  pfmAdditionalAccounts
  pfmBase
  pfmCustomCategories
  pfmExports
  pfmRefreshTransactions
}
    `;
export const WithdrawalCapabilityFragmentFragmentDoc = gql`
    fragment WithdrawalCapabilityFragment on WithdrawalCapability {
  availableToWithdraw
  minBalance
  withdrawalIncrement
  withdrawalMinLimit
  withdrawalMaxLimit
  speeds {
    speed
    enabled
  }
}
    `;
export const CreateAccountClosureAttemptDocument = gql`
    mutation CreateAccountClosureAttempt($input: CreateAccountClosureAttemptInput!) {
  createAccountClosureAttempt(input: $input) {
    accountClosureAttempt {
      id
      reason
    }
    errors {
      ...CreateAccountClosureAttemptErrorFragment
    }
  }
}
    ${CreateAccountClosureAttemptErrorFragmentFragmentDoc}`;
export type CreateAccountClosureAttemptMutationFn = Apollo.MutationFunction<CreateAccountClosureAttemptMutation, CreateAccountClosureAttemptMutationVariables>;

/**
 * __useCreateAccountClosureAttemptMutation__
 *
 * To run a mutation, you first call `useCreateAccountClosureAttemptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountClosureAttemptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountClosureAttemptMutation, { data, loading, error }] = useCreateAccountClosureAttemptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountClosureAttemptMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountClosureAttemptMutation, CreateAccountClosureAttemptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountClosureAttemptMutation, CreateAccountClosureAttemptMutationVariables>(CreateAccountClosureAttemptDocument, options);
      }
export type CreateAccountClosureAttemptMutationHookResult = ReturnType<typeof useCreateAccountClosureAttemptMutation>;
export type CreateAccountClosureAttemptMutationResult = Apollo.MutationResult<CreateAccountClosureAttemptMutation>;
export type CreateAccountClosureAttemptMutationOptions = Apollo.BaseMutationOptions<CreateAccountClosureAttemptMutation, CreateAccountClosureAttemptMutationVariables>;
export const CreateClosureRequestDocument = gql`
    mutation CreateClosureRequest($input: CreateClosureRequestInput!) {
  createClosureRequest(input: $input) {
    success
    errors {
      ...CreateClosureRequestErrorFragment
    }
  }
}
    ${CreateClosureRequestErrorFragmentFragmentDoc}`;
export type CreateClosureRequestMutationFn = Apollo.MutationFunction<CreateClosureRequestMutation, CreateClosureRequestMutationVariables>;

/**
 * __useCreateClosureRequestMutation__
 *
 * To run a mutation, you first call `useCreateClosureRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClosureRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClosureRequestMutation, { data, loading, error }] = useCreateClosureRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClosureRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateClosureRequestMutation, CreateClosureRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClosureRequestMutation, CreateClosureRequestMutationVariables>(CreateClosureRequestDocument, options);
      }
export type CreateClosureRequestMutationHookResult = ReturnType<typeof useCreateClosureRequestMutation>;
export type CreateClosureRequestMutationResult = Apollo.MutationResult<CreateClosureRequestMutation>;
export type CreateClosureRequestMutationOptions = Apollo.BaseMutationOptions<CreateClosureRequestMutation, CreateClosureRequestMutationVariables>;
export const AnswerQuestionDocument = gql`
    mutation AnswerQuestion($input: AnswerQuestionInput!) {
  answerQuestion(input: $input) {
    errors {
      ...ErrorFragment
    }
    nextAvailableDataContainer {
      ...QuestionContainerFragment
    }
    partnerBid {
      id
    }
  }
}
    ${ErrorFragmentFragmentDoc}
${QuestionContainerFragmentFragmentDoc}`;
export type AnswerQuestionMutationFn = Apollo.MutationFunction<AnswerQuestionMutation, AnswerQuestionMutationVariables>;

/**
 * __useAnswerQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerQuestionMutation, { data, loading, error }] = useAnswerQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AnswerQuestionMutation, AnswerQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerQuestionMutation, AnswerQuestionMutationVariables>(AnswerQuestionDocument, options);
      }
export type AnswerQuestionMutationHookResult = ReturnType<typeof useAnswerQuestionMutation>;
export type AnswerQuestionMutationResult = Apollo.MutationResult<AnswerQuestionMutation>;
export type AnswerQuestionMutationOptions = Apollo.BaseMutationOptions<AnswerQuestionMutation, AnswerQuestionMutationVariables>;
export const SkipContainerDocument = gql`
    mutation SkipContainer($input: SkipContainerInput!) {
  skipContainer(input: $input) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type SkipContainerMutationFn = Apollo.MutationFunction<SkipContainerMutation, SkipContainerMutationVariables>;

/**
 * __useSkipContainerMutation__
 *
 * To run a mutation, you first call `useSkipContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipContainerMutation, { data, loading, error }] = useSkipContainerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkipContainerMutation(baseOptions?: Apollo.MutationHookOptions<SkipContainerMutation, SkipContainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipContainerMutation, SkipContainerMutationVariables>(SkipContainerDocument, options);
      }
export type SkipContainerMutationHookResult = ReturnType<typeof useSkipContainerMutation>;
export type SkipContainerMutationResult = Apollo.MutationResult<SkipContainerMutation>;
export type SkipContainerMutationOptions = Apollo.BaseMutationOptions<SkipContainerMutation, SkipContainerMutationVariables>;
export const RefreshUserSessionDocument = gql`
    mutation RefreshUserSession($input: RefreshUserSessionInput!) {
  refreshUserSession(input: $input) {
    authentication {
      accessToken
      refreshToken
      accessTokenExpiresAt
    }
    errors {
      __typename
      ... on ErrorInterface {
        message
        path
      }
    }
  }
}
    `;
export type RefreshUserSessionMutationFn = Apollo.MutationFunction<RefreshUserSessionMutation, RefreshUserSessionMutationVariables>;

/**
 * __useRefreshUserSessionMutation__
 *
 * To run a mutation, you first call `useRefreshUserSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshUserSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshUserSessionMutation, { data, loading, error }] = useRefreshUserSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshUserSessionMutation(baseOptions?: Apollo.MutationHookOptions<RefreshUserSessionMutation, RefreshUserSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshUserSessionMutation, RefreshUserSessionMutationVariables>(RefreshUserSessionDocument, options);
      }
export type RefreshUserSessionMutationHookResult = ReturnType<typeof useRefreshUserSessionMutation>;
export type RefreshUserSessionMutationResult = Apollo.MutationResult<RefreshUserSessionMutation>;
export type RefreshUserSessionMutationOptions = Apollo.BaseMutationOptions<RefreshUserSessionMutation, RefreshUserSessionMutationVariables>;
export const CreateLinkTokenDocument = gql`
    mutation CreateLinkToken($linkAccountType: LinkAccountTypeEnum) {
  createLinkToken(linkAccountType: $linkAccountType) {
    errors {
      ...ErrorFragment
    }
    linkToken {
      ...PlaidLinkTokenFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}
${PlaidLinkTokenFragmentFragmentDoc}`;
export type CreateLinkTokenMutationFn = Apollo.MutationFunction<CreateLinkTokenMutation, CreateLinkTokenMutationVariables>;

/**
 * __useCreateLinkTokenMutation__
 *
 * To run a mutation, you first call `useCreateLinkTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkTokenMutation, { data, loading, error }] = useCreateLinkTokenMutation({
 *   variables: {
 *      linkAccountType: // value for 'linkAccountType'
 *   },
 * });
 */
export function useCreateLinkTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkTokenMutation, CreateLinkTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkTokenMutation, CreateLinkTokenMutationVariables>(CreateLinkTokenDocument, options);
      }
export type CreateLinkTokenMutationHookResult = ReturnType<typeof useCreateLinkTokenMutation>;
export type CreateLinkTokenMutationResult = Apollo.MutationResult<CreateLinkTokenMutation>;
export type CreateLinkTokenMutationOptions = Apollo.BaseMutationOptions<CreateLinkTokenMutation, CreateLinkTokenMutationVariables>;
export const ChangeBankAccountDocument = gql`
    mutation ChangeBankAccount($input: ChangeBankAccountInput!) {
  changeBankAccount(input: $input) {
    bankAccount {
      ...BankAccountFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${BankAccountFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type ChangeBankAccountMutationFn = Apollo.MutationFunction<ChangeBankAccountMutation, ChangeBankAccountMutationVariables>;

/**
 * __useChangeBankAccountMutation__
 *
 * To run a mutation, you first call `useChangeBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeBankAccountMutation, { data, loading, error }] = useChangeBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<ChangeBankAccountMutation, ChangeBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeBankAccountMutation, ChangeBankAccountMutationVariables>(ChangeBankAccountDocument, options);
      }
export type ChangeBankAccountMutationHookResult = ReturnType<typeof useChangeBankAccountMutation>;
export type ChangeBankAccountMutationResult = Apollo.MutationResult<ChangeBankAccountMutation>;
export type ChangeBankAccountMutationOptions = Apollo.BaseMutationOptions<ChangeBankAccountMutation, ChangeBankAccountMutationVariables>;
export const UnlinkBankAccountDocument = gql`
    mutation UnlinkBankAccount($input: UnlinkBankAccountInput!) {
  unlinkBankAccount(input: $input) {
    bankAccount {
      ...BankAccountFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${BankAccountFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UnlinkBankAccountMutationFn = Apollo.MutationFunction<UnlinkBankAccountMutation, UnlinkBankAccountMutationVariables>;

/**
 * __useUnlinkBankAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkBankAccountMutation, { data, loading, error }] = useUnlinkBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkBankAccountMutation, UnlinkBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkBankAccountMutation, UnlinkBankAccountMutationVariables>(UnlinkBankAccountDocument, options);
      }
export type UnlinkBankAccountMutationHookResult = ReturnType<typeof useUnlinkBankAccountMutation>;
export type UnlinkBankAccountMutationResult = Apollo.MutationResult<UnlinkBankAccountMutation>;
export type UnlinkBankAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkBankAccountMutation, UnlinkBankAccountMutationVariables>;
export const LinkMonitoredAccountDocument = gql`
    mutation LinkMonitoredAccount($input: LinkAccountInput!) {
  linkMonitoredAccount(input: $input) {
    monitoredBankAccounts {
      ...MonitoredBankAccountFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${MonitoredBankAccountFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type LinkMonitoredAccountMutationFn = Apollo.MutationFunction<LinkMonitoredAccountMutation, LinkMonitoredAccountMutationVariables>;

/**
 * __useLinkMonitoredAccountMutation__
 *
 * To run a mutation, you first call `useLinkMonitoredAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkMonitoredAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkMonitoredAccountMutation, { data, loading, error }] = useLinkMonitoredAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkMonitoredAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkMonitoredAccountMutation, LinkMonitoredAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkMonitoredAccountMutation, LinkMonitoredAccountMutationVariables>(LinkMonitoredAccountDocument, options);
      }
export type LinkMonitoredAccountMutationHookResult = ReturnType<typeof useLinkMonitoredAccountMutation>;
export type LinkMonitoredAccountMutationResult = Apollo.MutationResult<LinkMonitoredAccountMutation>;
export type LinkMonitoredAccountMutationOptions = Apollo.BaseMutationOptions<LinkMonitoredAccountMutation, LinkMonitoredAccountMutationVariables>;
export const UpsertBudgetDocument = gql`
    mutation UpsertBudget($input: UpsertBudgetInput!) {
  upsertBudget(input: $input) {
    budget {
      ...BudgetFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${BudgetFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UpsertBudgetMutationFn = Apollo.MutationFunction<UpsertBudgetMutation, UpsertBudgetMutationVariables>;

/**
 * __useUpsertBudgetMutation__
 *
 * To run a mutation, you first call `useUpsertBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBudgetMutation, { data, loading, error }] = useUpsertBudgetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertBudgetMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBudgetMutation, UpsertBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertBudgetMutation, UpsertBudgetMutationVariables>(UpsertBudgetDocument, options);
      }
export type UpsertBudgetMutationHookResult = ReturnType<typeof useUpsertBudgetMutation>;
export type UpsertBudgetMutationResult = Apollo.MutationResult<UpsertBudgetMutation>;
export type UpsertBudgetMutationOptions = Apollo.BaseMutationOptions<UpsertBudgetMutation, UpsertBudgetMutationVariables>;
export const CalibrateBudgetsDocument = gql`
    mutation CalibrateBudgets($input: CalibrateBudgetsInput!) {
  calibrateBudgets(input: $input) {
    budgets {
      ...BudgetFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${BudgetFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CalibrateBudgetsMutationFn = Apollo.MutationFunction<CalibrateBudgetsMutation, CalibrateBudgetsMutationVariables>;

/**
 * __useCalibrateBudgetsMutation__
 *
 * To run a mutation, you first call `useCalibrateBudgetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalibrateBudgetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calibrateBudgetsMutation, { data, loading, error }] = useCalibrateBudgetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalibrateBudgetsMutation(baseOptions?: Apollo.MutationHookOptions<CalibrateBudgetsMutation, CalibrateBudgetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalibrateBudgetsMutation, CalibrateBudgetsMutationVariables>(CalibrateBudgetsDocument, options);
      }
export type CalibrateBudgetsMutationHookResult = ReturnType<typeof useCalibrateBudgetsMutation>;
export type CalibrateBudgetsMutationResult = Apollo.MutationResult<CalibrateBudgetsMutation>;
export type CalibrateBudgetsMutationOptions = Apollo.BaseMutationOptions<CalibrateBudgetsMutation, CalibrateBudgetsMutationVariables>;
export const CreatePaymentAccountDocument = gql`
    mutation CreatePaymentAccount($input: CreatePaymentAccountInput!) {
  createPaymentAccount(input: $input) {
    paymentAccount {
      ...BankAccountFragment
    }
    errors {
      ... on ErrorInterface {
        message
        path
      }
    }
  }
}
    ${BankAccountFragmentFragmentDoc}`;
export type CreatePaymentAccountMutationFn = Apollo.MutationFunction<CreatePaymentAccountMutation, CreatePaymentAccountMutationVariables>;

/**
 * __useCreatePaymentAccountMutation__
 *
 * To run a mutation, you first call `useCreatePaymentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentAccountMutation, { data, loading, error }] = useCreatePaymentAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentAccountMutation, CreatePaymentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentAccountMutation, CreatePaymentAccountMutationVariables>(CreatePaymentAccountDocument, options);
      }
export type CreatePaymentAccountMutationHookResult = ReturnType<typeof useCreatePaymentAccountMutation>;
export type CreatePaymentAccountMutationResult = Apollo.MutationResult<CreatePaymentAccountMutation>;
export type CreatePaymentAccountMutationOptions = Apollo.BaseMutationOptions<CreatePaymentAccountMutation, CreatePaymentAccountMutationVariables>;
export const CreateCashAdvanceApplicationDocument = gql`
    mutation CreateCashAdvanceApplication($input: CreateCashAdvanceApplicationInput!) {
  createCashAdvanceApplication(input: $input) {
    cashAdvanceApplication {
      ...CashAdvanceApplicationFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${CashAdvanceApplicationFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CreateCashAdvanceApplicationMutationFn = Apollo.MutationFunction<CreateCashAdvanceApplicationMutation, CreateCashAdvanceApplicationMutationVariables>;

/**
 * __useCreateCashAdvanceApplicationMutation__
 *
 * To run a mutation, you first call `useCreateCashAdvanceApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashAdvanceApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashAdvanceApplicationMutation, { data, loading, error }] = useCreateCashAdvanceApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCashAdvanceApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCashAdvanceApplicationMutation, CreateCashAdvanceApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCashAdvanceApplicationMutation, CreateCashAdvanceApplicationMutationVariables>(CreateCashAdvanceApplicationDocument, options);
      }
export type CreateCashAdvanceApplicationMutationHookResult = ReturnType<typeof useCreateCashAdvanceApplicationMutation>;
export type CreateCashAdvanceApplicationMutationResult = Apollo.MutationResult<CreateCashAdvanceApplicationMutation>;
export type CreateCashAdvanceApplicationMutationOptions = Apollo.BaseMutationOptions<CreateCashAdvanceApplicationMutation, CreateCashAdvanceApplicationMutationVariables>;
export const AssignBankAccountToCashAdvanceApplicationDocument = gql`
    mutation AssignBankAccountToCashAdvanceApplication($input: AssignBankAccountToCashAdvanceApplicationInput!) {
  assignBankAccountToCashAdvanceApplication(input: $input) {
    cashAdvanceApplication {
      ...CashAdvanceApplicationFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${CashAdvanceApplicationFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type AssignBankAccountToCashAdvanceApplicationMutationFn = Apollo.MutationFunction<AssignBankAccountToCashAdvanceApplicationMutation, AssignBankAccountToCashAdvanceApplicationMutationVariables>;

/**
 * __useAssignBankAccountToCashAdvanceApplicationMutation__
 *
 * To run a mutation, you first call `useAssignBankAccountToCashAdvanceApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignBankAccountToCashAdvanceApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignBankAccountToCashAdvanceApplicationMutation, { data, loading, error }] = useAssignBankAccountToCashAdvanceApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignBankAccountToCashAdvanceApplicationMutation(baseOptions?: Apollo.MutationHookOptions<AssignBankAccountToCashAdvanceApplicationMutation, AssignBankAccountToCashAdvanceApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignBankAccountToCashAdvanceApplicationMutation, AssignBankAccountToCashAdvanceApplicationMutationVariables>(AssignBankAccountToCashAdvanceApplicationDocument, options);
      }
export type AssignBankAccountToCashAdvanceApplicationMutationHookResult = ReturnType<typeof useAssignBankAccountToCashAdvanceApplicationMutation>;
export type AssignBankAccountToCashAdvanceApplicationMutationResult = Apollo.MutationResult<AssignBankAccountToCashAdvanceApplicationMutation>;
export type AssignBankAccountToCashAdvanceApplicationMutationOptions = Apollo.BaseMutationOptions<AssignBankAccountToCashAdvanceApplicationMutation, AssignBankAccountToCashAdvanceApplicationMutationVariables>;
export const SubmitCashAdvanceApplicationDocument = gql`
    mutation SubmitCashAdvanceApplication($input: SubmitCashAdvanceApplicationInput!) {
  submitCashAdvanceApplication(input: $input) {
    cashAdvanceApplication {
      ...CashAdvanceApplicationFragment
    }
    cashAdvanceEvaluation {
      ...CashAdvanceEvaluationFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${CashAdvanceApplicationFragmentFragmentDoc}
${CashAdvanceEvaluationFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type SubmitCashAdvanceApplicationMutationFn = Apollo.MutationFunction<SubmitCashAdvanceApplicationMutation, SubmitCashAdvanceApplicationMutationVariables>;

/**
 * __useSubmitCashAdvanceApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitCashAdvanceApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCashAdvanceApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCashAdvanceApplicationMutation, { data, loading, error }] = useSubmitCashAdvanceApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCashAdvanceApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCashAdvanceApplicationMutation, SubmitCashAdvanceApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCashAdvanceApplicationMutation, SubmitCashAdvanceApplicationMutationVariables>(SubmitCashAdvanceApplicationDocument, options);
      }
export type SubmitCashAdvanceApplicationMutationHookResult = ReturnType<typeof useSubmitCashAdvanceApplicationMutation>;
export type SubmitCashAdvanceApplicationMutationResult = Apollo.MutationResult<SubmitCashAdvanceApplicationMutation>;
export type SubmitCashAdvanceApplicationMutationOptions = Apollo.BaseMutationOptions<SubmitCashAdvanceApplicationMutation, SubmitCashAdvanceApplicationMutationVariables>;
export const CreateCashAdvanceRequestDocument = gql`
    mutation CreateCashAdvanceRequest($input: CreateCashAdvanceRequestInput!) {
  createCashAdvanceRequest(input: $input) {
    cashAdvanceRequest {
      ...CashAdvanceRequestFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${CashAdvanceRequestFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CreateCashAdvanceRequestMutationFn = Apollo.MutationFunction<CreateCashAdvanceRequestMutation, CreateCashAdvanceRequestMutationVariables>;

/**
 * __useCreateCashAdvanceRequestMutation__
 *
 * To run a mutation, you first call `useCreateCashAdvanceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashAdvanceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashAdvanceRequestMutation, { data, loading, error }] = useCreateCashAdvanceRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCashAdvanceRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateCashAdvanceRequestMutation, CreateCashAdvanceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCashAdvanceRequestMutation, CreateCashAdvanceRequestMutationVariables>(CreateCashAdvanceRequestDocument, options);
      }
export type CreateCashAdvanceRequestMutationHookResult = ReturnType<typeof useCreateCashAdvanceRequestMutation>;
export type CreateCashAdvanceRequestMutationResult = Apollo.MutationResult<CreateCashAdvanceRequestMutation>;
export type CreateCashAdvanceRequestMutationOptions = Apollo.BaseMutationOptions<CreateCashAdvanceRequestMutation, CreateCashAdvanceRequestMutationVariables>;
export const RunCashAdvanceEvaluationDocument = gql`
    mutation RunCashAdvanceEvaluation($input: RunCashAdvanceEvaluationInput!) {
  runCashAdvanceEvaluation(input: $input) {
    cashAdvanceEvaluation {
      ...CashAdvanceEvaluationFragment
    }
    errors {
      ...RunCashAdvanceEvaluationErrorFragment
    }
  }
}
    ${CashAdvanceEvaluationFragmentFragmentDoc}
${RunCashAdvanceEvaluationErrorFragmentFragmentDoc}`;
export type RunCashAdvanceEvaluationMutationFn = Apollo.MutationFunction<RunCashAdvanceEvaluationMutation, RunCashAdvanceEvaluationMutationVariables>;

/**
 * __useRunCashAdvanceEvaluationMutation__
 *
 * To run a mutation, you first call `useRunCashAdvanceEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunCashAdvanceEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runCashAdvanceEvaluationMutation, { data, loading, error }] = useRunCashAdvanceEvaluationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunCashAdvanceEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<RunCashAdvanceEvaluationMutation, RunCashAdvanceEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunCashAdvanceEvaluationMutation, RunCashAdvanceEvaluationMutationVariables>(RunCashAdvanceEvaluationDocument, options);
      }
export type RunCashAdvanceEvaluationMutationHookResult = ReturnType<typeof useRunCashAdvanceEvaluationMutation>;
export type RunCashAdvanceEvaluationMutationResult = Apollo.MutationResult<RunCashAdvanceEvaluationMutation>;
export type RunCashAdvanceEvaluationMutationOptions = Apollo.BaseMutationOptions<RunCashAdvanceEvaluationMutation, RunCashAdvanceEvaluationMutationVariables>;
export const RepayCashAdvanceRequestDocument = gql`
    mutation RepayCashAdvanceRequest($input: RepayCashAdvanceRequestInput!) {
  repayCashAdvanceRequest(input: $input) {
    success
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type RepayCashAdvanceRequestMutationFn = Apollo.MutationFunction<RepayCashAdvanceRequestMutation, RepayCashAdvanceRequestMutationVariables>;

/**
 * __useRepayCashAdvanceRequestMutation__
 *
 * To run a mutation, you first call `useRepayCashAdvanceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepayCashAdvanceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repayCashAdvanceRequestMutation, { data, loading, error }] = useRepayCashAdvanceRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRepayCashAdvanceRequestMutation(baseOptions?: Apollo.MutationHookOptions<RepayCashAdvanceRequestMutation, RepayCashAdvanceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepayCashAdvanceRequestMutation, RepayCashAdvanceRequestMutationVariables>(RepayCashAdvanceRequestDocument, options);
      }
export type RepayCashAdvanceRequestMutationHookResult = ReturnType<typeof useRepayCashAdvanceRequestMutation>;
export type RepayCashAdvanceRequestMutationResult = Apollo.MutationResult<RepayCashAdvanceRequestMutation>;
export type RepayCashAdvanceRequestMutationOptions = Apollo.BaseMutationOptions<RepayCashAdvanceRequestMutation, RepayCashAdvanceRequestMutationVariables>;
export const UpdateCashAdvanceIdentityDocument = gql`
    mutation UpdateCashAdvanceIdentity($userInput: UpdateUserInput!, $addressInput: AddressInput!) {
  updateUser(input: $userInput) {
    user {
      id
      firstName
      lastName
      dob
    }
    errors {
      ...ErrorFragment
    }
  }
  address(input: $addressInput) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdateCashAdvanceIdentityMutationFn = Apollo.MutationFunction<UpdateCashAdvanceIdentityMutation, UpdateCashAdvanceIdentityMutationVariables>;

/**
 * __useUpdateCashAdvanceIdentityMutation__
 *
 * To run a mutation, you first call `useUpdateCashAdvanceIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCashAdvanceIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCashAdvanceIdentityMutation, { data, loading, error }] = useUpdateCashAdvanceIdentityMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      addressInput: // value for 'addressInput'
 *   },
 * });
 */
export function useUpdateCashAdvanceIdentityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCashAdvanceIdentityMutation, UpdateCashAdvanceIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCashAdvanceIdentityMutation, UpdateCashAdvanceIdentityMutationVariables>(UpdateCashAdvanceIdentityDocument, options);
      }
export type UpdateCashAdvanceIdentityMutationHookResult = ReturnType<typeof useUpdateCashAdvanceIdentityMutation>;
export type UpdateCashAdvanceIdentityMutationResult = Apollo.MutationResult<UpdateCashAdvanceIdentityMutation>;
export type UpdateCashAdvanceIdentityMutationOptions = Apollo.BaseMutationOptions<UpdateCashAdvanceIdentityMutation, UpdateCashAdvanceIdentityMutationVariables>;
export const CreateChatTokenDocument = gql`
    mutation CreateChatToken($createChatTokenInput: CreateChatTokenInput!) {
  createChatToken(input: $createChatTokenInput) {
    ...CreateChatTokenPayloadFragment
  }
}
    ${CreateChatTokenPayloadFragmentFragmentDoc}`;
export type CreateChatTokenMutationFn = Apollo.MutationFunction<CreateChatTokenMutation, CreateChatTokenMutationVariables>;

/**
 * __useCreateChatTokenMutation__
 *
 * To run a mutation, you first call `useCreateChatTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatTokenMutation, { data, loading, error }] = useCreateChatTokenMutation({
 *   variables: {
 *      createChatTokenInput: // value for 'createChatTokenInput'
 *   },
 * });
 */
export function useCreateChatTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatTokenMutation, CreateChatTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatTokenMutation, CreateChatTokenMutationVariables>(CreateChatTokenDocument, options);
      }
export type CreateChatTokenMutationHookResult = ReturnType<typeof useCreateChatTokenMutation>;
export type CreateChatTokenMutationResult = Apollo.MutationResult<CreateChatTokenMutation>;
export type CreateChatTokenMutationOptions = Apollo.BaseMutationOptions<CreateChatTokenMutation, CreateChatTokenMutationVariables>;
export const CreateChatkitSessionDocument = gql`
    mutation CreateChatkitSession($createSessionInput: CreateSessionInput!) {
  createChatkitSession(input: $createSessionInput) {
    ...CreateSessionPayloadFragment
  }
}
    ${CreateSessionPayloadFragmentFragmentDoc}`;
export type CreateChatkitSessionMutationFn = Apollo.MutationFunction<CreateChatkitSessionMutation, CreateChatkitSessionMutationVariables>;

/**
 * __useCreateChatkitSessionMutation__
 *
 * To run a mutation, you first call `useCreateChatkitSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatkitSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatkitSessionMutation, { data, loading, error }] = useCreateChatkitSessionMutation({
 *   variables: {
 *      createSessionInput: // value for 'createSessionInput'
 *   },
 * });
 */
export function useCreateChatkitSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatkitSessionMutation, CreateChatkitSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatkitSessionMutation, CreateChatkitSessionMutationVariables>(CreateChatkitSessionDocument, options);
      }
export type CreateChatkitSessionMutationHookResult = ReturnType<typeof useCreateChatkitSessionMutation>;
export type CreateChatkitSessionMutationResult = Apollo.MutationResult<CreateChatkitSessionMutation>;
export type CreateChatkitSessionMutationOptions = Apollo.BaseMutationOptions<CreateChatkitSessionMutation, CreateChatkitSessionMutationVariables>;
export const PublishWebEventDocument = gql`
    mutation PublishWebEvent($input: PublishWebEventInput!) {
  publishWebEvent(input: $input) {
    errors {
      ... on Error {
        ...ErrorFragment
      }
      ... on ClientEventError {
        errors {
          ...ErrorFragment
        }
        event {
          ...ClientEventFragment
        }
      }
    }
    eventId
  }
}
    ${ErrorFragmentFragmentDoc}
${ClientEventFragmentFragmentDoc}`;
export type PublishWebEventMutationFn = Apollo.MutationFunction<PublishWebEventMutation, PublishWebEventMutationVariables>;

/**
 * __usePublishWebEventMutation__
 *
 * To run a mutation, you first call `usePublishWebEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishWebEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishWebEventMutation, { data, loading, error }] = usePublishWebEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishWebEventMutation(baseOptions?: Apollo.MutationHookOptions<PublishWebEventMutation, PublishWebEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishWebEventMutation, PublishWebEventMutationVariables>(PublishWebEventDocument, options);
      }
export type PublishWebEventMutationHookResult = ReturnType<typeof usePublishWebEventMutation>;
export type PublishWebEventMutationResult = Apollo.MutationResult<PublishWebEventMutation>;
export type PublishWebEventMutationOptions = Apollo.BaseMutationOptions<PublishWebEventMutation, PublishWebEventMutationVariables>;
export const CreateUpdateLinkTokenDocument = gql`
    mutation CreateUpdateLinkToken($input: CreateUpdateLinkTokenInput!) {
  createUpdateLinkToken(input: $input) {
    linkToken {
      ...PlaidLinkTokenFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${PlaidLinkTokenFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CreateUpdateLinkTokenMutationFn = Apollo.MutationFunction<CreateUpdateLinkTokenMutation, CreateUpdateLinkTokenMutationVariables>;

/**
 * __useCreateUpdateLinkTokenMutation__
 *
 * To run a mutation, you first call `useCreateUpdateLinkTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateLinkTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateLinkTokenMutation, { data, loading, error }] = useCreateUpdateLinkTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateLinkTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateLinkTokenMutation, CreateUpdateLinkTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateLinkTokenMutation, CreateUpdateLinkTokenMutationVariables>(CreateUpdateLinkTokenDocument, options);
      }
export type CreateUpdateLinkTokenMutationHookResult = ReturnType<typeof useCreateUpdateLinkTokenMutation>;
export type CreateUpdateLinkTokenMutationResult = Apollo.MutationResult<CreateUpdateLinkTokenMutation>;
export type CreateUpdateLinkTokenMutationOptions = Apollo.BaseMutationOptions<CreateUpdateLinkTokenMutation, CreateUpdateLinkTokenMutationVariables>;
export const UpdatePaymentAccountDocument = gql`
    mutation UpdatePaymentAccount($input: UpdatePaymentAccountInput!) {
  updatePaymentAccount(input: $input) {
    paymentAccount {
      ...BankAccountFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${BankAccountFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UpdatePaymentAccountMutationFn = Apollo.MutationFunction<UpdatePaymentAccountMutation, UpdatePaymentAccountMutationVariables>;

/**
 * __useUpdatePaymentAccountMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentAccountMutation, { data, loading, error }] = useUpdatePaymentAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentAccountMutation, UpdatePaymentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentAccountMutation, UpdatePaymentAccountMutationVariables>(UpdatePaymentAccountDocument, options);
      }
export type UpdatePaymentAccountMutationHookResult = ReturnType<typeof useUpdatePaymentAccountMutation>;
export type UpdatePaymentAccountMutationResult = Apollo.MutationResult<UpdatePaymentAccountMutation>;
export type UpdatePaymentAccountMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentAccountMutation, UpdatePaymentAccountMutationVariables>;
export const RelinkPaymentAccountDocument = gql`
    mutation RelinkPaymentAccount($input: RelinkPaymentAccountInput!) {
  relinkPaymentAccount(input: $input) {
    paymentAccount {
      ...BankAccountFragment
    }
    errors {
      ... on ErrorInterface {
        message
        path
      }
    }
  }
}
    ${BankAccountFragmentFragmentDoc}`;
export type RelinkPaymentAccountMutationFn = Apollo.MutationFunction<RelinkPaymentAccountMutation, RelinkPaymentAccountMutationVariables>;

/**
 * __useRelinkPaymentAccountMutation__
 *
 * To run a mutation, you first call `useRelinkPaymentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRelinkPaymentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [relinkPaymentAccountMutation, { data, loading, error }] = useRelinkPaymentAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRelinkPaymentAccountMutation(baseOptions?: Apollo.MutationHookOptions<RelinkPaymentAccountMutation, RelinkPaymentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RelinkPaymentAccountMutation, RelinkPaymentAccountMutationVariables>(RelinkPaymentAccountDocument, options);
      }
export type RelinkPaymentAccountMutationHookResult = ReturnType<typeof useRelinkPaymentAccountMutation>;
export type RelinkPaymentAccountMutationResult = Apollo.MutationResult<RelinkPaymentAccountMutation>;
export type RelinkPaymentAccountMutationOptions = Apollo.BaseMutationOptions<RelinkPaymentAccountMutation, RelinkPaymentAccountMutationVariables>;
export const NotifyReferredUserDocument = gql`
    mutation NotifyReferredUser($input: NotifyReferredUserInput!) {
  notifyReferredUser(input: $input) {
    errors {
      ...NotifyReferredUserErrorFragment
    }
  }
}
    ${NotifyReferredUserErrorFragmentFragmentDoc}`;
export type NotifyReferredUserMutationFn = Apollo.MutationFunction<NotifyReferredUserMutation, NotifyReferredUserMutationVariables>;

/**
 * __useNotifyReferredUserMutation__
 *
 * To run a mutation, you first call `useNotifyReferredUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyReferredUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyReferredUserMutation, { data, loading, error }] = useNotifyReferredUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotifyReferredUserMutation(baseOptions?: Apollo.MutationHookOptions<NotifyReferredUserMutation, NotifyReferredUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyReferredUserMutation, NotifyReferredUserMutationVariables>(NotifyReferredUserDocument, options);
      }
export type NotifyReferredUserMutationHookResult = ReturnType<typeof useNotifyReferredUserMutation>;
export type NotifyReferredUserMutationResult = Apollo.MutationResult<NotifyReferredUserMutation>;
export type NotifyReferredUserMutationOptions = Apollo.BaseMutationOptions<NotifyReferredUserMutation, NotifyReferredUserMutationVariables>;
export const PauseSubscriptionDocument = gql`
    mutation PauseSubscription($input: PauseSubscriptionInput!) {
  pauseSubscription(input: $input) {
    subscription {
      ...SubscriptionFragment
    }
    errors {
      ...PauseSubscriptionErrorFragment
    }
  }
}
    ${SubscriptionFragmentFragmentDoc}
${PauseSubscriptionErrorFragmentFragmentDoc}`;
export type PauseSubscriptionMutationFn = Apollo.MutationFunction<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>;

/**
 * __usePauseSubscriptionMutation__
 *
 * To run a mutation, you first call `usePauseSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseSubscriptionMutation, { data, loading, error }] = usePauseSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePauseSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>(PauseSubscriptionDocument, options);
      }
export type PauseSubscriptionMutationHookResult = ReturnType<typeof usePauseSubscriptionMutation>;
export type PauseSubscriptionMutationResult = Apollo.MutationResult<PauseSubscriptionMutation>;
export type PauseSubscriptionMutationOptions = Apollo.BaseMutationOptions<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>;
export const ResumeSubscriptionDocument = gql`
    mutation ResumeSubscription($input: ResumeSubscriptionInput!) {
  resumeSubscription(input: $input) {
    subscription {
      ...SubscriptionFragment
    }
    errors {
      ...ResumeSubscriptionErrorFragment
    }
  }
}
    ${SubscriptionFragmentFragmentDoc}
${ResumeSubscriptionErrorFragmentFragmentDoc}`;
export type ResumeSubscriptionMutationFn = Apollo.MutationFunction<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>;

/**
 * __useResumeSubscriptionMutation__
 *
 * To run a mutation, you first call `useResumeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSubscriptionMutation, { data, loading, error }] = useResumeSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>(ResumeSubscriptionDocument, options);
      }
export type ResumeSubscriptionMutationHookResult = ReturnType<typeof useResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationResult = Apollo.MutationResult<ResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationOptions = Apollo.BaseMutationOptions<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>;
export const PayOutstandingFeeDocument = gql`
    mutation PayOutstandingFee($input: PayOutstandingFeeInput!) {
  payOutstandingFee(input: $input) {
    subscriptionFee {
      id
      amount
      chargedAt
      description
      lastPaymentAttemptAt
    }
    errors {
      ...PayOutstandingFeeErrorFragment
    }
  }
}
    ${PayOutstandingFeeErrorFragmentFragmentDoc}`;
export type PayOutstandingFeeMutationFn = Apollo.MutationFunction<PayOutstandingFeeMutation, PayOutstandingFeeMutationVariables>;

/**
 * __usePayOutstandingFeeMutation__
 *
 * To run a mutation, you first call `usePayOutstandingFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayOutstandingFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payOutstandingFeeMutation, { data, loading, error }] = usePayOutstandingFeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePayOutstandingFeeMutation(baseOptions?: Apollo.MutationHookOptions<PayOutstandingFeeMutation, PayOutstandingFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayOutstandingFeeMutation, PayOutstandingFeeMutationVariables>(PayOutstandingFeeDocument, options);
      }
export type PayOutstandingFeeMutationHookResult = ReturnType<typeof usePayOutstandingFeeMutation>;
export type PayOutstandingFeeMutationResult = Apollo.MutationResult<PayOutstandingFeeMutation>;
export type PayOutstandingFeeMutationOptions = Apollo.BaseMutationOptions<PayOutstandingFeeMutation, PayOutstandingFeeMutationVariables>;
export const KeepAccessSubscriptionDocument = gql`
    mutation KeepAccessSubscription($input: KeepAccessSubscriptionInput!) {
  keepAccessSubscription(input: $input) {
    subscription {
      ...SubscriptionFragment
    }
    errors {
      ...KeepAccessSubscriptionErrorFragment
    }
  }
}
    ${SubscriptionFragmentFragmentDoc}
${KeepAccessSubscriptionErrorFragmentFragmentDoc}`;
export type KeepAccessSubscriptionMutationFn = Apollo.MutationFunction<KeepAccessSubscriptionMutation, KeepAccessSubscriptionMutationVariables>;

/**
 * __useKeepAccessSubscriptionMutation__
 *
 * To run a mutation, you first call `useKeepAccessSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKeepAccessSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [keepAccessSubscriptionMutation, { data, loading, error }] = useKeepAccessSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKeepAccessSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<KeepAccessSubscriptionMutation, KeepAccessSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KeepAccessSubscriptionMutation, KeepAccessSubscriptionMutationVariables>(KeepAccessSubscriptionDocument, options);
      }
export type KeepAccessSubscriptionMutationHookResult = ReturnType<typeof useKeepAccessSubscriptionMutation>;
export type KeepAccessSubscriptionMutationResult = Apollo.MutationResult<KeepAccessSubscriptionMutation>;
export type KeepAccessSubscriptionMutationOptions = Apollo.BaseMutationOptions<KeepAccessSubscriptionMutation, KeepAccessSubscriptionMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($createUserInput: CreateUserInput!) {
  createUser(input: $createUserInput) {
    user {
      ...UserFragment
    }
    authentication {
      accessToken
      refreshToken
      accessTokenExpiresAt
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${UserFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      createUserInput: // value for 'createUserInput'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const OAuthCreateUserDocument = gql`
    mutation OAuthCreateUser($input: OAuthCreateUserInput!) {
  oAuthCreateUser(input: $input) {
    user {
      ...UserFragment
    }
    authentication {
      accessToken
      refreshToken
      accessTokenExpiresAt
    }
    errors {
      ...OAuthAccountCreationError
    }
  }
}
    ${UserFragmentFragmentDoc}
${OAuthAccountCreationErrorFragmentDoc}`;
export type OAuthCreateUserMutationFn = Apollo.MutationFunction<OAuthCreateUserMutation, OAuthCreateUserMutationVariables>;

/**
 * __useOAuthCreateUserMutation__
 *
 * To run a mutation, you first call `useOAuthCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuthCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuthCreateUserMutation, { data, loading, error }] = useOAuthCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOAuthCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<OAuthCreateUserMutation, OAuthCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OAuthCreateUserMutation, OAuthCreateUserMutationVariables>(OAuthCreateUserDocument, options);
      }
export type OAuthCreateUserMutationHookResult = ReturnType<typeof useOAuthCreateUserMutation>;
export type OAuthCreateUserMutationResult = Apollo.MutationResult<OAuthCreateUserMutation>;
export type OAuthCreateUserMutationOptions = Apollo.BaseMutationOptions<OAuthCreateUserMutation, OAuthCreateUserMutationVariables>;
export const OAuthSignInUserDocument = gql`
    mutation OAuthSignInUser($input: OAuthSignInUserInput!) {
  oAuthSignInUser(input: $input) {
    user {
      ...UserFragment
    }
    authentication {
      accessToken
      refreshToken
      accessTokenExpiresAt
    }
    errors {
      ...OAuthAccountSignInError
    }
  }
}
    ${UserFragmentFragmentDoc}
${OAuthAccountSignInErrorFragmentDoc}`;
export type OAuthSignInUserMutationFn = Apollo.MutationFunction<OAuthSignInUserMutation, OAuthSignInUserMutationVariables>;

/**
 * __useOAuthSignInUserMutation__
 *
 * To run a mutation, you first call `useOAuthSignInUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuthSignInUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuthSignInUserMutation, { data, loading, error }] = useOAuthSignInUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOAuthSignInUserMutation(baseOptions?: Apollo.MutationHookOptions<OAuthSignInUserMutation, OAuthSignInUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OAuthSignInUserMutation, OAuthSignInUserMutationVariables>(OAuthSignInUserDocument, options);
      }
export type OAuthSignInUserMutationHookResult = ReturnType<typeof useOAuthSignInUserMutation>;
export type OAuthSignInUserMutationResult = Apollo.MutationResult<OAuthSignInUserMutation>;
export type OAuthSignInUserMutationOptions = Apollo.BaseMutationOptions<OAuthSignInUserMutation, OAuthSignInUserMutationVariables>;
export const ConfirmPhoneDocument = gql`
    mutation ConfirmPhone($confirmPhoneInput: ConfirmPhoneInput!) {
  confirmPhone(input: $confirmPhoneInput) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type ConfirmPhoneMutationFn = Apollo.MutationFunction<ConfirmPhoneMutation, ConfirmPhoneMutationVariables>;

/**
 * __useConfirmPhoneMutation__
 *
 * To run a mutation, you first call `useConfirmPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPhoneMutation, { data, loading, error }] = useConfirmPhoneMutation({
 *   variables: {
 *      confirmPhoneInput: // value for 'confirmPhoneInput'
 *   },
 * });
 */
export function useConfirmPhoneMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmPhoneMutation, ConfirmPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmPhoneMutation, ConfirmPhoneMutationVariables>(ConfirmPhoneDocument, options);
      }
export type ConfirmPhoneMutationHookResult = ReturnType<typeof useConfirmPhoneMutation>;
export type ConfirmPhoneMutationResult = Apollo.MutationResult<ConfirmPhoneMutation>;
export type ConfirmPhoneMutationOptions = Apollo.BaseMutationOptions<ConfirmPhoneMutation, ConfirmPhoneMutationVariables>;
export const ResendEmailVerificationDocument = gql`
    mutation ResendEmailVerification($input: ResendEmailVerificationInput!) {
  resendEmailVerification(input: $input) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type ResendEmailVerificationMutationFn = Apollo.MutationFunction<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;

/**
 * __useResendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useResendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailVerificationMutation, { data, loading, error }] = useResendEmailVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>(ResendEmailVerificationDocument, options);
      }
export type ResendEmailVerificationMutationHookResult = ReturnType<typeof useResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationResult = Apollo.MutationResult<ResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationOptions = Apollo.BaseMutationOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;
export const ResendPhoneVerificationDocument = gql`
    mutation ResendPhoneVerification($input: ResendPhoneVerificationInput!) {
  resendPhoneVerification(input: $input) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type ResendPhoneVerificationMutationFn = Apollo.MutationFunction<ResendPhoneVerificationMutation, ResendPhoneVerificationMutationVariables>;

/**
 * __useResendPhoneVerificationMutation__
 *
 * To run a mutation, you first call `useResendPhoneVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPhoneVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPhoneVerificationMutation, { data, loading, error }] = useResendPhoneVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendPhoneVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ResendPhoneVerificationMutation, ResendPhoneVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendPhoneVerificationMutation, ResendPhoneVerificationMutationVariables>(ResendPhoneVerificationDocument, options);
      }
export type ResendPhoneVerificationMutationHookResult = ReturnType<typeof useResendPhoneVerificationMutation>;
export type ResendPhoneVerificationMutationResult = Apollo.MutationResult<ResendPhoneVerificationMutation>;
export type ResendPhoneVerificationMutationOptions = Apollo.BaseMutationOptions<ResendPhoneVerificationMutation, ResendPhoneVerificationMutationVariables>;
export const RegistrationCompleteDocument = gql`
    mutation RegistrationComplete($input: RegistrationCompleteInput!) {
  registrationComplete(input: $input) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type RegistrationCompleteMutationFn = Apollo.MutationFunction<RegistrationCompleteMutation, RegistrationCompleteMutationVariables>;

/**
 * __useRegistrationCompleteMutation__
 *
 * To run a mutation, you first call `useRegistrationCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrationCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrationCompleteMutation, { data, loading, error }] = useRegistrationCompleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegistrationCompleteMutation(baseOptions?: Apollo.MutationHookOptions<RegistrationCompleteMutation, RegistrationCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegistrationCompleteMutation, RegistrationCompleteMutationVariables>(RegistrationCompleteDocument, options);
      }
export type RegistrationCompleteMutationHookResult = ReturnType<typeof useRegistrationCompleteMutation>;
export type RegistrationCompleteMutationResult = Apollo.MutationResult<RegistrationCompleteMutation>;
export type RegistrationCompleteMutationOptions = Apollo.BaseMutationOptions<RegistrationCompleteMutation, RegistrationCompleteMutationVariables>;
export const SignInDocument = gql`
    mutation SignIn($signInUserInput: SignInUserInput!) {
  signInUser(input: $signInUserInput) {
    user {
      ...UserFragment
    }
    authentication {
      accessToken
      refreshToken
      accessTokenExpiresAt
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${UserFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      signInUserInput: // value for 'signInUserInput'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignOutUserDocument = gql`
    mutation SignOutUser($input: SignOutUserInput!) {
  signOutUser(input: $input)
}
    `;
export type SignOutUserMutationFn = Apollo.MutationFunction<SignOutUserMutation, SignOutUserMutationVariables>;

/**
 * __useSignOutUserMutation__
 *
 * To run a mutation, you first call `useSignOutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutUserMutation, { data, loading, error }] = useSignOutUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignOutUserMutation(baseOptions?: Apollo.MutationHookOptions<SignOutUserMutation, SignOutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutUserMutation, SignOutUserMutationVariables>(SignOutUserDocument, options);
      }
export type SignOutUserMutationHookResult = ReturnType<typeof useSignOutUserMutation>;
export type SignOutUserMutationResult = Apollo.MutationResult<SignOutUserMutation>;
export type SignOutUserMutationOptions = Apollo.BaseMutationOptions<SignOutUserMutation, SignOutUserMutationVariables>;
export const ConfirmEmailDocument = gql`
    mutation ConfirmEmail($confirmEmailInput: ConfirmEmailInput!) {
  confirmEmail(input: $confirmEmailInput) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type ConfirmEmailMutationFn = Apollo.MutationFunction<ConfirmEmailMutation, ConfirmEmailMutationVariables>;

/**
 * __useConfirmEmailMutation__
 *
 * To run a mutation, you first call `useConfirmEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailMutation, { data, loading, error }] = useConfirmEmailMutation({
 *   variables: {
 *      confirmEmailInput: // value for 'confirmEmailInput'
 *   },
 * });
 */
export function useConfirmEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument, options);
      }
export type ConfirmEmailMutationHookResult = ReturnType<typeof useConfirmEmailMutation>;
export type ConfirmEmailMutationResult = Apollo.MutationResult<ConfirmEmailMutation>;
export type ConfirmEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($forgotPasswordInput: ForgotPasswordInput!) {
  forgotPassword(input: $forgotPasswordInput)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      forgotPasswordInput: // value for 'forgotPasswordInput'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($resetPasswordInput: ResetPasswordInput!) {
  resetPassword(input: $resetPasswordInput) {
    ...ResetPasswordPayloadFragment
  }
}
    ${ResetPasswordPayloadFragmentFragmentDoc}`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      resetPasswordInput: // value for 'resetPasswordInput'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SendSignInSmsDocument = gql`
    mutation SendSignInSms($input: SendSignInSMSInput!) {
  sendSignInSms(input: $input) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type SendSignInSmsMutationFn = Apollo.MutationFunction<SendSignInSmsMutation, SendSignInSmsMutationVariables>;

/**
 * __useSendSignInSmsMutation__
 *
 * To run a mutation, you first call `useSendSignInSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSignInSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSignInSmsMutation, { data, loading, error }] = useSendSignInSmsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSignInSmsMutation(baseOptions?: Apollo.MutationHookOptions<SendSignInSmsMutation, SendSignInSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSignInSmsMutation, SendSignInSmsMutationVariables>(SendSignInSmsDocument, options);
      }
export type SendSignInSmsMutationHookResult = ReturnType<typeof useSendSignInSmsMutation>;
export type SendSignInSmsMutationResult = Apollo.MutationResult<SendSignInSmsMutation>;
export type SendSignInSmsMutationOptions = Apollo.BaseMutationOptions<SendSignInSmsMutation, SendSignInSmsMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($updateUserInput: UpdateUserInput!) {
  updateUser(input: $updateUserInput) {
    user {
      ...UserFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${UserFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      updateUserInput: // value for 'updateUserInput'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($addressInput: AddressInput!) {
  address(input: $addressInput) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      addressInput: // value for 'addressInput'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const UpdatePhoneDocument = gql`
    mutation UpdatePhone($updatePhoneInput: UpdatePhoneInput!) {
  updatePhone(input: $updatePhoneInput) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdatePhoneMutationFn = Apollo.MutationFunction<UpdatePhoneMutation, UpdatePhoneMutationVariables>;

/**
 * __useUpdatePhoneMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneMutation, { data, loading, error }] = useUpdatePhoneMutation({
 *   variables: {
 *      updatePhoneInput: // value for 'updatePhoneInput'
 *   },
 * });
 */
export function useUpdatePhoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhoneMutation, UpdatePhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhoneMutation, UpdatePhoneMutationVariables>(UpdatePhoneDocument, options);
      }
export type UpdatePhoneMutationHookResult = ReturnType<typeof useUpdatePhoneMutation>;
export type UpdatePhoneMutationResult = Apollo.MutationResult<UpdatePhoneMutation>;
export type UpdatePhoneMutationOptions = Apollo.BaseMutationOptions<UpdatePhoneMutation, UpdatePhoneMutationVariables>;
export const CreateUserFeatureOptInDocument = gql`
    mutation CreateUserFeatureOptIn($input: CreateUserFeatureOptInInput!) {
  createUserFeatureOptIn(input: $input) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type CreateUserFeatureOptInMutationFn = Apollo.MutationFunction<CreateUserFeatureOptInMutation, CreateUserFeatureOptInMutationVariables>;

/**
 * __useCreateUserFeatureOptInMutation__
 *
 * To run a mutation, you first call `useCreateUserFeatureOptInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserFeatureOptInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserFeatureOptInMutation, { data, loading, error }] = useCreateUserFeatureOptInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserFeatureOptInMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserFeatureOptInMutation, CreateUserFeatureOptInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserFeatureOptInMutation, CreateUserFeatureOptInMutationVariables>(CreateUserFeatureOptInDocument, options);
      }
export type CreateUserFeatureOptInMutationHookResult = ReturnType<typeof useCreateUserFeatureOptInMutation>;
export type CreateUserFeatureOptInMutationResult = Apollo.MutationResult<CreateUserFeatureOptInMutation>;
export type CreateUserFeatureOptInMutationOptions = Apollo.BaseMutationOptions<CreateUserFeatureOptInMutation, CreateUserFeatureOptInMutationVariables>;
export const UpsertUserFeatureOptInDocument = gql`
    mutation UpsertUserFeatureOptIn($input: UpsertUserFeatureOptInInput!) {
  upsertUserFeatureOptIn(input: $input) {
    userFeatureOptIn {
      ...UserFeatureOptInFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${UserFeatureOptInFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UpsertUserFeatureOptInMutationFn = Apollo.MutationFunction<UpsertUserFeatureOptInMutation, UpsertUserFeatureOptInMutationVariables>;

/**
 * __useUpsertUserFeatureOptInMutation__
 *
 * To run a mutation, you first call `useUpsertUserFeatureOptInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserFeatureOptInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserFeatureOptInMutation, { data, loading, error }] = useUpsertUserFeatureOptInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertUserFeatureOptInMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserFeatureOptInMutation, UpsertUserFeatureOptInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserFeatureOptInMutation, UpsertUserFeatureOptInMutationVariables>(UpsertUserFeatureOptInDocument, options);
      }
export type UpsertUserFeatureOptInMutationHookResult = ReturnType<typeof useUpsertUserFeatureOptInMutation>;
export type UpsertUserFeatureOptInMutationResult = Apollo.MutationResult<UpsertUserFeatureOptInMutation>;
export type UpsertUserFeatureOptInMutationOptions = Apollo.BaseMutationOptions<UpsertUserFeatureOptInMutation, UpsertUserFeatureOptInMutationVariables>;
export const SetUserAttributionDocument = gql`
    mutation SetUserAttribution($input: SetUserAttributionInput!) {
  setUserAttribution(input: $input) {
    errors {
      ... on Error {
        ...ErrorFragment
      }
      ... on InvalidUserAttributionError {
        message
        path
      }
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type SetUserAttributionMutationFn = Apollo.MutationFunction<SetUserAttributionMutation, SetUserAttributionMutationVariables>;

/**
 * __useSetUserAttributionMutation__
 *
 * To run a mutation, you first call `useSetUserAttributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserAttributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserAttributionMutation, { data, loading, error }] = useSetUserAttributionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserAttributionMutation(baseOptions?: Apollo.MutationHookOptions<SetUserAttributionMutation, SetUserAttributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserAttributionMutation, SetUserAttributionMutationVariables>(SetUserAttributionDocument, options);
      }
export type SetUserAttributionMutationHookResult = ReturnType<typeof useSetUserAttributionMutation>;
export type SetUserAttributionMutationResult = Apollo.MutationResult<SetUserAttributionMutation>;
export type SetUserAttributionMutationOptions = Apollo.BaseMutationOptions<SetUserAttributionMutation, SetUserAttributionMutationVariables>;
export const CreateWithdrawalDocument = gql`
    mutation CreateWithdrawal($input: CreateWithdrawalInput!) {
  createWithdrawal(input: $input) {
    transaction {
      ...TransactionFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${TransactionFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CreateWithdrawalMutationFn = Apollo.MutationFunction<CreateWithdrawalMutation, CreateWithdrawalMutationVariables>;

/**
 * __useCreateWithdrawalMutation__
 *
 * To run a mutation, you first call `useCreateWithdrawalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWithdrawalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWithdrawalMutation, { data, loading, error }] = useCreateWithdrawalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWithdrawalMutation(baseOptions?: Apollo.MutationHookOptions<CreateWithdrawalMutation, CreateWithdrawalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWithdrawalMutation, CreateWithdrawalMutationVariables>(CreateWithdrawalDocument, options);
      }
export type CreateWithdrawalMutationHookResult = ReturnType<typeof useCreateWithdrawalMutation>;
export type CreateWithdrawalMutationResult = Apollo.MutationResult<CreateWithdrawalMutation>;
export type CreateWithdrawalMutationOptions = Apollo.BaseMutationOptions<CreateWithdrawalMutation, CreateWithdrawalMutationVariables>;
export const AccountClosureAppSettingsDocument = gql`
    query AccountClosureAppSettings {
  appSettings {
    accountClosureLifetimeEarningsMinimumAmount
    accountClosurePotentialEarningsLostAmount
    accountClosureRetentionOfferCategoryIds
  }
}
    `;

/**
 * __useAccountClosureAppSettingsQuery__
 *
 * To run a query within a React component, call `useAccountClosureAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountClosureAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountClosureAppSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountClosureAppSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AccountClosureAppSettingsQuery, AccountClosureAppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountClosureAppSettingsQuery, AccountClosureAppSettingsQueryVariables>(AccountClosureAppSettingsDocument, options);
      }
export function useAccountClosureAppSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountClosureAppSettingsQuery, AccountClosureAppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountClosureAppSettingsQuery, AccountClosureAppSettingsQueryVariables>(AccountClosureAppSettingsDocument, options);
        }
export function useAccountClosureAppSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountClosureAppSettingsQuery, AccountClosureAppSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountClosureAppSettingsQuery, AccountClosureAppSettingsQueryVariables>(AccountClosureAppSettingsDocument, options);
        }
export type AccountClosureAppSettingsQueryHookResult = ReturnType<typeof useAccountClosureAppSettingsQuery>;
export type AccountClosureAppSettingsLazyQueryHookResult = ReturnType<typeof useAccountClosureAppSettingsLazyQuery>;
export type AccountClosureAppSettingsSuspenseQueryHookResult = ReturnType<typeof useAccountClosureAppSettingsSuspenseQuery>;
export type AccountClosureAppSettingsQueryResult = Apollo.QueryResult<AccountClosureAppSettingsQuery, AccountClosureAppSettingsQueryVariables>;
export const KeepAccessAppSettingsDocument = gql`
    query KeepAccessAppSettings {
  appSettings {
    keepAccessEligibleDiscountCode
    keepAccessEligibleTitle
    keepAccessEligibleSplash
    keepAccessEligibleDescription
    keepAccessEligibleButtonText
    keepAccessIneligibleDiscountCode
    keepAccessIneligibleTitle
    keepAccessIneligibleSplash
    keepAccessIneligibleDescription
    keepAccessIneligibleButtonText
  }
}
    `;

/**
 * __useKeepAccessAppSettingsQuery__
 *
 * To run a query within a React component, call `useKeepAccessAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeepAccessAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeepAccessAppSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useKeepAccessAppSettingsQuery(baseOptions?: Apollo.QueryHookOptions<KeepAccessAppSettingsQuery, KeepAccessAppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeepAccessAppSettingsQuery, KeepAccessAppSettingsQueryVariables>(KeepAccessAppSettingsDocument, options);
      }
export function useKeepAccessAppSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeepAccessAppSettingsQuery, KeepAccessAppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeepAccessAppSettingsQuery, KeepAccessAppSettingsQueryVariables>(KeepAccessAppSettingsDocument, options);
        }
export function useKeepAccessAppSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KeepAccessAppSettingsQuery, KeepAccessAppSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KeepAccessAppSettingsQuery, KeepAccessAppSettingsQueryVariables>(KeepAccessAppSettingsDocument, options);
        }
export type KeepAccessAppSettingsQueryHookResult = ReturnType<typeof useKeepAccessAppSettingsQuery>;
export type KeepAccessAppSettingsLazyQueryHookResult = ReturnType<typeof useKeepAccessAppSettingsLazyQuery>;
export type KeepAccessAppSettingsSuspenseQueryHookResult = ReturnType<typeof useKeepAccessAppSettingsSuspenseQuery>;
export type KeepAccessAppSettingsQueryResult = Apollo.QueryResult<KeepAccessAppSettingsQuery, KeepAccessAppSettingsQueryVariables>;
export const AddDataContainersDocument = gql`
    query AddDataContainers {
  addDataContainers {
    ...QuestionContainerFragment
  }
}
    ${QuestionContainerFragmentFragmentDoc}`;

/**
 * __useAddDataContainersQuery__
 *
 * To run a query within a React component, call `useAddDataContainersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddDataContainersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddDataContainersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddDataContainersQuery(baseOptions?: Apollo.QueryHookOptions<AddDataContainersQuery, AddDataContainersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddDataContainersQuery, AddDataContainersQueryVariables>(AddDataContainersDocument, options);
      }
export function useAddDataContainersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddDataContainersQuery, AddDataContainersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddDataContainersQuery, AddDataContainersQueryVariables>(AddDataContainersDocument, options);
        }
export function useAddDataContainersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddDataContainersQuery, AddDataContainersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddDataContainersQuery, AddDataContainersQueryVariables>(AddDataContainersDocument, options);
        }
export type AddDataContainersQueryHookResult = ReturnType<typeof useAddDataContainersQuery>;
export type AddDataContainersLazyQueryHookResult = ReturnType<typeof useAddDataContainersLazyQuery>;
export type AddDataContainersSuspenseQueryHookResult = ReturnType<typeof useAddDataContainersSuspenseQuery>;
export type AddDataContainersQueryResult = Apollo.QueryResult<AddDataContainersQuery, AddDataContainersQueryVariables>;
export const NextAvailableDataContainerDocument = gql`
    query NextAvailableDataContainer($placementName: String) {
  nextAvailableDataContainer(placementName: $placementName) {
    ...QuestionContainerFragment
  }
}
    ${QuestionContainerFragmentFragmentDoc}`;

/**
 * __useNextAvailableDataContainerQuery__
 *
 * To run a query within a React component, call `useNextAvailableDataContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextAvailableDataContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextAvailableDataContainerQuery({
 *   variables: {
 *      placementName: // value for 'placementName'
 *   },
 * });
 */
export function useNextAvailableDataContainerQuery(baseOptions?: Apollo.QueryHookOptions<NextAvailableDataContainerQuery, NextAvailableDataContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NextAvailableDataContainerQuery, NextAvailableDataContainerQueryVariables>(NextAvailableDataContainerDocument, options);
      }
export function useNextAvailableDataContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NextAvailableDataContainerQuery, NextAvailableDataContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NextAvailableDataContainerQuery, NextAvailableDataContainerQueryVariables>(NextAvailableDataContainerDocument, options);
        }
export function useNextAvailableDataContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NextAvailableDataContainerQuery, NextAvailableDataContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NextAvailableDataContainerQuery, NextAvailableDataContainerQueryVariables>(NextAvailableDataContainerDocument, options);
        }
export type NextAvailableDataContainerQueryHookResult = ReturnType<typeof useNextAvailableDataContainerQuery>;
export type NextAvailableDataContainerLazyQueryHookResult = ReturnType<typeof useNextAvailableDataContainerLazyQuery>;
export type NextAvailableDataContainerSuspenseQueryHookResult = ReturnType<typeof useNextAvailableDataContainerSuspenseQuery>;
export type NextAvailableDataContainerQueryResult = Apollo.QueryResult<NextAvailableDataContainerQuery, NextAvailableDataContainerQueryVariables>;
export const MonitoredBankAccountsDocument = gql`
    query MonitoredBankAccounts {
  monitoredBankAccounts {
    ...MonitoredBankAccountFragment
  }
}
    ${MonitoredBankAccountFragmentFragmentDoc}`;

/**
 * __useMonitoredBankAccountsQuery__
 *
 * To run a query within a React component, call `useMonitoredBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonitoredBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonitoredBankAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMonitoredBankAccountsQuery(baseOptions?: Apollo.QueryHookOptions<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>(MonitoredBankAccountsDocument, options);
      }
export function useMonitoredBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>(MonitoredBankAccountsDocument, options);
        }
export function useMonitoredBankAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>(MonitoredBankAccountsDocument, options);
        }
export type MonitoredBankAccountsQueryHookResult = ReturnType<typeof useMonitoredBankAccountsQuery>;
export type MonitoredBankAccountsLazyQueryHookResult = ReturnType<typeof useMonitoredBankAccountsLazyQuery>;
export type MonitoredBankAccountsSuspenseQueryHookResult = ReturnType<typeof useMonitoredBankAccountsSuspenseQuery>;
export type MonitoredBankAccountsQueryResult = Apollo.QueryResult<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>;
export const MonitoredBankAccountTransactionsDocument = gql`
    query MonitoredBankAccountTransactions($end: ISO8601DateTime, $merchant: String, $monitoredBankAccountId: ID, $primaryCategory: String, $sort: BankAccountTransactionSort, $start: ISO8601DateTime, $updatedAtStart: ISO8601DateTime) {
  monitoredBankAccountTransactions(
    monitoredBankAccountId: $monitoredBankAccountId
    start: $start
    end: $end
    updatedAtStart: $updatedAtStart
    merchant: $merchant
    primaryCategory: $primaryCategory
    sort: $sort
  ) {
    ...MonitoredBankAccountTransactionFragment
  }
}
    ${MonitoredBankAccountTransactionFragmentFragmentDoc}`;

/**
 * __useMonitoredBankAccountTransactionsQuery__
 *
 * To run a query within a React component, call `useMonitoredBankAccountTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonitoredBankAccountTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonitoredBankAccountTransactionsQuery({
 *   variables: {
 *      end: // value for 'end'
 *      merchant: // value for 'merchant'
 *      monitoredBankAccountId: // value for 'monitoredBankAccountId'
 *      primaryCategory: // value for 'primaryCategory'
 *      sort: // value for 'sort'
 *      start: // value for 'start'
 *      updatedAtStart: // value for 'updatedAtStart'
 *   },
 * });
 */
export function useMonitoredBankAccountTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>(MonitoredBankAccountTransactionsDocument, options);
      }
export function useMonitoredBankAccountTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>(MonitoredBankAccountTransactionsDocument, options);
        }
export function useMonitoredBankAccountTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>(MonitoredBankAccountTransactionsDocument, options);
        }
export type MonitoredBankAccountTransactionsQueryHookResult = ReturnType<typeof useMonitoredBankAccountTransactionsQuery>;
export type MonitoredBankAccountTransactionsLazyQueryHookResult = ReturnType<typeof useMonitoredBankAccountTransactionsLazyQuery>;
export type MonitoredBankAccountTransactionsSuspenseQueryHookResult = ReturnType<typeof useMonitoredBankAccountTransactionsSuspenseQuery>;
export type MonitoredBankAccountTransactionsQueryResult = Apollo.QueryResult<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>;
export const RecurringTransactionsDocument = gql`
    query RecurringTransactions {
  recurringTransactions {
    ...RecurringTransactionFragment
  }
}
    ${RecurringTransactionFragmentFragmentDoc}`;

/**
 * __useRecurringTransactionsQuery__
 *
 * To run a query within a React component, call `useRecurringTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringTransactionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecurringTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<RecurringTransactionsQuery, RecurringTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringTransactionsQuery, RecurringTransactionsQueryVariables>(RecurringTransactionsDocument, options);
      }
export function useRecurringTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringTransactionsQuery, RecurringTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringTransactionsQuery, RecurringTransactionsQueryVariables>(RecurringTransactionsDocument, options);
        }
export function useRecurringTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringTransactionsQuery, RecurringTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringTransactionsQuery, RecurringTransactionsQueryVariables>(RecurringTransactionsDocument, options);
        }
export type RecurringTransactionsQueryHookResult = ReturnType<typeof useRecurringTransactionsQuery>;
export type RecurringTransactionsLazyQueryHookResult = ReturnType<typeof useRecurringTransactionsLazyQuery>;
export type RecurringTransactionsSuspenseQueryHookResult = ReturnType<typeof useRecurringTransactionsSuspenseQuery>;
export type RecurringTransactionsQueryResult = Apollo.QueryResult<RecurringTransactionsQuery, RecurringTransactionsQueryVariables>;
export const BalanceDocument = gql`
    query Balance {
  balance {
    ...BalanceFragment
  }
}
    ${BalanceFragmentFragmentDoc}`;

/**
 * __useBalanceQuery__
 *
 * To run a query within a React component, call `useBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useBalanceQuery(baseOptions?: Apollo.QueryHookOptions<BalanceQuery, BalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BalanceQuery, BalanceQueryVariables>(BalanceDocument, options);
      }
export function useBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BalanceQuery, BalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BalanceQuery, BalanceQueryVariables>(BalanceDocument, options);
        }
export function useBalanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BalanceQuery, BalanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BalanceQuery, BalanceQueryVariables>(BalanceDocument, options);
        }
export type BalanceQueryHookResult = ReturnType<typeof useBalanceQuery>;
export type BalanceLazyQueryHookResult = ReturnType<typeof useBalanceLazyQuery>;
export type BalanceSuspenseQueryHookResult = ReturnType<typeof useBalanceSuspenseQuery>;
export type BalanceQueryResult = Apollo.QueryResult<BalanceQuery, BalanceQueryVariables>;
export const BudgetsDocument = gql`
    query Budgets {
  budgets {
    ...BudgetFragment
  }
}
    ${BudgetFragmentFragmentDoc}`;

/**
 * __useBudgetsQuery__
 *
 * To run a query within a React component, call `useBudgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBudgetsQuery(baseOptions?: Apollo.QueryHookOptions<BudgetsQuery, BudgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BudgetsQuery, BudgetsQueryVariables>(BudgetsDocument, options);
      }
export function useBudgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BudgetsQuery, BudgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BudgetsQuery, BudgetsQueryVariables>(BudgetsDocument, options);
        }
export function useBudgetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BudgetsQuery, BudgetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BudgetsQuery, BudgetsQueryVariables>(BudgetsDocument, options);
        }
export type BudgetsQueryHookResult = ReturnType<typeof useBudgetsQuery>;
export type BudgetsLazyQueryHookResult = ReturnType<typeof useBudgetsLazyQuery>;
export type BudgetsSuspenseQueryHookResult = ReturnType<typeof useBudgetsSuspenseQuery>;
export type BudgetsQueryResult = Apollo.QueryResult<BudgetsQuery, BudgetsQueryVariables>;
export const CashAdvanceStateDocument = gql`
    query CashAdvanceState {
  cashAdvanceApplication {
    ...CashAdvanceApplicationFragment
  }
  cashAdvanceApprovedAmount {
    ...CashAdvanceApprovedAmountFragment
  }
  cashAdvanceApplicationCapability
  cashAdvanceActiveRequests {
    ...CashAdvanceRequestFragment
  }
  paymentAccounts(includeUnlinked: true) {
    ...BankAccountFragment
  }
}
    ${CashAdvanceApplicationFragmentFragmentDoc}
${CashAdvanceApprovedAmountFragmentFragmentDoc}
${CashAdvanceRequestFragmentFragmentDoc}
${BankAccountFragmentFragmentDoc}`;

/**
 * __useCashAdvanceStateQuery__
 *
 * To run a query within a React component, call `useCashAdvanceStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashAdvanceStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashAdvanceStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCashAdvanceStateQuery(baseOptions?: Apollo.QueryHookOptions<CashAdvanceStateQuery, CashAdvanceStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashAdvanceStateQuery, CashAdvanceStateQueryVariables>(CashAdvanceStateDocument, options);
      }
export function useCashAdvanceStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashAdvanceStateQuery, CashAdvanceStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashAdvanceStateQuery, CashAdvanceStateQueryVariables>(CashAdvanceStateDocument, options);
        }
export function useCashAdvanceStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAdvanceStateQuery, CashAdvanceStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashAdvanceStateQuery, CashAdvanceStateQueryVariables>(CashAdvanceStateDocument, options);
        }
export type CashAdvanceStateQueryHookResult = ReturnType<typeof useCashAdvanceStateQuery>;
export type CashAdvanceStateLazyQueryHookResult = ReturnType<typeof useCashAdvanceStateLazyQuery>;
export type CashAdvanceStateSuspenseQueryHookResult = ReturnType<typeof useCashAdvanceStateSuspenseQuery>;
export type CashAdvanceStateQueryResult = Apollo.QueryResult<CashAdvanceStateQuery, CashAdvanceStateQueryVariables>;
export const CashAdvancePromoStateDocument = gql`
    query CashAdvancePromoState {
  cashAdvanceApplication {
    ...CashAdvanceApplicationFragment
  }
  cashAdvanceApprovedAmount {
    ...CashAdvanceApprovedAmountFragment
  }
  cashAdvanceApplicationCapability
  cashAdvanceActiveRequests {
    ...CashAdvanceRequestFragment
  }
}
    ${CashAdvanceApplicationFragmentFragmentDoc}
${CashAdvanceApprovedAmountFragmentFragmentDoc}
${CashAdvanceRequestFragmentFragmentDoc}`;

/**
 * __useCashAdvancePromoStateQuery__
 *
 * To run a query within a React component, call `useCashAdvancePromoStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashAdvancePromoStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashAdvancePromoStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCashAdvancePromoStateQuery(baseOptions?: Apollo.QueryHookOptions<CashAdvancePromoStateQuery, CashAdvancePromoStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashAdvancePromoStateQuery, CashAdvancePromoStateQueryVariables>(CashAdvancePromoStateDocument, options);
      }
export function useCashAdvancePromoStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashAdvancePromoStateQuery, CashAdvancePromoStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashAdvancePromoStateQuery, CashAdvancePromoStateQueryVariables>(CashAdvancePromoStateDocument, options);
        }
export function useCashAdvancePromoStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAdvancePromoStateQuery, CashAdvancePromoStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashAdvancePromoStateQuery, CashAdvancePromoStateQueryVariables>(CashAdvancePromoStateDocument, options);
        }
export type CashAdvancePromoStateQueryHookResult = ReturnType<typeof useCashAdvancePromoStateQuery>;
export type CashAdvancePromoStateLazyQueryHookResult = ReturnType<typeof useCashAdvancePromoStateLazyQuery>;
export type CashAdvancePromoStateSuspenseQueryHookResult = ReturnType<typeof useCashAdvancePromoStateSuspenseQuery>;
export type CashAdvancePromoStateQueryResult = Apollo.QueryResult<CashAdvancePromoStateQuery, CashAdvancePromoStateQueryVariables>;
export const CashAdvanceApplicationStatusDocument = gql`
    query CashAdvanceApplicationStatus {
  cashAdvanceApplication {
    id
    status
    pendingMessage
  }
}
    `;

/**
 * __useCashAdvanceApplicationStatusQuery__
 *
 * To run a query within a React component, call `useCashAdvanceApplicationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashAdvanceApplicationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashAdvanceApplicationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCashAdvanceApplicationStatusQuery(baseOptions?: Apollo.QueryHookOptions<CashAdvanceApplicationStatusQuery, CashAdvanceApplicationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashAdvanceApplicationStatusQuery, CashAdvanceApplicationStatusQueryVariables>(CashAdvanceApplicationStatusDocument, options);
      }
export function useCashAdvanceApplicationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashAdvanceApplicationStatusQuery, CashAdvanceApplicationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashAdvanceApplicationStatusQuery, CashAdvanceApplicationStatusQueryVariables>(CashAdvanceApplicationStatusDocument, options);
        }
export function useCashAdvanceApplicationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAdvanceApplicationStatusQuery, CashAdvanceApplicationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashAdvanceApplicationStatusQuery, CashAdvanceApplicationStatusQueryVariables>(CashAdvanceApplicationStatusDocument, options);
        }
export type CashAdvanceApplicationStatusQueryHookResult = ReturnType<typeof useCashAdvanceApplicationStatusQuery>;
export type CashAdvanceApplicationStatusLazyQueryHookResult = ReturnType<typeof useCashAdvanceApplicationStatusLazyQuery>;
export type CashAdvanceApplicationStatusSuspenseQueryHookResult = ReturnType<typeof useCashAdvanceApplicationStatusSuspenseQuery>;
export type CashAdvanceApplicationStatusQueryResult = Apollo.QueryResult<CashAdvanceApplicationStatusQuery, CashAdvanceApplicationStatusQueryVariables>;
export const CashAdvanceActiveRequestsStatusDocument = gql`
    query CashAdvanceActiveRequestsStatus {
  cashAdvanceActiveRequests {
    id
    status
    inFlightPayment
    amountNeededToRepay
    repaymentAmount
  }
}
    `;

/**
 * __useCashAdvanceActiveRequestsStatusQuery__
 *
 * To run a query within a React component, call `useCashAdvanceActiveRequestsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashAdvanceActiveRequestsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashAdvanceActiveRequestsStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCashAdvanceActiveRequestsStatusQuery(baseOptions?: Apollo.QueryHookOptions<CashAdvanceActiveRequestsStatusQuery, CashAdvanceActiveRequestsStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashAdvanceActiveRequestsStatusQuery, CashAdvanceActiveRequestsStatusQueryVariables>(CashAdvanceActiveRequestsStatusDocument, options);
      }
export function useCashAdvanceActiveRequestsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashAdvanceActiveRequestsStatusQuery, CashAdvanceActiveRequestsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashAdvanceActiveRequestsStatusQuery, CashAdvanceActiveRequestsStatusQueryVariables>(CashAdvanceActiveRequestsStatusDocument, options);
        }
export function useCashAdvanceActiveRequestsStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAdvanceActiveRequestsStatusQuery, CashAdvanceActiveRequestsStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashAdvanceActiveRequestsStatusQuery, CashAdvanceActiveRequestsStatusQueryVariables>(CashAdvanceActiveRequestsStatusDocument, options);
        }
export type CashAdvanceActiveRequestsStatusQueryHookResult = ReturnType<typeof useCashAdvanceActiveRequestsStatusQuery>;
export type CashAdvanceActiveRequestsStatusLazyQueryHookResult = ReturnType<typeof useCashAdvanceActiveRequestsStatusLazyQuery>;
export type CashAdvanceActiveRequestsStatusSuspenseQueryHookResult = ReturnType<typeof useCashAdvanceActiveRequestsStatusSuspenseQuery>;
export type CashAdvanceActiveRequestsStatusQueryResult = Apollo.QueryResult<CashAdvanceActiveRequestsStatusQuery, CashAdvanceActiveRequestsStatusQueryVariables>;
export const CashAdvanceQuoteDocument = gql`
    query CashAdvanceQuote($amount: String!, $tip: String, $transferType: CashAdvanceRequestTransferType!) {
  cashAdvanceQuote(amount: $amount, tip: $tip, transferType: $transferType) {
    ...CashAdvanceRequestFragment
  }
}
    ${CashAdvanceRequestFragmentFragmentDoc}`;

/**
 * __useCashAdvanceQuoteQuery__
 *
 * To run a query within a React component, call `useCashAdvanceQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashAdvanceQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashAdvanceQuoteQuery({
 *   variables: {
 *      amount: // value for 'amount'
 *      tip: // value for 'tip'
 *      transferType: // value for 'transferType'
 *   },
 * });
 */
export function useCashAdvanceQuoteQuery(baseOptions: Apollo.QueryHookOptions<CashAdvanceQuoteQuery, CashAdvanceQuoteQueryVariables> & ({ variables: CashAdvanceQuoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashAdvanceQuoteQuery, CashAdvanceQuoteQueryVariables>(CashAdvanceQuoteDocument, options);
      }
export function useCashAdvanceQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashAdvanceQuoteQuery, CashAdvanceQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashAdvanceQuoteQuery, CashAdvanceQuoteQueryVariables>(CashAdvanceQuoteDocument, options);
        }
export function useCashAdvanceQuoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAdvanceQuoteQuery, CashAdvanceQuoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashAdvanceQuoteQuery, CashAdvanceQuoteQueryVariables>(CashAdvanceQuoteDocument, options);
        }
export type CashAdvanceQuoteQueryHookResult = ReturnType<typeof useCashAdvanceQuoteQuery>;
export type CashAdvanceQuoteLazyQueryHookResult = ReturnType<typeof useCashAdvanceQuoteLazyQuery>;
export type CashAdvanceQuoteSuspenseQueryHookResult = ReturnType<typeof useCashAdvanceQuoteSuspenseQuery>;
export type CashAdvanceQuoteQueryResult = Apollo.QueryResult<CashAdvanceQuoteQuery, CashAdvanceQuoteQueryVariables>;
export const CashAdvanceAsapFeeScheduleDocument = gql`
    query CashAdvanceAsapFeeSchedule {
  cashAdvanceAsapFeeSchedule {
    ...CashAdvanceFeeScheduleFragment
  }
}
    ${CashAdvanceFeeScheduleFragmentFragmentDoc}`;

/**
 * __useCashAdvanceAsapFeeScheduleQuery__
 *
 * To run a query within a React component, call `useCashAdvanceAsapFeeScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashAdvanceAsapFeeScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashAdvanceAsapFeeScheduleQuery({
 *   variables: {
 *   },
 * });
 */
export function useCashAdvanceAsapFeeScheduleQuery(baseOptions?: Apollo.QueryHookOptions<CashAdvanceAsapFeeScheduleQuery, CashAdvanceAsapFeeScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashAdvanceAsapFeeScheduleQuery, CashAdvanceAsapFeeScheduleQueryVariables>(CashAdvanceAsapFeeScheduleDocument, options);
      }
export function useCashAdvanceAsapFeeScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashAdvanceAsapFeeScheduleQuery, CashAdvanceAsapFeeScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashAdvanceAsapFeeScheduleQuery, CashAdvanceAsapFeeScheduleQueryVariables>(CashAdvanceAsapFeeScheduleDocument, options);
        }
export function useCashAdvanceAsapFeeScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAdvanceAsapFeeScheduleQuery, CashAdvanceAsapFeeScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashAdvanceAsapFeeScheduleQuery, CashAdvanceAsapFeeScheduleQueryVariables>(CashAdvanceAsapFeeScheduleDocument, options);
        }
export type CashAdvanceAsapFeeScheduleQueryHookResult = ReturnType<typeof useCashAdvanceAsapFeeScheduleQuery>;
export type CashAdvanceAsapFeeScheduleLazyQueryHookResult = ReturnType<typeof useCashAdvanceAsapFeeScheduleLazyQuery>;
export type CashAdvanceAsapFeeScheduleSuspenseQueryHookResult = ReturnType<typeof useCashAdvanceAsapFeeScheduleSuspenseQuery>;
export type CashAdvanceAsapFeeScheduleQueryResult = Apollo.QueryResult<CashAdvanceAsapFeeScheduleQuery, CashAdvanceAsapFeeScheduleQueryVariables>;
export const CashAdvanceAppSettingsDocument = gql`
    query CashAdvanceAppSettings {
  appSettings {
    cashAdvanceMinimumAmount
    cashAdvanceMaximumAmount
    cashAdvanceMinimumMonthlyIncome
    cashAdvanceMonthlyFee
    cashAdvanceFirstMonthFee
    cashAdvanceMembershipCopy
    cashAdvanceAchTransferCopy
    cashAdvanceDeclineScreenCategory
  }
}
    `;

/**
 * __useCashAdvanceAppSettingsQuery__
 *
 * To run a query within a React component, call `useCashAdvanceAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashAdvanceAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashAdvanceAppSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCashAdvanceAppSettingsQuery(baseOptions?: Apollo.QueryHookOptions<CashAdvanceAppSettingsQuery, CashAdvanceAppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashAdvanceAppSettingsQuery, CashAdvanceAppSettingsQueryVariables>(CashAdvanceAppSettingsDocument, options);
      }
export function useCashAdvanceAppSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashAdvanceAppSettingsQuery, CashAdvanceAppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashAdvanceAppSettingsQuery, CashAdvanceAppSettingsQueryVariables>(CashAdvanceAppSettingsDocument, options);
        }
export function useCashAdvanceAppSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAdvanceAppSettingsQuery, CashAdvanceAppSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashAdvanceAppSettingsQuery, CashAdvanceAppSettingsQueryVariables>(CashAdvanceAppSettingsDocument, options);
        }
export type CashAdvanceAppSettingsQueryHookResult = ReturnType<typeof useCashAdvanceAppSettingsQuery>;
export type CashAdvanceAppSettingsLazyQueryHookResult = ReturnType<typeof useCashAdvanceAppSettingsLazyQuery>;
export type CashAdvanceAppSettingsSuspenseQueryHookResult = ReturnType<typeof useCashAdvanceAppSettingsSuspenseQuery>;
export type CashAdvanceAppSettingsQueryResult = Apollo.QueryResult<CashAdvanceAppSettingsQuery, CashAdvanceAppSettingsQueryVariables>;
export const CashAdvanceTransactionsDocument = gql`
    query CashAdvanceTransactions($first: Int, $after: String) {
  cashAdvanceTransactions(first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      ...TransactionFragment
    }
  }
}
    ${TransactionFragmentFragmentDoc}`;

/**
 * __useCashAdvanceTransactionsQuery__
 *
 * To run a query within a React component, call `useCashAdvanceTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashAdvanceTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashAdvanceTransactionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCashAdvanceTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<CashAdvanceTransactionsQuery, CashAdvanceTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashAdvanceTransactionsQuery, CashAdvanceTransactionsQueryVariables>(CashAdvanceTransactionsDocument, options);
      }
export function useCashAdvanceTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashAdvanceTransactionsQuery, CashAdvanceTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashAdvanceTransactionsQuery, CashAdvanceTransactionsQueryVariables>(CashAdvanceTransactionsDocument, options);
        }
export function useCashAdvanceTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAdvanceTransactionsQuery, CashAdvanceTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashAdvanceTransactionsQuery, CashAdvanceTransactionsQueryVariables>(CashAdvanceTransactionsDocument, options);
        }
export type CashAdvanceTransactionsQueryHookResult = ReturnType<typeof useCashAdvanceTransactionsQuery>;
export type CashAdvanceTransactionsLazyQueryHookResult = ReturnType<typeof useCashAdvanceTransactionsLazyQuery>;
export type CashAdvanceTransactionsSuspenseQueryHookResult = ReturnType<typeof useCashAdvanceTransactionsSuspenseQuery>;
export type CashAdvanceTransactionsQueryResult = Apollo.QueryResult<CashAdvanceTransactionsQuery, CashAdvanceTransactionsQueryVariables>;
export const PublicOffersForUrlDocument = gql`
    query PublicOffersForUrl($url: String!, $placementId: ID!) {
  publicOffersForUrl(url: $url, placementId: $placementId) {
    nodes {
      ... on Deal {
        ...DealFragment
      }
    }
  }
}
    ${DealFragmentFragmentDoc}`;

/**
 * __usePublicOffersForUrlQuery__
 *
 * To run a query within a React component, call `usePublicOffersForUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicOffersForUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicOffersForUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      placementId: // value for 'placementId'
 *   },
 * });
 */
export function usePublicOffersForUrlQuery(baseOptions: Apollo.QueryHookOptions<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables> & ({ variables: PublicOffersForUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables>(PublicOffersForUrlDocument, options);
      }
export function usePublicOffersForUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables>(PublicOffersForUrlDocument, options);
        }
export function usePublicOffersForUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables>(PublicOffersForUrlDocument, options);
        }
export type PublicOffersForUrlQueryHookResult = ReturnType<typeof usePublicOffersForUrlQuery>;
export type PublicOffersForUrlLazyQueryHookResult = ReturnType<typeof usePublicOffersForUrlLazyQuery>;
export type PublicOffersForUrlSuspenseQueryHookResult = ReturnType<typeof usePublicOffersForUrlSuspenseQuery>;
export type PublicOffersForUrlQueryResult = Apollo.QueryResult<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables>;
export const FindPartnerOfferCategoryByIdDocument = gql`
    query FindPartnerOfferCategoryById($categoryId: ID!, $placementId: ID!, $after: String, $before: String, $first: Int, $last: Int) {
  findPartnerOfferCategoryById(id: $categoryId, placementId: $placementId) {
    ...PartnerOfferCategoryFragment
    myFullPartnerOffers1(after: $after, before: $before, first: $first, last: $last) {
      nodes {
        ...PartnerOfferUnionFragment
      }
    }
  }
}
    ${PartnerOfferCategoryFragmentFragmentDoc}
${PartnerOfferUnionFragmentFragmentDoc}`;

/**
 * __useFindPartnerOfferCategoryByIdQuery__
 *
 * To run a query within a React component, call `useFindPartnerOfferCategoryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPartnerOfferCategoryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPartnerOfferCategoryByIdQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      placementId: // value for 'placementId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useFindPartnerOfferCategoryByIdQuery(baseOptions: Apollo.QueryHookOptions<FindPartnerOfferCategoryByIdQuery, FindPartnerOfferCategoryByIdQueryVariables> & ({ variables: FindPartnerOfferCategoryByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPartnerOfferCategoryByIdQuery, FindPartnerOfferCategoryByIdQueryVariables>(FindPartnerOfferCategoryByIdDocument, options);
      }
export function useFindPartnerOfferCategoryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPartnerOfferCategoryByIdQuery, FindPartnerOfferCategoryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPartnerOfferCategoryByIdQuery, FindPartnerOfferCategoryByIdQueryVariables>(FindPartnerOfferCategoryByIdDocument, options);
        }
export function useFindPartnerOfferCategoryByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindPartnerOfferCategoryByIdQuery, FindPartnerOfferCategoryByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindPartnerOfferCategoryByIdQuery, FindPartnerOfferCategoryByIdQueryVariables>(FindPartnerOfferCategoryByIdDocument, options);
        }
export type FindPartnerOfferCategoryByIdQueryHookResult = ReturnType<typeof useFindPartnerOfferCategoryByIdQuery>;
export type FindPartnerOfferCategoryByIdLazyQueryHookResult = ReturnType<typeof useFindPartnerOfferCategoryByIdLazyQuery>;
export type FindPartnerOfferCategoryByIdSuspenseQueryHookResult = ReturnType<typeof useFindPartnerOfferCategoryByIdSuspenseQuery>;
export type FindPartnerOfferCategoryByIdQueryResult = Apollo.QueryResult<FindPartnerOfferCategoryByIdQuery, FindPartnerOfferCategoryByIdQueryVariables>;
export const PartnerOfferPlacementByIdOffersDocument = gql`
    query PartnerOfferPlacementByIdOffers($placementId: ID!, $partnerOfferId: ID, $userId: ID, $after: String, $before: String, $first: Int, $last: Int) {
  publicOffersForPlacement(
    placementId: $placementId
    partnerOfferId: $partnerOfferId
    userId: $userId
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    nodes {
      ... on Deal {
        ...DealFragment
      }
    }
  }
}
    ${DealFragmentFragmentDoc}`;

/**
 * __usePartnerOfferPlacementByIdOffersQuery__
 *
 * To run a query within a React component, call `usePartnerOfferPlacementByIdOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerOfferPlacementByIdOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerOfferPlacementByIdOffersQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *      partnerOfferId: // value for 'partnerOfferId'
 *      userId: // value for 'userId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function usePartnerOfferPlacementByIdOffersQuery(baseOptions: Apollo.QueryHookOptions<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables> & ({ variables: PartnerOfferPlacementByIdOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables>(PartnerOfferPlacementByIdOffersDocument, options);
      }
export function usePartnerOfferPlacementByIdOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables>(PartnerOfferPlacementByIdOffersDocument, options);
        }
export function usePartnerOfferPlacementByIdOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables>(PartnerOfferPlacementByIdOffersDocument, options);
        }
export type PartnerOfferPlacementByIdOffersQueryHookResult = ReturnType<typeof usePartnerOfferPlacementByIdOffersQuery>;
export type PartnerOfferPlacementByIdOffersLazyQueryHookResult = ReturnType<typeof usePartnerOfferPlacementByIdOffersLazyQuery>;
export type PartnerOfferPlacementByIdOffersSuspenseQueryHookResult = ReturnType<typeof usePartnerOfferPlacementByIdOffersSuspenseQuery>;
export type PartnerOfferPlacementByIdOffersQueryResult = Apollo.QueryResult<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables>;
export const PublicOffersForPlacementDocument = gql`
    query PublicOffersForPlacement($placementId: ID!, $partnerOfferId: ID, $userId: ID) {
  publicOffersForPlacement(
    placementId: $placementId
    partnerOfferId: $partnerOfferId
    userId: $userId
  ) {
    nodes {
      ... on Deal {
        ...DealFragment
      }
    }
  }
}
    ${DealFragmentFragmentDoc}`;

/**
 * __usePublicOffersForPlacementQuery__
 *
 * To run a query within a React component, call `usePublicOffersForPlacementQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicOffersForPlacementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicOffersForPlacementQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *      partnerOfferId: // value for 'partnerOfferId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePublicOffersForPlacementQuery(baseOptions: Apollo.QueryHookOptions<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables> & ({ variables: PublicOffersForPlacementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables>(PublicOffersForPlacementDocument, options);
      }
export function usePublicOffersForPlacementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables>(PublicOffersForPlacementDocument, options);
        }
export function usePublicOffersForPlacementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables>(PublicOffersForPlacementDocument, options);
        }
export type PublicOffersForPlacementQueryHookResult = ReturnType<typeof usePublicOffersForPlacementQuery>;
export type PublicOffersForPlacementLazyQueryHookResult = ReturnType<typeof usePublicOffersForPlacementLazyQuery>;
export type PublicOffersForPlacementSuspenseQueryHookResult = ReturnType<typeof usePublicOffersForPlacementSuspenseQuery>;
export type PublicOffersForPlacementQueryResult = Apollo.QueryResult<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables>;
export const PublicOffersForPlacementPartnerLinksDocument = gql`
    query PublicOffersForPlacementPartnerLinks($placementId: ID!, $partnerOfferId: ID, $userId: ID) {
  publicOffersForPlacement(
    placementId: $placementId
    partnerOfferId: $partnerOfferId
    userId: $userId
  ) {
    nodes {
      ... on Deal {
        ctaUrl
        partner {
          name
        }
      }
    }
  }
}
    `;

/**
 * __usePublicOffersForPlacementPartnerLinksQuery__
 *
 * To run a query within a React component, call `usePublicOffersForPlacementPartnerLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicOffersForPlacementPartnerLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicOffersForPlacementPartnerLinksQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *      partnerOfferId: // value for 'partnerOfferId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePublicOffersForPlacementPartnerLinksQuery(baseOptions: Apollo.QueryHookOptions<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables> & ({ variables: PublicOffersForPlacementPartnerLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables>(PublicOffersForPlacementPartnerLinksDocument, options);
      }
export function usePublicOffersForPlacementPartnerLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables>(PublicOffersForPlacementPartnerLinksDocument, options);
        }
export function usePublicOffersForPlacementPartnerLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables>(PublicOffersForPlacementPartnerLinksDocument, options);
        }
export type PublicOffersForPlacementPartnerLinksQueryHookResult = ReturnType<typeof usePublicOffersForPlacementPartnerLinksQuery>;
export type PublicOffersForPlacementPartnerLinksLazyQueryHookResult = ReturnType<typeof usePublicOffersForPlacementPartnerLinksLazyQuery>;
export type PublicOffersForPlacementPartnerLinksSuspenseQueryHookResult = ReturnType<typeof usePublicOffersForPlacementPartnerLinksSuspenseQuery>;
export type PublicOffersForPlacementPartnerLinksQueryResult = Apollo.QueryResult<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables>;
export const OffersForPlacementDocument = gql`
    query OffersForPlacement($placementId: ID!, $after: String, $first: Int) {
  offersForPlacement(placementId: $placementId, after: $after, first: $first) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      ... on Survey {
        ...SurveyFragment
      }
    }
  }
}
    ${SurveyFragmentFragmentDoc}`;

/**
 * __useOffersForPlacementQuery__
 *
 * To run a query within a React component, call `useOffersForPlacementQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffersForPlacementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersForPlacementQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useOffersForPlacementQuery(baseOptions: Apollo.QueryHookOptions<OffersForPlacementQuery, OffersForPlacementQueryVariables> & ({ variables: OffersForPlacementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffersForPlacementQuery, OffersForPlacementQueryVariables>(OffersForPlacementDocument, options);
      }
export function useOffersForPlacementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffersForPlacementQuery, OffersForPlacementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffersForPlacementQuery, OffersForPlacementQueryVariables>(OffersForPlacementDocument, options);
        }
export function useOffersForPlacementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OffersForPlacementQuery, OffersForPlacementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OffersForPlacementQuery, OffersForPlacementQueryVariables>(OffersForPlacementDocument, options);
        }
export type OffersForPlacementQueryHookResult = ReturnType<typeof useOffersForPlacementQuery>;
export type OffersForPlacementLazyQueryHookResult = ReturnType<typeof useOffersForPlacementLazyQuery>;
export type OffersForPlacementSuspenseQueryHookResult = ReturnType<typeof useOffersForPlacementSuspenseQuery>;
export type OffersForPlacementQueryResult = Apollo.QueryResult<OffersForPlacementQuery, OffersForPlacementQueryVariables>;
export const MorePortalCategoriesDocument = gql`
    query MorePortalCategories($categoriesFirst: Int, $categoriesAfter: String, $offersFirst: Int) {
  user {
    id
    myCategories(first: $categoriesFirst, after: $categoriesAfter) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...UserOfferCategoryFragment
      }
    }
  }
}
    ${UserOfferCategoryFragmentFragmentDoc}`;

/**
 * __useMorePortalCategoriesQuery__
 *
 * To run a query within a React component, call `useMorePortalCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMorePortalCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMorePortalCategoriesQuery({
 *   variables: {
 *      categoriesFirst: // value for 'categoriesFirst'
 *      categoriesAfter: // value for 'categoriesAfter'
 *      offersFirst: // value for 'offersFirst'
 *   },
 * });
 */
export function useMorePortalCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<MorePortalCategoriesQuery, MorePortalCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MorePortalCategoriesQuery, MorePortalCategoriesQueryVariables>(MorePortalCategoriesDocument, options);
      }
export function useMorePortalCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MorePortalCategoriesQuery, MorePortalCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MorePortalCategoriesQuery, MorePortalCategoriesQueryVariables>(MorePortalCategoriesDocument, options);
        }
export function useMorePortalCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MorePortalCategoriesQuery, MorePortalCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MorePortalCategoriesQuery, MorePortalCategoriesQueryVariables>(MorePortalCategoriesDocument, options);
        }
export type MorePortalCategoriesQueryHookResult = ReturnType<typeof useMorePortalCategoriesQuery>;
export type MorePortalCategoriesLazyQueryHookResult = ReturnType<typeof useMorePortalCategoriesLazyQuery>;
export type MorePortalCategoriesSuspenseQueryHookResult = ReturnType<typeof useMorePortalCategoriesSuspenseQuery>;
export type MorePortalCategoriesQueryResult = Apollo.QueryResult<MorePortalCategoriesQuery, MorePortalCategoriesQueryVariables>;
export const PaymentAccountChangeAllowedDocument = gql`
    query PaymentAccountChangeAllowed($transferMethod: PaymentAccountTransferMethod!) {
  paymentAccountChangeAllowed(transferMethod: $transferMethod)
}
    `;

/**
 * __usePaymentAccountChangeAllowedQuery__
 *
 * To run a query within a React component, call `usePaymentAccountChangeAllowedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentAccountChangeAllowedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentAccountChangeAllowedQuery({
 *   variables: {
 *      transferMethod: // value for 'transferMethod'
 *   },
 * });
 */
export function usePaymentAccountChangeAllowedQuery(baseOptions: Apollo.QueryHookOptions<PaymentAccountChangeAllowedQuery, PaymentAccountChangeAllowedQueryVariables> & ({ variables: PaymentAccountChangeAllowedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentAccountChangeAllowedQuery, PaymentAccountChangeAllowedQueryVariables>(PaymentAccountChangeAllowedDocument, options);
      }
export function usePaymentAccountChangeAllowedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentAccountChangeAllowedQuery, PaymentAccountChangeAllowedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentAccountChangeAllowedQuery, PaymentAccountChangeAllowedQueryVariables>(PaymentAccountChangeAllowedDocument, options);
        }
export function usePaymentAccountChangeAllowedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentAccountChangeAllowedQuery, PaymentAccountChangeAllowedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentAccountChangeAllowedQuery, PaymentAccountChangeAllowedQueryVariables>(PaymentAccountChangeAllowedDocument, options);
        }
export type PaymentAccountChangeAllowedQueryHookResult = ReturnType<typeof usePaymentAccountChangeAllowedQuery>;
export type PaymentAccountChangeAllowedLazyQueryHookResult = ReturnType<typeof usePaymentAccountChangeAllowedLazyQuery>;
export type PaymentAccountChangeAllowedSuspenseQueryHookResult = ReturnType<typeof usePaymentAccountChangeAllowedSuspenseQuery>;
export type PaymentAccountChangeAllowedQueryResult = Apollo.QueryResult<PaymentAccountChangeAllowedQuery, PaymentAccountChangeAllowedQueryVariables>;
export const ReferralDocument = gql`
    query Referral {
  referral {
    ...ReferralFragment
  }
}
    ${ReferralFragmentFragmentDoc}`;

/**
 * __useReferralQuery__
 *
 * To run a query within a React component, call `useReferralQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferralQuery(baseOptions?: Apollo.QueryHookOptions<ReferralQuery, ReferralQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferralQuery, ReferralQueryVariables>(ReferralDocument, options);
      }
export function useReferralLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferralQuery, ReferralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferralQuery, ReferralQueryVariables>(ReferralDocument, options);
        }
export function useReferralSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferralQuery, ReferralQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReferralQuery, ReferralQueryVariables>(ReferralDocument, options);
        }
export type ReferralQueryHookResult = ReturnType<typeof useReferralQuery>;
export type ReferralLazyQueryHookResult = ReturnType<typeof useReferralLazyQuery>;
export type ReferralSuspenseQueryHookResult = ReturnType<typeof useReferralSuspenseQuery>;
export type ReferralQueryResult = Apollo.QueryResult<ReferralQuery, ReferralQueryVariables>;
export const SubscriptionsDocument = gql`
    query Subscriptions($active: Boolean) {
  subscriptions(active: $active) {
    ...SubscriptionFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}`;

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
      }
export function useSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
export function useSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
export type SubscriptionsQueryHookResult = ReturnType<typeof useSubscriptionsQuery>;
export type SubscriptionsLazyQueryHookResult = ReturnType<typeof useSubscriptionsLazyQuery>;
export type SubscriptionsSuspenseQueryHookResult = ReturnType<typeof useSubscriptionsSuspenseQuery>;
export type SubscriptionsQueryResult = Apollo.QueryResult<SubscriptionsQuery, SubscriptionsQueryVariables>;
export const SubscriptionFeesOutstandingDocument = gql`
    query SubscriptionFeesOutstanding {
  subscriptionFeesOutstanding {
    ...SubscriptionFeeFragment
  }
}
    ${SubscriptionFeeFragmentFragmentDoc}`;

/**
 * __useSubscriptionFeesOutstandingQuery__
 *
 * To run a query within a React component, call `useSubscriptionFeesOutstandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionFeesOutstandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionFeesOutstandingQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionFeesOutstandingQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionFeesOutstandingQuery, SubscriptionFeesOutstandingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionFeesOutstandingQuery, SubscriptionFeesOutstandingQueryVariables>(SubscriptionFeesOutstandingDocument, options);
      }
export function useSubscriptionFeesOutstandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionFeesOutstandingQuery, SubscriptionFeesOutstandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionFeesOutstandingQuery, SubscriptionFeesOutstandingQueryVariables>(SubscriptionFeesOutstandingDocument, options);
        }
export function useSubscriptionFeesOutstandingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionFeesOutstandingQuery, SubscriptionFeesOutstandingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionFeesOutstandingQuery, SubscriptionFeesOutstandingQueryVariables>(SubscriptionFeesOutstandingDocument, options);
        }
export type SubscriptionFeesOutstandingQueryHookResult = ReturnType<typeof useSubscriptionFeesOutstandingQuery>;
export type SubscriptionFeesOutstandingLazyQueryHookResult = ReturnType<typeof useSubscriptionFeesOutstandingLazyQuery>;
export type SubscriptionFeesOutstandingSuspenseQueryHookResult = ReturnType<typeof useSubscriptionFeesOutstandingSuspenseQuery>;
export type SubscriptionFeesOutstandingQueryResult = Apollo.QueryResult<SubscriptionFeesOutstandingQuery, SubscriptionFeesOutstandingQueryVariables>;
export const KeepAccessSubscriptionAllowedDocument = gql`
    query KeepAccessSubscriptionAllowed($subscriptionId: ID!, $code: String!) {
  keepAccessSubscriptionAllowed(subscriptionId: $subscriptionId, code: $code)
}
    `;

/**
 * __useKeepAccessSubscriptionAllowedQuery__
 *
 * To run a query within a React component, call `useKeepAccessSubscriptionAllowedQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeepAccessSubscriptionAllowedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeepAccessSubscriptionAllowedQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useKeepAccessSubscriptionAllowedQuery(baseOptions: Apollo.QueryHookOptions<KeepAccessSubscriptionAllowedQuery, KeepAccessSubscriptionAllowedQueryVariables> & ({ variables: KeepAccessSubscriptionAllowedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeepAccessSubscriptionAllowedQuery, KeepAccessSubscriptionAllowedQueryVariables>(KeepAccessSubscriptionAllowedDocument, options);
      }
export function useKeepAccessSubscriptionAllowedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeepAccessSubscriptionAllowedQuery, KeepAccessSubscriptionAllowedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeepAccessSubscriptionAllowedQuery, KeepAccessSubscriptionAllowedQueryVariables>(KeepAccessSubscriptionAllowedDocument, options);
        }
export function useKeepAccessSubscriptionAllowedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KeepAccessSubscriptionAllowedQuery, KeepAccessSubscriptionAllowedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KeepAccessSubscriptionAllowedQuery, KeepAccessSubscriptionAllowedQueryVariables>(KeepAccessSubscriptionAllowedDocument, options);
        }
export type KeepAccessSubscriptionAllowedQueryHookResult = ReturnType<typeof useKeepAccessSubscriptionAllowedQuery>;
export type KeepAccessSubscriptionAllowedLazyQueryHookResult = ReturnType<typeof useKeepAccessSubscriptionAllowedLazyQuery>;
export type KeepAccessSubscriptionAllowedSuspenseQueryHookResult = ReturnType<typeof useKeepAccessSubscriptionAllowedSuspenseQuery>;
export type KeepAccessSubscriptionAllowedQueryResult = Apollo.QueryResult<KeepAccessSubscriptionAllowedQuery, KeepAccessSubscriptionAllowedQueryVariables>;
export const UserDocument = gql`
    query User($categoriesFirst: Int, $offersFirst: Int) {
  user {
    ...UserFragment
    myCategories(first: $categoriesFirst) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...UserOfferCategoryFragment
      }
    }
  }
}
    ${UserFragmentFragmentDoc}
${UserOfferCategoryFragmentFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      categoriesFirst: // value for 'categoriesFirst'
 *      offersFirst: // value for 'offersFirst'
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const AvailableFeaturesDocument = gql`
    query AvailableFeatures {
  availableFeatures {
    ...AvailableFeaturesFragment
  }
}
    ${AvailableFeaturesFragmentFragmentDoc}`;

/**
 * __useAvailableFeaturesQuery__
 *
 * To run a query within a React component, call `useAvailableFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>(AvailableFeaturesDocument, options);
      }
export function useAvailableFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>(AvailableFeaturesDocument, options);
        }
export function useAvailableFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>(AvailableFeaturesDocument, options);
        }
export type AvailableFeaturesQueryHookResult = ReturnType<typeof useAvailableFeaturesQuery>;
export type AvailableFeaturesLazyQueryHookResult = ReturnType<typeof useAvailableFeaturesLazyQuery>;
export type AvailableFeaturesSuspenseQueryHookResult = ReturnType<typeof useAvailableFeaturesSuspenseQuery>;
export type AvailableFeaturesQueryResult = Apollo.QueryResult<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>;
export const CurrentUserIdentityDocument = gql`
    query CurrentUserIdentity {
  user {
    id
  }
}
    `;

/**
 * __useCurrentUserIdentityQuery__
 *
 * To run a query within a React component, call `useCurrentUserIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserIdentityQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserIdentityQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserIdentityQuery, CurrentUserIdentityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserIdentityQuery, CurrentUserIdentityQueryVariables>(CurrentUserIdentityDocument, options);
      }
export function useCurrentUserIdentityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserIdentityQuery, CurrentUserIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserIdentityQuery, CurrentUserIdentityQueryVariables>(CurrentUserIdentityDocument, options);
        }
export function useCurrentUserIdentitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserIdentityQuery, CurrentUserIdentityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserIdentityQuery, CurrentUserIdentityQueryVariables>(CurrentUserIdentityDocument, options);
        }
export type CurrentUserIdentityQueryHookResult = ReturnType<typeof useCurrentUserIdentityQuery>;
export type CurrentUserIdentityLazyQueryHookResult = ReturnType<typeof useCurrentUserIdentityLazyQuery>;
export type CurrentUserIdentitySuspenseQueryHookResult = ReturnType<typeof useCurrentUserIdentitySuspenseQuery>;
export type CurrentUserIdentityQueryResult = Apollo.QueryResult<CurrentUserIdentityQuery, CurrentUserIdentityQueryVariables>;
export const CheckIdentifierDocument = gql`
    query CheckIdentifier($email: String, $phone: Phone) {
  checkIdentifier(email: $email, phone: $phone) {
    action
    message
  }
}
    `;

/**
 * __useCheckIdentifierQuery__
 *
 * To run a query within a React component, call `useCheckIdentifierQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIdentifierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIdentifierQuery({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCheckIdentifierQuery(baseOptions?: Apollo.QueryHookOptions<CheckIdentifierQuery, CheckIdentifierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIdentifierQuery, CheckIdentifierQueryVariables>(CheckIdentifierDocument, options);
      }
export function useCheckIdentifierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIdentifierQuery, CheckIdentifierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIdentifierQuery, CheckIdentifierQueryVariables>(CheckIdentifierDocument, options);
        }
export function useCheckIdentifierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckIdentifierQuery, CheckIdentifierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckIdentifierQuery, CheckIdentifierQueryVariables>(CheckIdentifierDocument, options);
        }
export type CheckIdentifierQueryHookResult = ReturnType<typeof useCheckIdentifierQuery>;
export type CheckIdentifierLazyQueryHookResult = ReturnType<typeof useCheckIdentifierLazyQuery>;
export type CheckIdentifierSuspenseQueryHookResult = ReturnType<typeof useCheckIdentifierSuspenseQuery>;
export type CheckIdentifierQueryResult = Apollo.QueryResult<CheckIdentifierQuery, CheckIdentifierQueryVariables>;
export const RecentTransactionsDocument = gql`
    query RecentTransactions($first: Int, $after: String) {
  recentTransactions(first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      ...TransactionFragment
    }
  }
}
    ${TransactionFragmentFragmentDoc}`;

/**
 * __useRecentTransactionsQuery__
 *
 * To run a query within a React component, call `useRecentTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentTransactionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRecentTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<RecentTransactionsQuery, RecentTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentTransactionsQuery, RecentTransactionsQueryVariables>(RecentTransactionsDocument, options);
      }
export function useRecentTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentTransactionsQuery, RecentTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentTransactionsQuery, RecentTransactionsQueryVariables>(RecentTransactionsDocument, options);
        }
export function useRecentTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentTransactionsQuery, RecentTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentTransactionsQuery, RecentTransactionsQueryVariables>(RecentTransactionsDocument, options);
        }
export type RecentTransactionsQueryHookResult = ReturnType<typeof useRecentTransactionsQuery>;
export type RecentTransactionsLazyQueryHookResult = ReturnType<typeof useRecentTransactionsLazyQuery>;
export type RecentTransactionsSuspenseQueryHookResult = ReturnType<typeof useRecentTransactionsSuspenseQuery>;
export type RecentTransactionsQueryResult = Apollo.QueryResult<RecentTransactionsQuery, RecentTransactionsQueryVariables>;
export const WithdrawalCapabilityDocument = gql`
    query WithdrawalCapability {
  withdrawalCapability {
    ...WithdrawalCapabilityFragment
  }
}
    ${WithdrawalCapabilityFragmentFragmentDoc}`;

/**
 * __useWithdrawalCapabilityQuery__
 *
 * To run a query within a React component, call `useWithdrawalCapabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithdrawalCapabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithdrawalCapabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useWithdrawalCapabilityQuery(baseOptions?: Apollo.QueryHookOptions<WithdrawalCapabilityQuery, WithdrawalCapabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WithdrawalCapabilityQuery, WithdrawalCapabilityQueryVariables>(WithdrawalCapabilityDocument, options);
      }
export function useWithdrawalCapabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WithdrawalCapabilityQuery, WithdrawalCapabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WithdrawalCapabilityQuery, WithdrawalCapabilityQueryVariables>(WithdrawalCapabilityDocument, options);
        }
export function useWithdrawalCapabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WithdrawalCapabilityQuery, WithdrawalCapabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WithdrawalCapabilityQuery, WithdrawalCapabilityQueryVariables>(WithdrawalCapabilityDocument, options);
        }
export type WithdrawalCapabilityQueryHookResult = ReturnType<typeof useWithdrawalCapabilityQuery>;
export type WithdrawalCapabilityLazyQueryHookResult = ReturnType<typeof useWithdrawalCapabilityLazyQuery>;
export type WithdrawalCapabilitySuspenseQueryHookResult = ReturnType<typeof useWithdrawalCapabilitySuspenseQuery>;
export type WithdrawalCapabilityQueryResult = Apollo.QueryResult<WithdrawalCapabilityQuery, WithdrawalCapabilityQueryVariables>;
export const WithdrawalFeeQuotesDocument = gql`
    query WithdrawalFeeQuotes($amount: Float!) {
  withdrawalFeeQuotes(amount: $amount) {
    speed
    fee
    enabled
  }
}
    `;

/**
 * __useWithdrawalFeeQuotesQuery__
 *
 * To run a query within a React component, call `useWithdrawalFeeQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithdrawalFeeQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithdrawalFeeQuotesQuery({
 *   variables: {
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useWithdrawalFeeQuotesQuery(baseOptions: Apollo.QueryHookOptions<WithdrawalFeeQuotesQuery, WithdrawalFeeQuotesQueryVariables> & ({ variables: WithdrawalFeeQuotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WithdrawalFeeQuotesQuery, WithdrawalFeeQuotesQueryVariables>(WithdrawalFeeQuotesDocument, options);
      }
export function useWithdrawalFeeQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WithdrawalFeeQuotesQuery, WithdrawalFeeQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WithdrawalFeeQuotesQuery, WithdrawalFeeQuotesQueryVariables>(WithdrawalFeeQuotesDocument, options);
        }
export function useWithdrawalFeeQuotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WithdrawalFeeQuotesQuery, WithdrawalFeeQuotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WithdrawalFeeQuotesQuery, WithdrawalFeeQuotesQueryVariables>(WithdrawalFeeQuotesDocument, options);
        }
export type WithdrawalFeeQuotesQueryHookResult = ReturnType<typeof useWithdrawalFeeQuotesQuery>;
export type WithdrawalFeeQuotesLazyQueryHookResult = ReturnType<typeof useWithdrawalFeeQuotesLazyQuery>;
export type WithdrawalFeeQuotesSuspenseQueryHookResult = ReturnType<typeof useWithdrawalFeeQuotesSuspenseQuery>;
export type WithdrawalFeeQuotesQueryResult = Apollo.QueryResult<WithdrawalFeeQuotesQuery, WithdrawalFeeQuotesQueryVariables>;
export const PaymentAccountsDocument = gql`
    query PaymentAccounts($transferMethod: PaymentAccountTransferMethod, $includeUnlinked: Boolean) {
  paymentAccounts(
    transferMethod: $transferMethod
    includeUnlinked: $includeUnlinked
  ) {
    ...BankAccountFragment
  }
}
    ${BankAccountFragmentFragmentDoc}`;

/**
 * __usePaymentAccountsQuery__
 *
 * To run a query within a React component, call `usePaymentAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentAccountsQuery({
 *   variables: {
 *      transferMethod: // value for 'transferMethod'
 *      includeUnlinked: // value for 'includeUnlinked'
 *   },
 * });
 */
export function usePaymentAccountsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentAccountsQuery, PaymentAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentAccountsQuery, PaymentAccountsQueryVariables>(PaymentAccountsDocument, options);
      }
export function usePaymentAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentAccountsQuery, PaymentAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentAccountsQuery, PaymentAccountsQueryVariables>(PaymentAccountsDocument, options);
        }
export function usePaymentAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentAccountsQuery, PaymentAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentAccountsQuery, PaymentAccountsQueryVariables>(PaymentAccountsDocument, options);
        }
export type PaymentAccountsQueryHookResult = ReturnType<typeof usePaymentAccountsQuery>;
export type PaymentAccountsLazyQueryHookResult = ReturnType<typeof usePaymentAccountsLazyQuery>;
export type PaymentAccountsSuspenseQueryHookResult = ReturnType<typeof usePaymentAccountsSuspenseQuery>;
export type PaymentAccountsQueryResult = Apollo.QueryResult<PaymentAccountsQuery, PaymentAccountsQueryVariables>;
export const WalletAppSettingsDocument = gql`
    query WalletAppSettings {
  appSettings {
    lifetimeEarningsInfoCopy
    availableBalanceInfoCopy
    pendingBalanceInfoCopy
  }
}
    `;

/**
 * __useWalletAppSettingsQuery__
 *
 * To run a query within a React component, call `useWalletAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletAppSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalletAppSettingsQuery(baseOptions?: Apollo.QueryHookOptions<WalletAppSettingsQuery, WalletAppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletAppSettingsQuery, WalletAppSettingsQueryVariables>(WalletAppSettingsDocument, options);
      }
export function useWalletAppSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletAppSettingsQuery, WalletAppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletAppSettingsQuery, WalletAppSettingsQueryVariables>(WalletAppSettingsDocument, options);
        }
export function useWalletAppSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WalletAppSettingsQuery, WalletAppSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletAppSettingsQuery, WalletAppSettingsQueryVariables>(WalletAppSettingsDocument, options);
        }
export type WalletAppSettingsQueryHookResult = ReturnType<typeof useWalletAppSettingsQuery>;
export type WalletAppSettingsLazyQueryHookResult = ReturnType<typeof useWalletAppSettingsLazyQuery>;
export type WalletAppSettingsSuspenseQueryHookResult = ReturnType<typeof useWalletAppSettingsSuspenseQuery>;
export type WalletAppSettingsQueryResult = Apollo.QueryResult<WalletAppSettingsQuery, WalletAppSettingsQueryVariables>;